/* eslint-disable max-len */
const translations = {
  invitationAcceptance: {
    pageTitle: 'Zaproszenia do placówek',
    stepLabel: 'Zaproszenie',
    loading: 'Ładowanie zaproszeń',
    organization: 'Placówka',
    pending: 'Oczekujące zaproszenia',
    counter: 'Zaproszenie {{current}} z {{total}}',
    accept: 'Dołączam do zespołu',
    reject: 'Odrzuć zaproszenie',
    eyebrow: 'Zaproszenie do zespołu',
    yourAccess: 'Twój dostęp',
    validUntil: 'Ważne do',
    validDays: 'Ważne jeszcze {{count}} dni',
    validDay: 'Ważne jeszcze 1 dzień',
    validHours: 'Ważne jeszcze {{count}} h',
    moreSpecializations: '+{{count}}',
    dashboard: 'Przejdź do panelu',
    retry: 'Spróbuj ponownie',
    empty: 'Brak oczekujących zaproszeń',
    emptyDescription: 'Nie masz nowych, ważnych zaproszeń do placówek.',
    loadError: 'Nie udało się pobrać zaproszeń. Spróbuj ponownie.',
    actionError: 'Nie udało się zapisać decyzji lub odświeżyć dostępu. Spróbuj ponownie.',
    roles: {
      owner: {
        label: 'Właściciel',
        description: 'Pełna kontrola nad placówką',
        perks: { 0: 'Zespół, role i uprawnienia', 1: 'Ustawienia i usługi placówki', 2: 'Statystyki całej placówki' },
      },
      admin: {
        label: 'Administrator',
        description: 'Zarządzanie placówką na co dzień',
        perks: { 0: 'Kalendarz i grafik placówki', 1: 'Zespół i zaproszenia', 2: 'Usługi, ustawienia i statystyki' },
      },
      professional: {
        label: 'Specjalista',
        description: 'Praca z pacjentami',
        perks: { 0: 'Wizyty i poczekalnia', 1: 'Karty pacjentów i dokumentacja', 2: 'Twój grafik i kalendarz wizyt' },
      },
      other: {
        label: 'Dostęp do placówki',
        description: 'Uprawnienia przydzielone przez administratora',
        perks: {},
      },
    },
  },
  authFlow: {
    resetPassword: {
      title: 'Odzyskaj dostęp',
      line1: 'Wróć do',
      line2: 'swojego konta.',
    },
    requestSent: {
      title: 'Sprawdź skrzynkę odbiorczą',
      line1: 'Zajrzyj',
      line2: 'do skrzynki.',
    },
    newPassword: {
      title: 'Ustaw nowe hasło',
      line1: 'Nowe hasło.',
      line2: 'Wracasz do Vetsi.',
    },
    confirmation: {
      title: 'Potwierdź swój adres e-mail',
      line1: 'Jeszcze krok',
      line2: 'i jesteś z nami.',
    },
    verified: {
      title: 'Adres e-mail potwierdzony',
      line1: 'Gotowe.',
      line2: 'Możesz wracać.',
    },
    verificationError: {
      title: 'Nie udało się potwierdzić adresu e-mail',
      line1: 'Spróbujmy',
      line2: 'jeszcze raz.',
    },
    phoneLogin: {
      title: 'Zaloguj się numerem telefonu',
      line1: 'Twój telefon.',
      line2: 'Twój dostęp.',
    },
    acceptTerms: {
      title: 'Aktualizacja dokumentów',
      line1: 'Zasady wspólnego',
      line2: 'działania.',
    },
    accountClosed: {
      title: 'Konto zostało zamknięte',
      line1: 'Dziękujemy',
      line2: 'za wspólny czas.',
    },
    pendingDeletion: {
      title: 'Konto oczekuje na usunięcie',
      line1: 'Informacja',
      line2: 'o Twoim koncie.',
    },
    terms: {
      title: 'Regulamin Vetsi',
      line1: 'Zasady',
      line2: 'w jednym miejscu.',
    },
    privacy: {
      title: 'Polityka prywatności',
      line1: 'Twoje dane.',
      line2: 'Jasne zasady.',
    },
  },
  ownerRegistration: {
    welcomeLine1: 'Tu zaczyna się',
    welcomeLine2: 'wspólna troska.',
    title: 'Załóż konto w Vetsi',
    description: 'Konto dla Ciebie i Twoich zwierząt.',
  },
  ownerLogin: {
    welcomeLine1: 'Miło was',
    welcomeLine2: 'widzieć.',
    title: 'Zaloguj się do Vetsi',
    description: 'Twoje konto opiekuna zwierząt.',
    professionalPrompt: 'Jesteś specjalistą weterynarii?',
    professionalLink: 'Przejdź do Vetsi Clinic',
  },
  professionalLogin: {
    welcomeLine1: 'Dobrze Cię',
    welcomeLine2: 'widzieć.',
    title: 'Zaloguj się do Vetsi Clinic',
    description: 'Dostęp dla lekarzy i zespołu placówki.',
    ownerPrompt: 'Jesteś opiekunem zwierzęcia?',
    ownerLink: 'Przejdź do logowania opiekuna',
  },
  professionalRegistration: {
    label: 'System dla placówek weterynaryjnych',
    title: 'Dołącz do',
    description:
      'Mniej formalności, więcej czasu dla pacjentów. Załóż konto i zarządzaj wizytami, dokumentacją medyczną oraz pracą zespołu w jednym miejscu.',
    formTitle: 'Utwórz konto',
    formDescription:
      'Podaj swoje dane. Profil i dane placówki uzupełnisz po zalogowaniu.',
    footer: {
      description: 'Kompletny system dla placówek weterynaryjnych.',
      companyName: 'Vetsi Sp. z o.o.',
      product: 'Produkt',
      company: 'Firma',
      legal: 'Prawne',
      assistant: 'Asystent Vetsi',
      phone: 'Asystent telefoniczny',
      booking: 'Strona i rezerwacje',
      system: 'System Vetsi Clinic',
      pricing: 'Cennik',
      migration: 'Wdrożenie',
      blog: 'Blog',
      contact: 'Kontakt',
      terms: 'Regulamin',
      privacy: 'Polityka prywatności',
      copyright:
        'Vetsi jest zarejestrowanym znakiem towarowym na terenie Unii Europejskiej. Wszystkie prawa zastrzeżone. Vetsi Clinic 2023-2026.',
    },
    navigation: {
      label: 'Nawigacja Vetsi Clinic',
      openMenu: 'Otwórz menu',
      closeMenu: 'Zamknij menu',
      howItWorks: 'Jak to działa',
      product: 'Produkt',
      menu: 'Menu',
      productBullets: {
        assistant: {
          first: 'Przeszukuje historię pacjenta za Ciebie',
          second: 'Analizuje wyniki, pliki oraz obrazy USG i RTG',
          third: 'Wykorzystuje transkrypcję przy przygotowaniu notatki',
          fourth: 'Łączy historię pacjenta z informacjami z bieżącej wizyty',
          fifth: 'Przygotowuje notatkę według Twojego szablonu',
          sixth: 'Ostateczna decyzja zawsze należy do Ciebie',
        },
        phone: {
          first: 'Działa 24/7, również poza godzinami placówki',
          second: 'Pomaga opiekunowi doprecyzować powód wizyty',
          third: 'Proponuje termin w grafiku właściwego specjalisty',
          fourth: 'Zapisuje wybraną wizytę w kalendarzu',
          fifth: 'Łączy opiekuna z recepcją, gdy sprawa wymaga człowieka',
          sixth: 'Nieodebrany telefon nie musi oznaczać utraconej wizyty',
        },
        booking: {
          first: 'Własna strona WWW',
          second: 'System rezerwacji wizyt w 2 krokach',
          third: 'Opiekun sam wybiera specjalistę i dogodny termin',
          fourth: 'Zespół od razu widzi szczegóły nowej rezerwacji',
          fifth: 'Potwierdzenie rezerwacji wysyłane SMS-em i e-mailem',
          sixth: 'Rezerwacje dostępne 24/7, także poza godzinami placówki',
        },
        system: {
          first: 'Kartoteka pacjentów i historia dokumentacji',
          second: 'Przypomnienia dla opiekunów przez SMS i e-mail',
          third: 'Kalendarz, poczekalnia i grafiki zespołu',
          fourth: 'Leki, zabiegi i szablony notatek',
          fifth: 'Płatności online i przedpłaty',
          sixth: 'Jeden system zamiast kilku osobnych narzędzi',
        },
      },
      pricing: 'Cennik',
      faq: 'FAQ',
      blog: 'Blog',
      signIn: 'Zaloguj się',
      bookDemo: 'Umów demo',
      assistant: 'Asystent Vetsi',
      assistantDescription:
        'Przygotowuje Cię do wizyty, wspiera podczas jej trwania i na koniec przygotowuje z niej notatkę.',
      phone: 'Asystent telefoniczny',
      phoneDescription:
        'Odbiera telefony i umawia wizyty, gdy zespół zajmuje się pacjentami.',
      booking: 'Rezerwacje online',
      bookingDescription:
        'Opiekun wybiera usługę, specjalistę i wolny termin bez angażowania zespołu.',
      system: 'System Vetsi Clinic',
      systemDescription:
        'Łączy codzienną pracę całej placówki w jednym systemie.',
    },
  },
  professionalStatistics: {
    total: 'Wszystkie moje wizyty',
    chartTitle: 'Jak zmienia się liczba moich wizyt?',
    servicesTitle: 'Jakie wizyty prowadzę?',
    servicesSubtitle: 'Moje ukończone wizyty według usługi',
    title: 'Moje statystyki',
    pageTitle: 'Moje statystyki | Vetsi',
    subtitle: 'Twój przegląd wizyt i pacjentów w wybranej placówce.',
    scopeDescription:
      'Raport obejmuje wyłącznie wizyty przypisane do Ciebie w wybranej placówce. Nie zawiera wyników innych specjalistów.',
    chooseClinic: 'Wybierz placówkę, aby zobaczyć statystyki.',
    patientsTitle: 'Czy pacjenci do Ciebie wracają?',
    patientsAnswer: 'Powracający do Ciebie to {{share}} pacjentów',
    patientsSubtitle: 'Zwierzęta z kartoteką i ukończoną wizytą u Ciebie',
    newPatients: 'pierwszy raz u Ciebie',
    returningPatients: 'powracających do Ciebie',
    patientDefinition:
      'Nowy pacjent ma pierwszą ukończoną wizytę u Ciebie w tej placówce w wybranym okresie. Może mieć wcześniejsze wizyty u innego specjalisty. To podział pacjentów, nie wskaźnik retencji.',
    patientsHint:
      'Nowy pacjent nie ma wcześniejszej ukończonej wizyty u Ciebie w wybranej placówce.',
    heatmapTitle: 'Kiedy przyjmujesz najwięcej pacjentów?',
  },
  statisticsOverview: {
    grouping: 'Grupowanie wizyt',
    chartGrouping: {
      day: 'Każdy słupek to jeden dzień, również bez wizyt.',
      week: 'Każdy słupek to tydzień lub jego część w wybranym okresie.',
      month: 'Każdy słupek to miesiąc lub jego część w wybranym okresie.',
    },
    tableLabels: {
      total: 'Wszystkie',
      completed: 'Ukończone',
      cancelled: 'Anulowane',
      other: 'Pozostałe',
    },
    patientDefinition:
      'Nowy pacjent ma pierwszą ukończoną wizytę w tej placówce w wybranym okresie. To podział pacjentów, nie wskaźnik retencji.',
    servicesTotal:
      'Łącznie: {{count}} ukończonych wizyt. Każdą wizytę liczymy raz.',
    heatmapLess: 'Mniej',
    heatmapMore: 'Więcej',
    specialistsSubtitle: 'Wszystkie wizyty z terminem w wybranym okresie',
    specialistsContext:
      'Liczba wizyt zależy od wymiaru pracy i rodzaju usług. Tabela nie jest rankingiem jakości opieki.',
    title: 'Przegląd placówki',
    pageTitle: 'Statystyki | Vetsi',
    howWeCount: 'Jak to liczymy?',
    subtitle:
      'Ile było wizyt, jak się zakończyły i kiedy przychodzi najwięcej pacjentów.',
    refresh: 'Odśwież',
    period: 'Okres',
    from: 'Od',
    to: 'Do',
    partial: 'Okres niepełny',
    calculatedAt: 'Obliczono',
    stale: 'Nie udało się odświeżyć danych. Pokazujemy ostatni poprawny wynik.',
    denied: 'Nie masz dostępu do statystyk tej placówki.',
    failed: 'Nie udało się pobrać statystyk.',
    invalidRange:
      'Nieprawidłowy zakres dat. Wybierz maksymalnie 366 dni, nie później niż dzisiaj.',
    retry: 'Spróbuj ponownie',
    chooseDates: 'Wybierz datę początku i końca okresu.',
    empty: 'W tym okresie nie ma wizyt.',
    total: 'Wszystkie wizyty',
    completed: 'Ukończone wizyty',
    cancelled: 'Anulowane wizyty',
    other: 'Pozostałe statusy',
    noChange: 'Bez zmian',
    more: 'więcej',
    fewer: 'mniej',
    vsPrevious: 'vs poprzedni okres',
    visits: 'wizyt',
    visitCount: 'Liczba wizyt',
    chartTitle: 'Jak zmienia się liczba wizyt?',
    chartSubtitle: 'Wszystkie statusy · według terminu rozpoczęcia wizyty',
    chartTotal: 'Suma słupków: {{count}} wizyt',
    day: 'Dzień',
    week: 'Tydzień',
    month: 'Miesiąc',
    patientsTitle: 'Czy pacjenci wracają?',
    patientsSubtitle: 'Zwierzęta z kartoteką i ukończoną wizytą',
    newPatients: 'nowych pacjentów',
    returningPatients: 'powracających pacjentów',
    identified: 'Pacjenci z kartoteką: {{count}}',
    unlinked: 'Ukończone wizyty bez kartoteki pacjenta: {{count}}',
    servicesTitle: 'Z czym przychodzą pacjenci?',
    servicesSubtitle: 'Liczba ukończonych wizyt w wybranym okresie',
    remainingServices: 'Pozostałe usługi',
    emptyServices: 'Brak ukończonych wizyt w wybranym okresie',
    missingService: 'Brak usługi lub usunięta usługa',
    heatmapTitle: 'Kiedy przyjmujecie najwięcej pacjentów?',
    heatmapSubtitle: 'Ukończone wizyty według dnia i godziny rozpoczęcia',
    fullDay: 'Pokaż całą dobę',
    lessHours: 'Pokaż typowe godziny',
    specialistsTitle: 'Ile wizyt ma każdy specjalista?',
    specialist: 'Specjalista',
    missingSpecialist: 'Brak specjalisty lub były pracownik',
    grandTotal: 'Łącznie',
    hints: {
      total:
        'Wizyty z terminem rozpoczęcia w wybranym okresie, bez usuniętych wizyt.',
      completed: 'Wizyty o obecnym statusie ukończone.',
      cancelled: 'Wizyty o obecnym statusie anulowane.',
      other: 'Pozostałe obecne statusy, w tym otwarte, odrzucone i przerwane.',
      chart: 'Liczba wszystkich wizyt według terminu rozpoczęcia.',
      patients:
        'Nowy pacjent nie ma wcześniejszej ukończonej wizyty w tej placówce.',
      services: 'Usługi są liczone wyłącznie dla ukończonych wizyt.',
      heatmap:
        'Ukończone wizyty według lokalnej godziny rozpoczęcia. Liczba wizyt nie oznacza obciążenia grafiku.',
      specialists:
        'Wszystkie wizyty według przypisanego specjalisty. Wiersz łączny dotyczy całego raportu.',
    },
    answers: {
      chart: 'Najwięcej wizyt: {{range}} ({{count}})',
      patients: 'Powracający to {{share}} pacjentów',
      services: 'Najczęściej: {{name}} ({{share}} ukończonych wizyt)',
      heatmap: 'Najwięcej: {{weekday}}, {{from}}-{{to}} ({{count}})',
    },
    weekdaysFull: {
      '1': 'poniedziałek',
      '2': 'wtorek',
      '3': 'środa',
      '4': 'czwartek',
      '5': 'piątek',
      '6': 'sobota',
      '7': 'niedziela',
    },
    weekdays: {
      '1': 'Pon',
      '2': 'Wt',
      '3': 'Śr',
      '4': 'Czw',
      '5': 'Pt',
      '6': 'Sob',
      '7': 'Ndz',
    },
    presets: {
      LAST_7_DAYS: 'Ostatnie 7 dni',
      LAST_30_DAYS: 'Ostatnie 30 dni',
      LAST_90_DAYS: 'Ostatnie 90 dni',
      LAST_365_DAYS: 'Ostatnie 365 dni',
      CURRENT_MONTH: 'Bieżący miesiąc',
      LAST_MONTH: 'Poprzedni miesiąc',
      CUSTOM: 'Własny zakres',
    },
  },
  nav: {
    waitingRoom: 'Poczekalnia',
    waitingRoomInProgress: 'Wizyta w trakcie',
    calendar: 'Kalendarz',
    patients: 'Pacjenci',
    treatments: 'Zabiegi',
    visitHistory: 'Historia wizyt',
    templates: 'Szablony',
    specialists: 'Specjaliści',
    statistics: 'Statystyki',
    myStatistics: 'Moje statystyki',
    organizations: 'Organizacje',
    myPets: 'Moje zwierzaki',
    bookVisit: 'Umów wizytę',
    upcomingVisits: 'Nadchodzące wizyty',
    products: 'Produkty',
    supplementsAndTreats: 'Suplementy i przysmaki',
    insurance: 'Ubezpieczenie',
    voiceReception: 'Recepcja głosowa',
    warehouse: 'Magazyn',
    webinars: 'Webinary',
  },
  voiceReceptionist: {
    common: {
      save: 'Zapisz zmiany',
      cancel: 'Anuluj',
      close: 'Zamknij',
      retry: 'Ponów',
      loading: 'Ładowanie…',
      loadError: 'Nie udało się pobrać danych recepcji głosowej.',
      actionError: 'Nie udało się wykonać działania. Spróbuj ponownie.',
      saved: 'Zmiany zostały zapisane.',
      notAvailable: 'Brak danych',
    },
    dashboard: {
      title: 'Recepcja głosowa',
      description:
        'Ustaw powitanie i usługi oraz sprawdzaj historię połączeń placówki.',
      tabsLabel: 'Sekcje recepcji głosowej',
      tabs: {
        settings: 'Ustawienia',
        history: 'Historia połączeń',
      },
      notConfigured:
        'Recepcja głosowa nie została jeszcze uruchomiona dla tej placówki. Skontaktuj się z zespołem Vetsi.',
    },
    status: {
      title: 'Stan recepcji głosowej',
      assignedNumber: 'Numer recepcji',
      humanFallbackNumber: 'Numer przekazania do zespołu',
      updatedAt: 'Ostatnia aktualizacja: {{date}}',
      state: {
        DISABLED: 'Wyłączona',
        TRANSFERRED: 'Przeniesiona',
        TRANSFERRING: 'Przenoszenie',
        DISABLING: 'Wyłączanie',
        PROVISIONING: 'Uruchamianie',
        ACTIVE: 'Aktywna',
        FAILED: 'Wymaga uwagi',
      },
      readiness: {
        UNAVAILABLE: 'Niedostępna',
        HUMAN_FALLBACK: 'Połączenia kierowane do zespołu',
        READY: 'Gotowa',
      },
    },
    settings: {
      title: 'Ustawienia rozmowy',
      description:
        'Powitanie i wybrane usługi są używane podczas nowych rozmów.',
      welcomeMessage: 'Powitanie',
      welcomeMessageHint: 'Maksymalnie 500 znaków.',
      services: 'Usługi dostępne przez telefon',
      servicesPlaceholder: 'Wybierz usługi',
      servicesEmpty: 'Placówka nie ma aktywnych usług do wyboru.',
      escalationTitle: 'Przekazanie do zespołu',
      escalationDescription:
        'Na ten numer recepcja przekaże rozmowę, gdy potrzebna będzie pomoc człowieka.',
      escalationNumber: 'Numer telefonu zespołu',
      conflict:
        'Ustawienia zmieniły się w innym oknie. Odświeżyliśmy dane. Sprawdź je i zapisz ponownie.',
    },
    history: {
      title: 'Historia połączeń',
      description:
        'Otwórz połączenie, aby zobaczyć jego szczegóły i dostępny zapis rozmowy.',
      tableLabel: 'Lista połączeń recepcji głosowej',
      startedAt: 'Rozpoczęcie',
      caller: 'Dzwoniący',
      service: 'Usługa',
      status: 'Stan',
      outcome: 'Zakończenie',
      booking: 'Rezerwacja',
      transfer: 'Przekazanie',
      callback: 'Oddzwonienie',
      duration: 'Czas trwania',
      actions: 'Działania',
      open: 'Otwórz szczegóły połączenia',
      empty: 'Nie zarejestrowano jeszcze żadnych połączeń.',
      loadError: 'Nie udało się pobrać historii połączeń.',
      state: {
        ACTIVE: 'W toku',
        FINISHED: 'Zakończone',
      },
      outcomeValue: {
        COMPLETED: 'Zakończone poprawnie',
        CALLER_HANGUP: 'Rozmówca zakończył połączenie',
        TRANSFERRED: 'Przekazane do zespołu',
        TRANSFERRED_UNVERIFIED: 'Przekazanie niepotwierdzone',
        TRANSFER_FAILED: 'Nie udało się przekazać',
        TECHNICAL_FAILURE: 'Błąd techniczny',
        LEASE_LOST: 'Połączenie przerwane',
        DURATION_LIMIT: 'Osiągnięto limit czasu',
        WORKER_SHUTDOWN: 'Połączenie zakończone',
      },
      bookingValue: {
        SUBMITTING: 'Zapisywanie',
        BOOKED: 'Wizyta umówiona',
        SLOT_TAKEN: 'Termin niedostępny',
        IN_PROGRESS: 'Trwa sprawdzanie',
        UNCERTAIN: 'Wymaga sprawdzenia',
        REJECTED: 'Nie umówiono wizyty',
        HANDOFF_REQUIRED: 'Wymaga działania zespołu',
      },
      callbackStatus: {
        RECORDED: 'Zgłoszone',
        RESOLVED: 'Zakończone',
      },
      callbackValue: {
        CALLER_CONTACTED: 'Skontaktowano się z rozmówcą',
        CONTACT_ATTEMPT_FAILED: 'Nie udało się skontaktować',
        NO_ACTION_REQUIRED: 'Nie wymaga działania',
      },
    },
    call: {
      title: 'Szczegóły połączenia',
      back: 'Wróć do historii połączeń',
      openedAt: 'Rozpoczęcie: {{date}}',
      finishedAt: 'Zakończenie: {{date}}',
      transcriptTitle: 'Zapis rozmowy',
      timelineTitle: 'Przebieg połączenia',
      caller: 'Rozmówca',
      receptionist: 'Recepcja głosowa',
      openVisit: 'Otwórz wizytę',
      timeline: {
        CALL_OPENED: 'Rozpoczęto połączenie',
        CALL_FINISHED: 'Zakończono połączenie',
        BOOKING_SUBMITTING: 'Trwa zapisywanie wizyty',
        BOOKING_BOOKED: 'Wizyta została zarezerwowana',
        BOOKING_SLOT_TAKEN: 'Wybrany termin nie był już dostępny',
        BOOKING_IN_PROGRESS: 'Trwa sprawdzanie rezerwacji',
        BOOKING_UNCERTAIN: 'Rezerwacja wymaga sprawdzenia',
        BOOKING_REJECTED: 'Nie udało się zarezerwować wizyty',
        BOOKING_HANDOFF_REQUIRED: 'Zespół musi dokończyć rezerwację',
        CALLBACK_RECORDED: 'Zapisano prośbę o oddzwonienie',
        CALLBACK_RESOLVED: 'Zakończono obsługę prośby o oddzwonienie',
        other: 'Zaktualizowano stan połączenia',
      },
      transcript: {
        AVAILABLE: 'Poniżej znajduje się nieedytowalny zapis rozmowy.',
        EMPTY: 'Ta rozmowa nie zawiera zapisanego tekstu.',
        EXPIRED: 'Okres przechowywania zapisu tej rozmowy zakończył się.',
        REFUSED: 'Rozmówca nie wyraził zgody na zapis rozmowy.',
        empty: 'Ta rozmowa nie zawiera zapisanych wypowiedzi.',
      },
      loadError: 'Nie udało się pobrać szczegółów połączenia.',
    },
    platform: {
      tab: 'Recepcja głosowa',
      title: 'Recepcja głosowa',
      description: 'Uruchamiaj recepcję dla placówki i zarządzaj jej numerami.',
      notConfigured: 'Recepcja głosowa nie jest jeszcze skonfigurowana.',
      disabledAfterTransfer:
        'Recepcja jest wyłączona. Możesz przypisać tej placówce nowy numer recepcji.',
      receptionistNumber: 'Numer recepcji',
      humanFallbackNumber: 'Numer przekazania do zespołu',
      provision: 'Uruchom recepcję',
      provisionTitle: 'Uruchom recepcję głosową',
      transfer: 'Przenieś wyłączony numer',
      transferTitle: 'Przeniesienie wyłączonego numeru recepcji',
      transferDescription:
        'Przenieś numer z innej placówki dopiero po wyłączeniu jej recepcji. Do zakończenia konfiguracji połączenia będą kierowane na numer zespołu nowej placówki.',
      sourceOrganizationId: 'Identyfikator placówki źródłowej',
      replace: 'Zmień numer recepcji',
      replaceTitle: 'Zmiana numeru recepcji',
      replaceDescription:
        'Nowy numer zastąpi obecny po zakończeniu bezpiecznej zmiany.',
      escalation: 'Zmień numer przekazania',
      escalationTitle: 'Zmiana numeru przekazania do zespołu',
      retry: 'Ponów uruchamianie',
      disable: 'Wyłącz recepcję',
      disableTitle: 'Wyłączyć recepcję głosową?',
      disableDescription:
        'Automatyczne odbieranie zostanie wyłączone, a połączenia nadal będą mogły trafić do zespołu.',
      disableConfirm: 'Wyłącz',
      actionAccepted:
        'Działanie zostało rozpoczęte. Stan zaktualizuje się automatycznie.',
      failed:
        'Ostatnie działanie nie zostało zakończone. Możesz spróbować ponownie.',
    },
    validation: {
      required: 'To pole jest wymagane.',
      e164: 'Podaj numer w formacie międzynarodowym, np. +48123456789.',
      organizationId: 'Podaj prawidłowy 24-znakowy identyfikator placówki.',
      welcomeMessage: 'Powitanie może mieć maksymalnie 500 znaków.',
    },
  },
  voicePrivacy: {
    trial: {
      pageTitle: 'Testowa recepcja głosowa',
      unverified:
        'Próba rozwojowa: brak potwierdzonej zerowej retencji Google i podpisanej informacji prawnej.',
      unavailable:
        'Nie można potwierdzić aktualnej próby dla tej placówki. Nie traktuj tej strony jako potwierdzenia jej aktywności.',
      version: 'Wersja informacji: {{version}}',
      expiresAt: 'Próba jest ograniczona do: {{date}}',
      contactController: 'Skontaktuj się z administratorem w sprawie danych',
      controllerContactMissing:
        'Placówka nie skonfigurowała adresu e-mail do kontaktu. Skontaktuj się z nią bezpośrednio w sprawie swoich danych.',
      status: {
        ACTIVE:
          'Okres upoważnienia i zapisanego nadzoru jeszcze nie upłynął. Dostępność rozmowy podlega osobnej weryfikacji. Potwierdzenia zewnętrzne nadal są niezweryfikowane.',
        MONITORING_REQUIRED:
          'Próba jest wstrzymana: brakuje aktualnego potwierdzenia nadzoru operatora.',
        EXPIRED: 'Czas upoważnienia do próby upłynął.',
      },
    },
    common: {
      loadError: 'Nie udało się pobrać informacji o prywatności.',
      requestError:
        'Nie udało się wykonać tej operacji. Sprawdź dane lub spróbuj ponownie.',
    },
    notice: {
      pageTitle: 'Prywatność rozmów z recepcją głosową',
      version: 'Wersja {{version}} · obowiązuje od {{date}}',
      controller: 'Administrator danych',
      retention: 'Przechowywanie i usuwanie danych',
      rights: 'Twoje prawa',
      rightsDescription:
        'Możesz poprosić o dostęp, sprostowanie, ograniczenie przetwarzania lub usunięcie danych związanych z rozmową.',
      startRequest: 'Złóż wniosek dotyczący danych',
    },
    request: {
      pageTitle: 'Wniosek dotyczący danych rozmowy',
      description:
        'Potwierdzimy Twój kanał kontaktu jednorazowym kodem. Ten formularz nie służy do próśb o oddzwonienie.',
      right: 'Rodzaj wniosku',
      rights: {
        ACCESS: 'Dostęp do danych',
        CORRECTION: 'Sprostowanie danych',
        RESTRICTION: 'Ograniczenie przetwarzania',
        ERASURE: 'Usunięcie danych',
      },
      channel: 'Kanał potwierdzenia',
      contact: 'Numer telefonu do weryfikacji SMS',
      start: 'Wyślij kod potwierdzający',
      challengeSent: 'Kod potwierdzający został wysłany wybranym kanałem.',
      code: 'Sześciocyfrowy kod',
      verify: 'Potwierdź i sprawdź wniosek',
      statusTitle: 'Stan wniosku',
      refreshStatus: 'Odśwież stan wniosku',
      status: {
        AWAITING_OTP: 'Wniosek oczekuje na potwierdzenie kodem.',
        PENDING_HUMAN_REVIEW: 'Wniosek oczekuje na ocenę uprawnionej osoby.',
        IN_REVIEW: 'Wniosek jest weryfikowany.',
        RESTRICTED: 'Przetwarzanie danych zostało ograniczone.',
        COMPLETED: 'Wniosek został zrealizowany.',
        DEFERRED_BY_LEGAL_HOLD:
          'Realizacja wniosku została odroczona z powodu obowiązku zachowania danych.',
        REJECTED: 'Wniosek nie może zostać zrealizowany.',
      },
      legalHold:
        'Część danych podlega obowiązkowi zachowania. Usunięcie zostanie wznowione po jego zakończeniu.',
      back: 'Wróć do informacji o prywatności',
      validation: {
        right: 'Wybierz rodzaj wniosku.',
        channelInvalid: 'Wybierz prawidłowy kanał potwierdzenia.',
        channelRequired: 'Wybierz kanał potwierdzenia.',
        contact: 'Podaj numer telefonu do weryfikacji SMS.',
        codeFormat: 'Kod musi zawierać dokładnie sześć cyfr.',
        codeRequired: 'Podaj kod potwierdzający.',
      },
    },
  },
  header: {
    addYourBusiness: 'Dodaj swój biznes',
    logIn: 'Zaloguj się',
    signUp: 'Załóż konto',
  },
  account: {
    settings: 'Ustawienia',
    notifications: 'Powiadomienia',
    logout: 'Wyloguj',
    logoutError: 'Nastąpił błąd podczas wylogowania!',
    adminPanel: 'Panel administratora',
  },
  openingStatus: {
    closedOpensAt: 'Dziś zamknięte • Otwarcie o {{time}}',
    closedDayOffFull: 'Dziś zamknięte • Dzień wolny',
    openClosesAtFull: 'Dziś otwarte • Zamknięcie o {{time}}',
    closedOpensLaterToday: 'Dziś zamknięte • Otwarcie o {{time}}',
    closedOpensOnDayAt: 'Dziś zamknięte • Otwarcie {{day}} o {{time}}',
    closedToday: 'Dziś zamknięte',
    openToday: 'Dziś otwarte',
    dayOff: 'Dzień wolny',
    opensAt: 'Otwarcie o {{time}}',
    closesAt: 'Zamknięcie o {{time}}',
    checkHours: 'Sprawdź godziny',
    opensDayAt: 'Otwarcie {{day}} o {{time}}',
    tomorrow: 'jutro',
    weekdays: {
      1: 'poniedziałek',
      2: 'wtorek',
      3: 'środa',
      4: 'czwartek',
      5: 'piątek',
      6: 'sobota',
      7: 'niedziela',
    },
  },
  validation: {
    phoneInvalid:
      'Numer telefonu musi zawierać numer kierunkowy kraju (np. +48123456789)',
    fieldRequired: 'Pole wymagane',
    invalidInput: 'Nieprawidłowe dane wejściowe',
    timeFormat: 'Czas musi być w formacie HH:mm',
    hourNotMidnight: 'Godzina nie może być równa 00:00',
    firstNameInvalid: 'Podaj poprawne imię',
    firstNameMin: 'Imię nie może być krótsze niż 2 znaki',
    firstNameRequired: 'Imię jest wymagane',
    lastNameInvalid: 'Podaj poprawne nazwisko',
    lastNameMin: 'Nazwisko nie może być krótsze niż 2 znaki',
    lastNameRequired: 'Nazwisko jest wymagane',
    emailRequired: 'Adres e-mail jest wymagany',
    emailRequiredForPaidVisit:
      'Adres e-mail jest wymagany przy płatnej wizycie',
    emailFormat: 'Adres e-mail musi mieć poprawny format',
    passwordRequired: 'Hasło jest wymagane',
    repeatPasswordRequired: 'Powtórzenie hasła jest wymagane',
    passwordsMustMatch: 'Hasła muszą być identyczne',
    termsRequired:
      'Akceptacja regulaminu oraz polityki prywatności jest wymagana',
    visitTypeRequired: 'Typ wizyty jest wymagany',
    professionalRequired: 'Specjalista jest wymagany',
    visitDateRequired: 'Data wizyty jest wymagana',
    petNameRequired: 'Imię jest wymagane',
    petSelectionRequired: 'Wybierz zwierzaka lub wpisz imię nowego zwierzaka',
    petNameMax: 'Imię nie może przekraczać 20 znaków',
    healthDescriptionRequired: 'Opis stanu zdrowia jest wymagany',
    emailOrPhoneRequired: 'Podaj adres e-mail lub numer telefonu',
    streetRequired: 'Ulica jest wymagana',
    cityRequired: 'Miasto jest wymagane',
    postalCodeRequired: 'Kod pocztowy jest wymagany',
    petCategoryRequired: 'Rodzaj zwierzęcia jest wymagany',
    visitFormatRequired: 'Rodzaj wizyty jest wymagany',
    visitDescriptionRequired: 'Opis wizyty jest wymagany',
    petsyMeetingTypeRequired: 'Typ e-spotkania jest wymagany',
    petsyMeetingDateRequired: 'Data e-spotkania jest wymagana',
    petsyMeetingDescriptionRequired: 'Opis e-spotkania jest wymagany',
    guestReminderChannelRequired: 'Wybierz co najmniej jeden kanał powiadomień',
    guestReminderScheduledAtPast:
      'Data i godzina przypomnienia muszą być w przyszłości',
  },
  snackbar: {
    genericError: 'Coś poszło nie tak',
    calendarReverted: 'Cofnięto zmiany',
    calendarUpdated: 'Zaktualizowano grafik',
    endAfterStart: 'Godzina końcowa musi być po godzinie początkowej',
    startAfterStart: 'Godzina początkowa musi być po godzinie początkowej',
    orgClosedWeekday: 'Organizacja nie pracuje w wybranym dniu tygodnia',
    visitTypesUnavailable: 'Wybrane typy wizyt nie są dostępne w organizacji',
    availabilityListEmpty: 'Lista dostępności nie może być pusta',
    outsideWorkingHours: 'Wybrane godziny są poza godzinami pracy organizacji',
    visitUpdated: 'Wizyta została zaktualizowana',
    visitCancelled: 'Wizyta została odwołana',
    visitRescheduled: 'Termin wizyty został zmieniony',
    visitBooked: 'Wizyta została umówiona',
    visitBookFailed: 'Nie udało się umówić wizyty',
    visitsLoadFailed: 'Nie udało się pobrać wizyt',
    emailTaken: 'Adres email jest już przypisany do innego konta',
    phoneTaken: 'Podany numer telefonu jest już przypisany do innego konta',
    attachmentDuplicate: 'Załącznik został już dodany',
    discountApplied: 'Kod rabatowy został pomyślnie zastosowany!',
    promoCodeInvalid:
      'Kod rabatowy jest niepoprawny lub dotyczy innego typu wizyty',
    fileOpenFailed: 'Nie udało się otworzyć pliku',
    treatmentAdded: 'Zabieg został dodany',
    medications_added_from_treatment: '{{count}} leków dodano z zabiegu',
    treatmentAddError: 'Wystąpił błąd podczas dodawania zabiegu',
    treatmentUpdated: 'Zabieg został zaktualizowany',
    treatmentUpdateError: 'Wystąpił błąd podczas aktualizacji zabiegu',
    treatmentDeleted: 'Zabieg został usunięty',
    treatmentDeleteError: 'Wystąpił błąd podczas usuwania zabiegu',
    treatmentCatalogAdded: 'Zabieg został dodany do katalogu',
    pdfGenerateError: 'Wystąpił błąd podczas generowania PDF',
    treatmentsSelected: 'Zaznaczono {{count}} zabiegów',
    treatmentsFetchError: 'Wystąpił błąd podczas pobierania zabiegów',
    visitCompleted: 'Wizyta została zakończona',
    visitAborted: 'Wizyta została przerwana',
    medicationAdded: 'Lekarstwo zostało dodane',
    medicationUpdated: 'Lekarstwo zostało zaktualizowane',
    medicationDeleted: 'Lekarstwo zostało usunięte',
    medicationAddError: 'Wystąpił błąd podczas dodawania lekarstwa',
    medicationUpdateError: 'Wystąpił błąd podczas aktualizacji lekarstwa',
    medicationDeleteError: 'Wystąpił błąd podczas usuwania lekarstwa',
    registrationError: 'Wystąpił błąd podczas rejestracji',
    profilesLoadFailed: 'Nie udało się pobrać profili',
    professionalLoadFailed: 'Nie udało się pobrać danych specjalisty',
    visitTimeChanged: 'Termin wizyty został zmieniony',
    visitApproved: 'Wizyta została zatwierdzona',
    visitApproveError: 'Błąd podczas zatwierdzania wizyty',
    visitRejected: 'Wizyta została odrzucona',
    visitRejectError: 'Błąd podczas odrzucania wizyty',
    accountError: 'Wystąpił błąd',
    calendarSlotConflictOrgs:
      'Ten przedział koliduje z godzinami {{list}}. Wybierz inny czas.',
    calendarSlotOverlap:
      'Jeden z przedziałów czasowych koliduje z innym przedziałem czasowym',
    visitEditError: 'Wystąpił błąd podczas edycji wizyty',
    visitEndedSuccess: 'Wizyta została zakończona',
    timeOffSelectProfessional: 'Wybierz specjalistę',
    timeOffSelectDates: 'Wybierz datę początkową i końcową',
    timeOffEndAfterStart:
      'Data końcowa musi być późniejsza niż data początkowa',
    timeOffMinDuration: 'Niedostępność musi trwać co najmniej 10 minut',
    timeOffOverlap: 'Ten okres nakłada się na istniejący okres wolny od pracy',
    timeOffAdded: 'Dodano okres niedostępności',
    timeOffAddError: 'Wystąpił błąd podczas dodawania',
    timeOffRemoved: 'Usunięto okres niedostępności',
    timeOffRemoveError: 'Wystąpił błąd podczas usuwania',
    defaultRejectionReason: 'Odrzucono przez użytkownika',
    historyFetchError: 'Nie mogliśmy pobrać najnowszej historii',
    chatMessagesLoadError: 'Nie udało się załadować wiadomości',
    chatSendError: 'Błąd podczas wysyłania wiadomości',
    copyLinkError: 'Nie udało się skopiować linku',
    linkCopiedSuccess: 'Link skopiowany do schowka!',
    videoConnectionError: 'Wystąpił błąd podczas połączenia wideo',
    conversationDetailsError: 'Nie mogliśmy pobrać szczegółów rozmowy',
    productsLoadError: 'Nie udało się pobrać produktów',
    paymentSummariesLoadError: 'Nie mogliśmy pobrać podsumowań',
    petsyHistoryFetchError: 'Nie mogliśmy pobrać najnowszej historii e-spotkań',
  },
  calendar: {
    viewMonth: 'Miesiąc',
    viewWeek: 'Tydzień',
    viewDay: 'Dzień',
    today: 'Dzisiaj',
    openSchedule: 'Grafik',
    addTimeOff: 'Dodaj niedostępność',
    eventUnavailable: 'Niedostępny',
    toolbarOrgUnavailability: 'Ustal niedostępności specjalistów w placówce',
    toolbarProUnavailability: 'Ustal swoją niedostępność w placówce',
    weekdayLongMon: 'Poniedziałek',
    weekdayLongTue: 'Wtorek',
    weekdayLongWed: 'Środa',
    weekdayLongThu: 'Czwartek',
    weekdayLongFri: 'Piątek',
    weekdayLongSat: 'Sobota',
    weekdayLongSun: 'Niedziela',
    weekdayShortMon: 'Pn',
    weekdayShortTue: 'Wt',
    weekdayShortWed: 'Śr',
    weekdayShortThu: 'Cz',
    weekdayShortFri: 'Pt',
    weekdayShortSat: 'Sb',
    weekdayShortSun: 'Nd',
    schedule: {
      unavailabilityTitle: 'Ustawiono niedostępności',
      unavailabilityBody:
        'W podanych poniżej okresach grafik nie będzie dostępny dla pacjentów.',
      facilityOpeningTitle: 'Godziny otwarcia placówki',
      facilityOpeningCaption:
        'Placówka tego dnia jest otwarta w podanych godzinach. Godziny dostępności w tym dniu muszą być wewnątrz godzin otwarcia placówki.',
      slotAssignedToOrg:
        'Ten przedział godzinowy został przypisany do {{name}}',
      addInterval: 'Dodaj kolejny przedział',
      pickWeekdayForAvailability:
        'Wybierz dzień tygodnia, aby ustawić dostępność',
      timeFrom: 'Od',
      timeTo: 'Do',
      discardChanges: 'Anuluj zmiany',
      conflictWarningTitle:
        'Część umówionych wizyt jest poza nowym harmonogramem',
      conflictWarningBody:
        'Poniższe wizyty będą kolidować z nowym harmonogramem. Możesz kliknąć wizytę, aby ją przełożyć, albo potwierdzić zmianę mimo to.',
      conflictColDate: 'Data',
      conflictColPatient: 'Pacjent',
      conflictColProfessional: 'Specjalista',
      conflictCancel: 'Anuluj',
      conflictConfirm: 'Potwierdź',
    },
  },
  auth: {
    loginHeroLine1: 'Twoje zwierzę zasługuje na ',
    loginHeroHighlight: 'najlepszą',
    loginHeroLine2: ' opiekę!',
    loginTitle: 'Zaloguj się do Vetsi',
    noAccount: 'Nie masz konta?',
    registerLink: 'Zarejestruj się',
    fieldFirstName: 'Imię',
    fieldLastName: 'Nazwisko',
    fieldEmail: 'Adres e-mail',
    fieldPhone: 'Numer telefonu',
    fieldPassword: 'Hasło',
    fieldRepeatPassword: 'Powtórz hasło',
    submitCreateAccount: 'Załóż konto',
    termsPrefix: 'Akceptuję ',
    termsRegulations: 'regulamin',
    termsMiddle: ' oraz ',
    termsPrivacy: 'politykę prywatności.',
    marketingConsent:
      'Wyrażam zgodę na otrzymywanie informacji handlowych od Vetsi drogą elektroniczną na podany adres e-mail.',
    verifyCodePageTitle: 'Weryfikacja kodu | Vetsi',
    verifyCodeHeading: 'Sprawdź swoją skrzynkę e-mail!',
    verifyCodeDescription:
      'Wysłaliśmy 6-cyfrowy kod potwierdzający na adres {{email}}. Wpisz kod poniżej, aby zweryfikować adres e-mail.',
    verifyCodeNoCode: 'Nie masz kodu?',
    verifyCodeResend: 'Wyślij ponownie',
    verifyCodeBackToLogin: 'Wróć do logowania',
    phoneLoginAuthUnavailable: 'Logowanie telefonem jest obecnie niedostępne',
    phoneLoginCodeSent: 'Kod weryfikacyjny został wysłany na Twój telefon',
    phoneLoginSendCodeError: 'Nie udało się wysłać kodu weryfikacyjnego',
    phoneLoginVerificationUnavailable: 'Weryfikacja kodu jest niedostępna',
    phoneLoginVerifyCodeError: 'Nie udało się zweryfikować kodu',
    phoneLoginTitle: 'Logowanie numerem telefonu',
    phoneLoginSubtitle: 'Podaj numer telefonu, aby otrzymać kod weryfikacyjny',
    phoneLoginSendCode: 'Wyślij kod weryfikacyjny',
    phoneLoginEnterCodeTitle: 'Wpisz kod weryfikacyjny',
    phoneLoginEnterCodeSubtitle: 'Wysłaliśmy 6-cyfrowy kod na numer {{phone}}',
    phoneLoginVerificationCodeLabel: 'Kod weryfikacyjny',
    phoneLoginBack: 'Wstecz',
    phoneLoginVerifyCode: 'Zweryfikuj kod',
  },
  petAi: {
    suggestion1: 'Jak mogę poprawić dietę mojego pupila?',
    suggestion2: 'Jakie są najlepsze zabawy dla mojego zwierzaka?',
    suggestion3: 'Czy mój pupil potrzebuje więcej aktywności?',
    suggestion4: 'Jak mogę pomóc w pielęgnacji sierści?',
    suggestion5: 'Jakie suplementy są odpowiednie dla mojego zwierzaka?',
    suggestion6: 'Jak często powinienem szczepić mojego pupila?',
    suggestion7: 'Jakie są objawy stresu u zwierząt?',
    suggestion8: 'Jak mogę poprawić zachowanie mojego pupila?',
    suggestion9: 'Czy mój zwierzak ma odpowiednią wagę?',
    suggestion10: 'Jakie są najlepsze przekąski dla mojego pupila?',
    loading1: 'Analizuję Twoje pytanie...',
    loading2: 'Przeglądam profil pupila...',
    loading3: 'Sprawdzam historię zdrowia...',
    loading4: 'Przeszukuję bazę wiedzy...',
    loading5: 'Przygotowuję odpowiedź...',
    error: 'Przepraszamy, wystąpił błąd. Spróbuj ponownie za chwilę.',
    placeholderReply: 'Możesz odpowiedzieć tutaj...',
    greeting:
      'Cześć! Czy masz jakieś pytanie dotyczące opieki i rozwoju {{name}}?',
    feedbackThanks: 'Dziękujemy za Twoją opinię!',
    feedbackError: 'Wystąpił błąd podczas zapisywania opinii',
    fileOpenError: 'Nie udało się otworzyć pliku',
    documentSourcesLabel: 'Źródła dokumentów:',
    documentFallback: 'Dokument',
    closingMedical:
      'W przypadku dalszych pytań dotyczących zdrowia pupila skontaktuj się z weterynarzem.',
    closingMedicalCta: 'Umów wizytę u weterynarza',
    closingDiet:
      'W przypadku dalszych pytań dotyczących żywienia skontaktuj się z dietetykiem.',
    closingDietCta: 'Umów wizytę u dietetyka',
    closingBehavior:
      'W przypadku dalszych pytań dotyczących zachowania pupila skontaktuj się z behawiorystą.',
    closingBehaviorCta: 'Umów wizytę u behawiorysty',
    feedbackPrompt: 'Czy ta informacja była pomocna?',
    invalidInput: 'Nieprawidłowe dane wejściowe',
  },
  systemPages: {
    page404Title: '404 Nie znaleziono strony | Vetsi',
    page404Heading: 'Przykro nam, nie znaleziono strony',
    page404Body:
      'Przykro nam, nie znaleziono strony. Może podano nieprawidłowy adres? Sprawdź pisownię.',
    page403Title: '403 Brak dostępu | Vetsi',
    page403Heading: 'Brak uprawnień',
    page403Body:
      'Strona, do której próbujesz uzyskać dostęp, jest ograniczona. Skontaktuj się z administratorem systemu.',
    page500Title: '500 Błąd serwera | Vetsi',
    page500Heading: '500 Błąd serwera',
    page500Body: 'Wystąpił błąd, spróbuj ponownie później.',
    comingSoonTitle: 'Wkrótce dostępne | Vetsi',
    comingSoonHeading: 'Wkrótce dostępne!',
    comingSoonBody: 'Intensywnie pracujemy nad tą stroną!',
    comingSoonDays: 'Dni',
    comingSoonHours: 'Godziny',
    comingSoonMinutes: 'Minuty',
    comingSoonSeconds: 'Sekundy',
    comingSoonEmailPlaceholder: 'Wpisz swój adres e-mail',
    comingSoonNotifyMe: 'Powiadom mnie',
    maintenanceTitle: 'Przerwa techniczna | Vetsi',
    maintenanceHeading: 'Strona jest obecnie w trakcie prac technicznych',
    maintenanceBody:
      'Intensywnie pracujemy nad przywróceniem pełnej dostępności.',
    blankTitle: 'Pusta strona | Vetsi',
    blankHeading: 'Pusta strona',
    chatTitle: 'Czat | Vetsi',
    profileSuggestionsTitle: 'Sugestie opieki nad pupilem | Vetsi',
    permissionDeniedTitle: 'Brak uprawnień | Vetsi',
    permissionDeniedHeading: 'Brak uprawnień',
    dashboardBreadcrumb: 'Panel',
    permissionDeniedBreadcrumb: 'Brak uprawnień',
    roleAdminLabel: 'Administrator',
    roleUserLabel: 'Użytkownik',
    roleAdminAria: 'rola administratora',
    roleUserAria: 'rola użytkownika',
    sampleCardTitle: 'Karta {{index}}',
    sampleCardSubheader: 'Podgląd zawartości',
    sampleCardBody: 'To jest przykładowa zawartość demonstracyjna komponentu.',
  },
  searchNotFound: {
    title: 'Nie znaleziono wyników',
    prefix: 'Brak wyników dla',
    hint: 'Sprawdź literówki lub użyj pełnych słów.',
    enterKeywords: 'Wpisz słowa kluczowe',
  },
  visit: {
    calendarVisitLoadError:
      'Nie udało się otworzyć wizyty. Wizyta może być niedostępna w wybranej placówce.',
    calendarVisitRetry: 'Spróbuj ponownie',
    defaultCancelReasonByStaff: 'Wizyta odwołana przez placówkę',
    aiChatTitle: 'Czat z asystentem',
    aiChatDescription:
      'Asystent Vetsi posiada wszystkie informacje na temat historii leczenia, leków oraz dokumentacji medycznej tego pacjenta.',
    scheduleModalTitle: 'Twój grafik',
    goToVisit: 'Przejdź do wizyty',
    startVisit: 'Rozpocznij wizytę',
    bookAgain: 'Umów wizytę ponownie',
    bookVisit: 'Umów wizytę',
    nextPaymentPortal:
      'W następnym kroku przeniesiemy Cię do portalu płatniczego.',
    cancelVisitTitle: 'Odwołanie wizyty',
    cancelVisitConfirm: 'Czy na pewno chcesz odwołać wizytę?',
    cancelReasonOptional: 'Powód odwołania (opcjonalnie)',
    cancelAction: 'Odwołaj',
    abortVisitTitle: 'Przerwij wizytę',
    abortVisitSubtitle: 'Podaj powód przerwania wizyty',
    abortReasonRequired: 'Wybierz przyczynę',
    abortOtherReasonRequired: 'Wpisz powód',
    abortReasonReschedule: 'Chęć zmiany terminu',
    abortReasonConnection: 'Problem z połączeniem',
    abortReasonWrongSpecialist: 'Błędnie wybrany specjalista',
    abortReasonLabel: 'Powód przerwania wizyty',
    abortOther: 'Inne',
    abortConfirm: 'Przerwij',
    tabDetails: 'Szczegóły',
    tabManage: 'Zarządzaj',
    rejectAction: 'Odrzuć',
    payVisit: 'Opłać wizytę',
    retryPayment: 'Ponów płatność',
    forceCreateAccountForOnlineHelper:
      'Chcę założyć konto, aby zarządzać wizytami i danymi mojego pupila (Konto jest wymagane do przeprowadzenia wizyty online)',
    confirmAction: 'Potwierdź',
    joinAction: 'Dołącz',
    cancelledByOwner: 'Właściciela',
    cancelledByClinic: 'Placówkę',
    cancelledByLabel: 'Odwołano przez:',
    abortedByProfessional: 'Wizyta przerwana przez specjalistę',
    paymentProcessing: 'Twoja płatność jest przetwarzana.',
    paymentCompleted: 'Płatność zakończona pomyślnie.',
    specialistStartedJoin: 'Specjalista rozpoczął wizytę. Możesz dołączyć.',
    joinAtScheduledTime:
      'Dołączenie do wizyty będzie możliwe o zarezerwowanej godzinie.',
    waitingForSpecialist:
      'Oczekiwanie na rozpoczęcie wizyty przez specjalistę.',
    paymentRejectedRetry:
      'Twoja płatność została odrzucona, aby sfinalizować wizytę, opłać ją ponownie.',
    clinicBookedAwaitingPayment:
      'Wizyta została umówiona przez placówkę i oczekuje na płatność.',
    clinicBookedAwaitingConfirm:
      'Wizyta została umówiona przez placówkę i oczekuje na twoje potwierdzenie. Jeśli wizyta nie zostanie potwierdzona w ciągu 60 minut, zostanie automatycznie anulowana.',
    visitDetailsTitle: 'Szczegóły wizyty',
    descriptionFromOwner:
      'Opis został przekazany przez właściciela przed wizytą.',
    complaintsHeading: 'Dolegliwości',
    attachmentsHeading: 'Załączniki',
    upcomingCardNearest: 'Wizyta odbędzie się',
    pendingCardNearest: 'Wizyta zaplanowana na',
    pastCardNearest: 'Wizyta odbyła się',
    plannedCardNearest: 'Wizyta była zaplanowana na',
    ownerLabel: 'Właściciel',
    rescheduleVisit: 'Zmień termin',
    cancelVisitShort: 'Odwołaj',
    abortVisitShort: 'Przerwij',
    paymentPaid: 'Opłacona',
    paymentPending: 'Oczekująca',
    paymentRefunded: 'Zwrócona',
    timeOffOrgTitle: 'Niedostępność placówki',
    timeOffStaffTitle: 'Ustal brak dostępności specjalistów',
    timeOffProTitle: 'Ustal brak dostępności',
    timeOffOrgHint:
      'Niedostępność placówki dotyczy wszystkich specjalistów. Ustawienie godzin spowoduje, że żaden specjalista nie będzie dostępny w podanym czasie.',
    timeOffBookingHint:
      'Ustalone niedostępności spowodują brak możliwości rezerwacji online wizyt u specjalistów w podanym okresie.',
    timeOffProHint:
      'Ustalone niedostępności spowodują brak możliwości rezerwacji wizyt w podanym czasie.',
    timeOffSpecialistField: 'Specjalista',
    timeOffReasonPlaceholder: 'Opcjonalny opis...',
    timeOffHoursRange: 'Godziny: {{start}}-{{end}}',
    timeOffEditTitle: 'Edytuj niedostępność',
    timeOffViewTitle: 'Niedostępność',
    timeOffStartDateTime: 'Data i godzina rozpoczęcia',
    timeOffEndDateTime: 'Data i godzina zakończenia',
    timeOffUpdated: 'Zaktualizowano okres niedostępności',
    timeOffUpdateError: 'Wystąpił błąd podczas aktualizacji',
    visitDetailsLoadError: 'Nie mogliśmy pobrać szczegółów wizyty',
    formsFillCta: 'Wypełnij',
    formsPendingTitle: 'Formularze do wypełnienia',
    formsPendingBody:
      'Przed wizytą wypełnij wymagane formularze ({{count}}). Pomoże to specjaliście lepiej przygotować się do wizyty.',
    reviewAddedSuccess: 'Opinia została dodana pomyślnie',
    reviewAddError: 'Nie udało się dodać opinii',
    formStatusToComplete: 'Do wypełnienia',
    formsToCompleteHeading: 'Formularze do wypełnienia',
    tabInternalNotes: 'Notatki wewnętrzne',
    calendarStatusPending: 'Oczekująca',
    calendarStatusCompleted: 'Zakończona',
    filtersClearAll: 'Wyczyść wszystko',
    calendarFilterStatusCreated: 'Utworzona',
    calendarFilterStatusPending: 'Oczekująca',
    calendarFilterStatusCompleted: 'Zakończona',
    calendarFilterStatusCancelled: 'Anulowana',
    calendarFilterStatusPendingApproval: 'Oczekuje na zatwierdzenie',
    calendarFilterStatusAccepted: 'Zaakceptowana',
    calendarFilterStatusRejected: 'Odrzucona',
    calendarFilterStatusRejectedBySystem: 'Odrzucona przez system',
    calendarFilterStatusAborted: 'Przerwana',
    calendarFilterVisitStatusLabel: 'Status wizyty',
    calendarFilterDoctorLabel: 'Lekarz',
    calendarFilterAllStatuses: 'Wszystkie',
    calendarFilterAllProfessionals: 'Wszyscy',
    calendarFilterChipStatus: 'Status: {{label}}',
    calendarFilterChipDoctor: 'Lekarz: {{name}}',
    legalWithdrawalNote:
      'Vetsi sp. z o.o. oraz zapoznałem się z prawem do odstąpienia od umowy.*',
    petNameFieldShort: 'Imię',
    timeOffSpecialistLine: 'Specjalista: {{name}}',
    editAction: 'Edytuj',
    editDetailsAction: 'Edytuj szczegóły',
    detailsEditModalTitle: 'Edytuj szczegóły wizyty',
    detailsEditSaveAction: 'Zapisz',
    rescheduleAction: 'Zmień termin',
    rescheduleModalTitle: 'Zmień termin wizyty',
    timeOffAddPeriod: 'Dodaj nowy okres niedostępności',
    timeOffReasonLabel: 'Powód niedostępności',
    timeOffPeriodsHeading: 'Okresy niedostępności',
    formFieldSelect: 'Wybór',
    formFieldFile: 'Załącznik',
    formStatusNotStarted: 'Nie rozpoczęty',
    formStatusSubmitted: 'Wysłany',
    formNotFilledByPatient: 'Pacjent jeszcze nie wypełnił tego formularza.',
    payOnSite: 'Wizyta płatna na miejscu',
    servicePrice: 'Cena usługi',
    visitPriceLabel: 'Cena wizyty',
    bookingVisitFormatVideo: 'Wideo',
    bookingVisitFormatChat: 'Czat',
    bookingVisitFormatOnsite: 'Na miejscu',
    bookingVisitFormatMobile: 'Mobilna',
    bookingSelectVisitFormat: 'Wybierz rodzaj wizyty',
    bookingFieldVisitFormat: 'Rodzaj wizyty',
    bookingVisitPurposeLabel: 'Cel wizyty',
    bookingSpecializationLabel: 'Specjalizacja',
    bookingCurrentSlot: 'Aktualny termin:',
    bookingNewSlot: 'Nowy termin:',
    bookingSlot: 'Termin:',
    bookingSummaryCategory: 'Typ wizyty:',
    bookingSummaryFormat: 'Rodzaj wizyty:',
    petsyMeetingTypeSummary: 'Typ e-spotkania:',
    bookingTermsPrivacyLink: 'politykę prywatności',
    bookingTermsAnd: 'i',
    bookingChoosePet: 'Wybierz zwierzaka',
    specialistFallback: 'Specjalista',
    professionalNotFound: 'Nie znaleziono specjalisty',
    petsySelectMeetingTypeHeading: 'Wybierz typ e-spotkania',
    petsyMeetingTypeField: 'Typ e-spotkania',
    cardVisitTitle: 'Wizyta',
    kindColonShort: 'Rodzaj:',
    atTimePrefix: 'o godzinie',
    actionInProgress: 'W trakcie',
    changeSlot: 'Zmień termin',
    reserve: 'Rezerwuj',
    payment: 'Płatność',
    goToVetsiPanel: 'lub przejdź do panelu Vetsi',
    petExtraInfoLater:
      'Dodatkowe informacje dotyczące zwierzaka będą możliwe do uzupełnienia w dowolnym momencie.',
    petNameHeading: 'Podaj imię zwierzaka',
    petNameRequiredBooking: 'Imię zwierzaka jest wymagane',
    symptomsRequired: 'Opis dolegliwości jest wymagany',
    selectSpecialist: 'Wybierz specjalistę',
    professionalPetNamePlaceholder: 'Podaj imię zwierzaka',
    tablePet: 'Zwierzak',
    tablePatient: 'Pacjent',
    tableSpecialist: 'Specjalista',
    tableDate: 'Data',
    tableTime: 'Godzina',
    tableKind: 'Rodzaj',
    tableStatus: 'Status',
    upcomingNoMoreVisits: 'Brak kolejnych wizyt',
    upcomingNoVisits: 'Brak wizyt',
    visitNotesTab: 'Notatki z wizyty',
    noFormsForVisit: 'Brak formularzy przypisanych do tej wizyty.',
    formFieldText: 'Tekst',
    formFieldCheckbox: 'Checkbox',
    formFieldRadio: 'Radio',
    formStatusDraft: 'Szkic',
    historyEmptyUser: 'Brak umówionych wizyt. Umów swoją pierwszą wizytę!',
    waitingRoomTodayTitle: 'Dzisiejsze nadchodzące wizyty',
    rescheduleVisitTitle: 'Zmień termin wizyty',
    editMinHoursNotice:
      'Edycja wizyty jest możliwa z minimum 6 godzinnym wyprzedzeniem.',
    cancelMinHoursNotice:
      'Anulowanie wizyty jest możliwe z minimum 6 godzinnym wyprzedzeniem.',
    reservationFeeFieldLabel: 'Przedpłata (zł)',
    reservationFeeFieldHelper:
      'Kwota pobierana online przy rezerwacji. Pozostaw puste, aby wyłączyć.',
    reservationFeeTooHigh: 'Przedpłata nie może być wyższa niż cena usługi.',
    reservationFeeRequiredLabel: 'Opłata rezerwacyjna:',
    staffOnlinePriceNotice:
      'Opiekun zapłaci online cenę usługi: {{amount}} zł.',
    staffOnlinePrepaymentNotice:
      'Opiekun zapłaci online przedpłatę: {{amount}} zł. Resztę rozliczy na wizycie.',
    staffGuestPrepaymentNotice:
      'Wizyta bez konta Vetsi: przedpłata nie zostanie pobrana online. Opiekun rozliczy całość na wizycie.',
    reservationFeeRequiredAlert:
      'Wymagana opłata rezerwacyjna: <bold>{{amount}} zł</bold>',
    reservationFeeFreeCancelNotice:
      'Bezpłatne anulowanie wizyty możliwe do 24 godzin przed wizytą.',
    reservationFeeBookingNonRefundable:
      'Ta wizyta odbędzie się za mniej niż 24 godziny, więc opłata rezerwacyjna nie podlega zwrotowi.',
    reservationFeeRefundOnCancel:
      'Otrzymasz zwrot opłaty rezerwacyjnej ({{amount}} zł).',
    reservationFeeNoRefundOnCancel:
      'Jeśli anulujesz wizytę później niż 24 godziny przed jej terminem, opłata rezerwacyjna nie zostanie zwrócona.',
    bookingBreadcrumbNew: 'Nowa wizyta',
    bookingBreadcrumbReschedule: 'Zmień termin',
    bookingBreadcrumbScheduled: 'Zaplanowana wizyta',
    visitAddressLabelColon: 'Adres wizyty:',
    petOwnerConnector: 'z',
    summaryVisitCategoryShort: 'Typ:',
    inviteLinkTitle: 'Zaproś na spotkanie',
    inviteLinkBody:
      'Poniższy link pozwala pacjentom na umówienie wizyty bezpośrednio z Tobą. Możesz go skopiować i udostępnić potencjalnym pacjentom.',
    calendarNoSlotsTitle: 'Brak dostępnych terminów',
    calendarNoSlotsHint: 'Sprawdź dostępne terminy w innych dniach',
    calendarToday: 'Dziś',
    calendarTomorrow: 'Jutro',
    chatVisitEnded: 'Wizyta została zakończona.',
    chatVisitCancelled: 'Wizyta została anulowana.',
    visitNotesPlaceholder:
      'Miejsce do sporządzania notatek dotyczących wizyty.',
    notesPanelTitle: 'Notatki',
    notesTabForPatient: 'Notatki (Pacjent)',
    selectTemplate: 'Wybierz szablon',
    templateNotSelected: 'Nie wybrano',
    notesTabInternal: 'Notatki (Wewnętrzne)',
    notesInternalHint:
      'Notatki wewnętrzne będą widoczne tylko dla innych specjalistów w tej placówce',
    notesDrawerTitle: 'Notatki',
    notesDrawerButton: 'Notatki',
    visitReasonTitle: 'Powód wizyty',
    visitCourseTitle: 'Przebieg wizyty',
    visitCourseEmpty: 'Brak zmian podczas tej wizyty',
    visitCourseAdd: 'Dodaj',
    visitCourseAddToVisit: 'Dodaj do wizyty',
    visitCourseMenuPatientNotes: 'Notatki dla pacjenta',
    visitCourseMenuMedication: 'Lekarstwo',
    visitCourseMenuTreatment: 'Zabieg',
    visitCourseMenuReminder: 'Przypomnienie',
    visitCourseMenuDocument: 'Dokument',
    visitCourseMenuInternalNotes: 'Notatki wewnętrzne',
    visitCourseMenuSummary: 'Podsumowanie wizyty',
    visitCourseAddSuccess: 'Wpis został dodany',
    visitCourseAddError: 'Nie udało się dodać wpisu',
    visitCourseRemoveSuccess: 'Wpis został usunięty',
    visitCourseRemoveError: 'Nie udało się usunąć wpisu',
    visitPageTitle: 'Wizyta | Vetsi',
    tabVisit: 'Wizyta',
    tabHistory: 'Historia',
    tabMedications: 'Lekarstwa',
    tabReminders: 'Przypomnienia',
    tabTreatments: 'Zabiegi',
    tabDocumentation: 'Dokumentacja',
    tabNotes: 'Notatki',
    partyTabPatient: 'Pacjent',
    partyTabOwner: 'Właściciel',
    partyTabsAriaLabel: 'Dane pacjenta i właściciela',
    endVisitAndSend: 'Zakończ i wyślij',
    endVisitAndSaveDraft: 'Zakończ i zapisz draft',
    endVisitDraftExplainer:
      'Draft zapisuje notatki tylko dla placówki. Właściciel ich nie zobaczy, dopóki ich nie wyślesz z historii wizyt.',
    notesDraftChip: 'Draft',
    notesStatusColumn: 'Notatka',
    historyClosedColumn: 'Zamknięto',
    noteStatusFilterLabel: 'Notatka',
    noteStatusChip: 'Notatka: {{statuses}}',
    notesStatusSent: 'Dodano',
    notesStatusDraft: 'Draft',
    notesStatusNone: 'Brak',
    ratingStatusNone: 'Brak',
    notesDraftHint:
      'Draft: te notatki nie zostały jeszcze wysłane do właściciela.',
    notesDraftSendButton: 'Wyślij do właściciela',
    notesModePatient: 'Dla pacjenta',
    notesModeInternal: 'Wewnętrzne',
    notesAutosaveSaving: 'Zapisywanie…',
    notesAutosaveSaved: 'Zapisano',
    notesAutosaveError: 'Nie udało się zapisać',
    walkInBadge: 'Bez zapisu',
    walkInBadgeTooltip:
      'Wizyta rozpoczęta bez wcześniejszej rezerwacji terminu.',
    walkInStartButton: 'Rozpocznij wizytę bez zapisu',
    walkInModalTitle: 'Rozpocznij wizytę bez zapisu',
    walkInStepService: 'Usługa',
    walkInCategoryLabel: 'Kategoria wizyty',
    walkInServiceLabel: 'Usługa',
    walkInVisitTypeLabel: 'Rodzaj wizyty',
    walkInSubmit: 'Rozpocznij wizytę',
    walkInOverlapWarning:
      'Ta wizyta pokrywa się z wizytą zaplanowaną od {{start}} do {{end}}.',
    walkInSuccess: 'Wizyta została rozpoczęta',
    walkInFailed: 'Nie udało się rozpocząć wizyty',
    alreadyPendingTitle: 'Masz już rozpoczętą wizytę',
    alreadyPendingTitlePrefix: 'Masz już rozpoczętą wizytę umówioną na',
    alreadyPendingBody:
      'Zakończ bieżącą wizytę, zanim rozpoczniesz kolejną. W przypadku przygotowanych notatek dla tej wizyty, opcja "Zakończ i rozpocznij nową" zapisze je jako draft do którego będzie można wrócić w dowolnej chwili.',
    alreadyPendingGoToVisit: 'Przejdź do wizyty',
    alreadyPendingEndAndStart: 'Zakończ i rozpocznij nową',
    ownerHasVisitTodayTitle: 'Ten opiekun ma dziś zaplanowaną wizytę',
    ownerHasVisitTodayBody:
      'O {{time}}: {{patient}}. Możesz rozpocząć tamtą wizytę zamiast tworzyć nową.',
    ownerHasVisitTodayStartScheduled: 'Rozpocznij zaplanowaną wizytę',
    ownerHasVisitTodayStartAnyway: 'Rozpocznij mimo to',
    endVisitButton: 'Zakończ wizytę',
    endVisitNoNotesConfirm:
      'Nie sporządzono żadnych notatek dla tej wizyty. Czy na pewno chcesz ją zakończyć?',
    endVisitSuccess: 'Wizyta została zakończona',
    joinCallButton: 'Dołącz',
    patientAgeLabel: 'Wiek:',
    patientGenderLabel: 'Płeć:',
    patientWeightLabel: 'Waga:',
    patientChipLabel: 'Chip:',
    ownerEmailLabel: 'Email:',
    ownerPhoneLabel: 'Telefon:',
    ownerCityLabel: 'Adres:',
    editPatientButton: 'Edytuj dane pacjenta',
    editProfileTitle: 'Edycja danych pacjenta',
    editProfileSuccess: 'Dane pacjenta zostały zaktualizowane',
    editProfileSave: 'Zapisz',
    editProfileCancel: 'Anuluj',
    editOwnerTitle: 'Edycja danych właściciela',
    editOwnerSuccess: 'Dane właściciela zostały zaktualizowane',
    editOwnerButton: 'Edytuj dane właściciela',
    editOwnerFirstName: 'Imię',
    editOwnerLastName: 'Nazwisko',
    editOwnerEmail: 'E-mail',
    editOwnerPhone: 'Numer telefonu',
    validationOwnerEmail: 'Podaj poprawny adres e-mail',
    validationOwnerPhone: 'Numer telefonu musi mieć od 6 do 20 znaków',
    editProfileName: 'Imię',
    editProfileBreed: 'Rasa',
    editProfileGender: 'Płeć',
    editProfileDob: 'Data urodzenia',
    editProfileWeight: 'Waga (kg)',
    editProfileChipNumber: 'Numer chipa',
    editProfileScopeWarning:
      'Wprowadzone zmiany w profilu pacjenta będą widoczne w całym systemie. Ta zmiana nie dotyczy tylko obecnej wizyty.',
    editProfilePetCategory: 'Rodzaj zwierzaka',
    petCategoryDog: 'Pies',
    petCategoryCat: 'Kot',
    petCategoryOther: 'Inne',
    selectPetCategoryError: 'Wybierz kategorię zwierzaka (pies, kot lub inne)',
    validationNameRequired: 'Imię jest wymagane',
    validationNameMax: 'Imię nie może przekraczać 20 znaków',
    validationBreedRequired: 'Rasa jest wymagana',
    validationGenderRequired: 'Płeć jest wymagana',
    validationDobRequired: 'Wiek jest wymagany',
    validationWeightRequired: 'Waga jest wymagana',
    validationWeightMin: 'Waga musi być większa od 0',
    validationWeightType: 'Podaj poprawną liczbę',
    validationChipFormat:
      'Numer mikroczipa musi składać się z dokładnie 15 cyfr',
    historyFilterOwnerChip: 'Właściciel: {{name}}',
    historyFilterPetChip: 'Zwierzak: {{name}}',
    historyProfessionalChip: 'Specjalista: {{name}}',
    historyDateFromChip: 'Od: {{date}}',
    historyDateToChip: 'Do: {{date}}',
    historyClosedFromChip: 'Zamknięto od: {{date}}',
    historyClosedToChip: 'Zamknięto do: {{date}}',
    historyFiltersTooltip: 'Filtry',
    historyFilterStatusCompleted: 'Zakończona',
    historyFilterStatusCancelled: 'Odwołana',
    historyFilterStatusAborted: 'Przerwana',
    historyFilterEmpty: 'Brak wizyt spełniających wybrane filtry',
    historyDateFromLabel: 'Data od',
    historyDateToLabel: 'Data do',
    historyClosedFromLabel: 'Zamknięto od',
    historyClosedToLabel: 'Zamknięto do',
    historyNoReview: 'Brak opinii',
    historyTableActions: 'Akcje',
    historyOwnerField: 'Właściciel',
    petsyHistoryLoadError: 'Nie mogliśmy pobrać najnowszej historii e-spotkań',
    bookingConfirmedTitle: 'Twoja wizyta została potwierdzona!',
    bookingEmailFollowUp:
      'Wszystkie informacje zostaną również przesłane na Twojego maila',
    bookingEmailFollowUpGuest:
      'Wszystkie informacje wraz z linkiem do zarządzania tą wizytą wyślemy również na adres <hl>{{email}}</hl>.',
    bookingPhoneFollowUpGuest:
      'Wszystkie informacje wraz z linkiem do zarządzania tą wizytą wyślemy również SMS-em na numer <hl>{{phone}}</hl>.',
    bookingBothFollowUpGuest:
      'Wszystkie informacje wraz z linkiem do zarządzania tą wizytą wyślemy również na adres <hl>{{email}}</hl> oraz SMS-em na numer <hl>{{phone}}</hl>.',
    bookingGuestCloseHint: 'Możesz zamknąć tę stronę',
    backToHome: 'Wróć na stronę główną',
    backToSearch: 'Wróć do wyszukiwarki',
    rejectVisitDialogTitle: 'Odrzucenie wizyty',
    rejectPendingConfirm: 'Czy na pewno chcesz odrzucić tę wizytę?',
    inviteCopyButton: 'Kopiuj',
    inviteCopied: 'Skopiowano!',
    petsyVisitReservedTitle: 'Twoja wizyta została zarezerwowana',
    uploadAttachmentsCta: 'Dodaj załączniki',
    endVisit: 'Zakończ',
    missingStepsTitle: 'Brakujące kroki',
    abortMenuItem: 'Przerwij wizytę',
    stepsRequiredBadge: 'Obowiązkowe',
    stepsDuringVisitIntro:
      'Należy spełnić poniższe warunki podczas trwania e-spotkania.',
    stepDiagnosisAndPlan: 'Wyjaśnienie diagnozy i planu leczenia',
    stepOwnerAnswers: 'Odpowiedzi na pytania właściciela',
    searchProductsPlaceholder: 'Szukaj produktów...',
    productPriceLabel: 'Cena: {{price}} {{currency}}',
    productsEmpty: 'Brak produktów',
    productsNoneFound: 'Nie znaleziono produktów',
    paymentSummaryPending: 'Oczekujące',
    historyRatingColumn: 'Opinia',
    editInternalNotes: 'Edytuj notatki',
    saveInternalNotes: 'Zapisz notatki',
    vetsiAssistantTab: 'Asystent Vetsi',
    aiNoteEmpty: 'Brak informacji od asystenta Vetsi',
    aiNoteGenerating: 'Asystent Vetsi przygotowuje notatkę...',
    aiNoteFailed: 'Nie udało się wygenerować notatki asystenta Vetsi',
    startTranscription: 'Rozpocznij transkrypcję',
    stopTranscription: 'Zatrzymaj transkrypcję',
    transcriptionTab: 'Transkrypcja',
    transcriptionTitle: 'Transkrypcja',
    transcriptionLivePreview: 'Podgląd na żywo',
    transcriptionActivityStarting: 'Przygotowuję nagrywanie',
    transcriptionActivityStartingDetail:
      'Łączę transkrypcję i uruchamiam mikrofon.',
    transcriptionActivityRecording: 'Nagrywanie trwa',
    transcriptionActivityRecordingDetail:
      'Możesz mówić naturalnie. Tekst pojawi się po analizie.',
    transcriptionActivityRecordingElsewhere: 'Nagrywanie w innym oknie',
    transcriptionActivityRecordingElsewhereDetail:
      'Ta wizyta ma aktywną sesję. Zaczekaj na jej zakończenie.',
    transcriptionActivitySynchronizing: 'Sprawdzam stan transkrypcji',
    transcriptionActivitySynchronizingDetail:
      'Ponowne nagrywanie będzie dostępne po potwierdzeniu zakończenia poprzedniej sesji.',
    transcriptionActivityReviewing: 'Analizuję wypowiedź',
    transcriptionActivityReviewingDetail:
      'Doprecyzowuję tekst i rozmówców. Nagrywanie trwa.',
    transcriptionActivityStopping: 'Zapisuję rozmowę',
    transcriptionActivityStoppingDetail:
      'Nagrywanie zakończone. Sprawdzam ostatnie wypowiedzi.',
    transcriptionEmpty: 'Brak transkrypcji z wizyty',
    transcriptionEdit: 'Edytuj',
    transcriptionSave: 'Zapisz',
    transcriptionCancel: 'Anuluj',
    transcriptionConsentTitle: 'Potwierdź zgodę na transkrypcję',
    transcriptionConsentDescription:
      'Przed rozpoczęciem transkrypcji potwierdź, że opiekun został poinformowany o nagrywaniu dźwięku w celu przygotowania transkrypcji wizyty i wyraził na to zgodę. Audio używane do weryfikacji mówców jest dostępne w naszej aplikacji do analizy przez 7 dni.',
    transcriptionConsentConfirm: 'Potwierdzam zgodę',
    transcriptionStartFailed: 'Nie udało się rozpocząć transkrypcji',
    transcriptionConnectionFailed: 'Połączenie transkrypcji zostało przerwane',
    transcriptionConnectionInterrupted:
      'Połączenie transkrypcji zostało przerwane. Możesz rozpocząć nowe nagranie.',
    transcriptionStopFailed:
      'Nie udało się potwierdzić zakończenia transkrypcji. Trwa odzyskiwanie zapisanego tekstu.',
    transcriptionRecoveryFailed:
      'Nie udało się odświeżyć zapisu transkrypcji. Odśwież wizytę przed kolejnym nagraniem.',
    transcriptionSpeaker: 'Rozmówca {{number}}',
    transcriptionRoleProfessional: 'Specjalista',
    transcriptionRoleCaregiver: 'Opiekun',
    transcriptionRoleUnknown: 'Rola nierozpoznana',
    transcriptionStopping: 'Kończenie transkrypcji…',
    transcriptSummary: 'Streszczenie rozmowy',
    summaryGenerating: 'Generowanie streszczenia…',
    summaryGenerationFailed: 'Nie udało się wygenerować streszczenia',
    paymentSummaryAll: 'Wszystkie',
    paymentSummaryCompletedLabel: 'Odbyte',
    paymentStatsVisitWordOne: 'wizyta',
    paymentStatsVisitWordFew: 'wizyty',
    paymentStatsVisitWordMany: 'wizyt',
    stepsPanelTitle: 'Analiza specjalistyczna',
    stepsCompleteBadge: 'Gotowe',
    stepPatientVerification: 'Weryfikacja pacjenta',
    stepDiagnosisSet: 'Postawienie diagnozy',
    stepTreatmentRecommendations:
      'Zalecenia leczenia (np. leki, dieta, rehabilitacja)',
    endVisitMissingStepsAnalysis: 'Analiza specjalistyczna',
    endVisitMissingStepsNotes: 'Notatki z e-spotkania',
    productsSelectedCount: 'Wybrane produkty: {{count}}',
  },
  search: {
    professionalFilters: {
      professional: 'Specjalista',
      noProfessionals: 'Nie znaleziono specjalisty',
      clearProfessional: 'Wyczyść wybór specjalisty',
      openProfessionals: 'Rozwiń listę specjalistów',
      closeProfessionals: 'Zwiń listę specjalistów',
      allModes: 'Wszystkie',
      date: 'Data',
      invalidDate: 'Wybierz dzisiejszą lub późniejszą datę.',
      checking: 'Sprawdzamy dostępne terminy…',
      availabilityError:
        'Nie udało się sprawdzić dostępności. Spróbuj ponownie.',
      professionalsError: 'Nie udało się pobrać listy specjalistów.',
      retry: 'Spróbuj ponownie',
      noMatches: 'Brak specjalistów spełniających wybrane filtry.',
    },
    meta: {
      bookOnline: 'Umów wizytę online',
      findSpecialist: 'Znajdź najlepszego specjalistę',
      bookOnline247: ' i umów wizytę online 24/7 dzięki Vetsi',
      facilityDetailsTitle: 'Szczegóły placówki | Vetsi',
      bookingPageTitle: 'Rezerwacja wizyty | Vetsi',
      bookingDefaultDescription: 'Umów wizytę online 24/7 dzięki Vetsi',
      reserveOnline: 'Zarezerwuj Wizytę Online',
      vetsiBrand: 'Vetsi',
      orgBookingDescription:
        'Umów wizytę w {{org}} w {{city}} - poznaj placówkę oraz jej zespół i umów wizytę online 24/7 dzięki Vetsi',
    },
    category: {
      veterinarian: 'Weterynarz',
      dietitian: 'Dietetyk',
      behaviorist: 'Behawiorysta',
      groomer: 'Groomer',
      trainer: 'Trener',
      physiotherapist: 'Fizjoterapeuta',
    },
    openingHoursTitle: 'Godziny otwarcia',
    fileProcessing: 'Procesowanie pliku...',
    ui: {
      facilityDetails: 'Szczegóły placówki',
      specialists: 'Specjaliści',
      detailsTab: 'Szczegóły',
      specialistsTab: 'Specjaliści',
      inFacility: 'W placówce',
      organizationName: 'Nazwa placówki',
      service: 'Usługa',
      tabAll: 'Wszystkie',
      tabOnline: 'Online',
      tabMobile: 'Mobilna',
      aboutTab: 'Opis',
      location: 'Lokalizacja',
      category: 'Kategoria',
      specialization: 'Specjalizacja',
      hoursShort: 'Godziny',
      website: 'Strona',
      visitType: 'Rodzaj wizyty',
      visitCategory: 'Kategoria wizyty',
      calendarTitle: 'Kalendarz',
      selectSlot: 'Wybierz termin',
    },
    nearestAvailableSlot: 'Najbliższy wolny termin',
    slotRelativeToday: 'dzisiaj',
    slotRelativeTomorrow: 'jutro',
    slotRelativeDayAfterTomorrow: 'pojutrze',
    listCard: {
      lastBooked: 'Ostatnio umówiona wizyta',
    },
    moreHours: 'Pokaż więcej godzin',
    more: 'Więcej',
    noSlotsForProfessional: 'Brak wolnych terminów u tego specjalisty',
    emptyProfessionals: {
      title: 'Brak dostępnych specjalistów',
      body: 'Aktualnie placówka nie posiada dostępnych specjalistów. Skontaktuj się bezpośrednio z placówką lub zmień filtry wyszukiwania.',
    },
    emptyProfessionalsTab: {
      title: 'Brak specjalistów',
      body: 'Aktualnie placówka nie posiada dostępnych specjalistów.',
    },
    emptyAbout: {
      title: 'Brak opisu placówki',
      body: 'Aktualnie placówka nie posiada opisu.',
    },
    specializationOther: 'Inne',
    lastVisit: {
      prefix: 'Ostatnia umówiona wizyta ',
      today: 'dziś',
      yesterday: 'wczoraj',
      timePrefix: ' o ',
    },
    orgPhotoAlt: '{{name}}, zdjęcie {{number}}',
    noResults: {
      title: 'Nie znaleźliśmy żadnych placówek',
      subtitle:
        'Nie udało się znaleźć placówek spełniających Twoje kryteria. Spróbuj zmienić filtry wyszukiwania lub sprawdź ponownie później.',
      specialistLead: 'Jesteś zwierzęcym specjalistą? ',
      specialistLink: 'Dołącz do Vetsi i promuj swój biznes!',
      ownerLead: 'Jesteś opiekunem pupila? ',
      ownerLink: 'Poleć swojego specjalistę aby dołączył do Vetsi!',
    },
    book: {
      submitFailed:
        'Nie udało się potwierdzić rezerwacji. Twoje dane pozostały w formularzu. Spróbuj ponownie.',
      invalidDetails: 'Sprawdź dane w formularzu i spróbuj ponownie.',
      clientUpdateRequired:
        'Formularz rezerwacji został zaktualizowany. Odśwież stronę i spróbuj ponownie.',
      attachmentReuploadRequired:
        'Załącznik pochodzi ze starszej wersji formularza. Odśwież stronę, dodaj plik ponownie i ponów rezerwację.',
      confirmation: {
        codeRejected: 'Nieprawidłowy kod potwierdzenia.',
        expired:
          'Kod wygasł lub wykorzystano wszystkie próby. Zamknij to okno i ponownie wyślij formularz, aby otrzymać nowy kod.',
        processing:
          'Potwierdzenie jest już przetwarzane. Zaczekaj chwilę i spróbuj ponownie.',
        failed: 'Nie udało się sprawdzić kodu. Spróbuj ponownie.',
        title: 'Potwierdź rezerwację',
        description:
          'Wpisz kod wysłany na podane dane kontaktowe. Szczegóły wizyty będą dostępne dopiero po potwierdzeniu.',
        descriptionEmail:
          'Wpisz kod wysłany na Twój adres e-mail. Szczegóły wizyty będą dostępne dopiero po potwierdzeniu.',
        descriptionSms:
          'Wpisz kod wysłany SMS-em na Twój numer telefonu. Szczegóły wizyty będą dostępne dopiero po potwierdzeniu.',
        code: 'Kod potwierdzenia',
        codeInvalid: 'Wpisz sześciocyfrowy kod.',
        expiry:
          'Kod wygasa po 15 minutach. Termin zostanie zarezerwowany po jego wpisaniu.',
        confirm: 'Umów wizytę',
        voiceDescription:
          'Jeśli to Ty rezerwowałeś wizytę, potwierdź ten kontakt. Szczegóły wizyty będą dostępne po weryfikacji.',
        voiceContinue: 'Potwierdź mój kontakt',
        voiceEmailSent: 'Sprawdź wiadomość z linkiem weryfikacyjnym.',
        voiceFailed: 'Nie udało się wysłać kodu. Spróbuj ponownie.',
      },
      continueToConfirmation: 'Potwierdź wizytę',
      guardianTitle: 'Dane opiekuna',
      guardianIntro:
        'Podaj dane kontaktowe, aby dokończyć rezerwację i otrzymywać informacje o wizycie.',
      guestConfirmationInfo:
        'Rezerwujesz jako gość? Wyślemy kod potwierdzenia SMS-em, a jeśli nie podasz numeru telefonu, na adres e-mail. Wizyta zostanie zarezerwowana po jego wpisaniu.',
      hasAccount: 'Masz już konto?',
      createAccount:
        'Chcę założyć konto, aby zarządzać wizytami i danymi mojego pupila.',
      contactRequiredAlert:
        'Aby umówić wizytę należy podać adres e-mail lub numer telefonu',
      paidVisitEmailInfo:
        'Płatna wizyta wymaga adresu e-mail. Przy rezerwacji jako gość wyślemy kody potwierdzenia przed rezerwacją i przekazaniem informacji o płatności. Jeśli podasz numer telefonu, potwierdzisz go również kodem SMS.',
      promoTitle: 'Załóż konto i odkryj możliwości nowoczesnej opieki',
      promoMonitoringTitle: 'Monitoring leczenia',
      promoMonitoringDesc:
        'Przypomnienia o terminach wizyt i dawkach leków zawsze pod ręką.',
      promoHistoryTitle: 'Historia wizyt',
      promoHistoryDesc:
        'Pełny wgląd w historię leczenia: daty, zalecenia i notatki w jednym miejscu.',
      promoHealthBookTitle: 'Cyfrowa książeczka zdrowia',
      promoHealthBookDesc:
        'Zarządzaj informacjami, dokumentami i historią leczenia w bezpiecznym miejscu.',
      promoDocsTitle: 'Dokumentacja medyczna',
      promoDocsDesc:
        'Wyniki badań i wypisy z wizyt bezpiecznie przechowywane i dostępne 24/7.',
      stepAddress: 'Adres',
      visitAddressTitle: 'Adres wizyty',
      visitAddressSubtitle: 'Podaj adres, pod którym odbędzie się wizyta.',
      street: 'Ulica',
      city: 'Miejscowość',
      zipCode: 'Kod pocztowy',
      petHealthTitle: 'Wywiad zdrowotny pupila',
      petHealthIntro:
        'Pamiętaj aby szczegółowo opisać stan swojego pupila oraz przekazać wszelkie informacje w tym załączniki, które mogą być przydatne podczas wizyty specjalistą.',
      selectPet: 'Wybierz pupila',
      healthProblemLabel: 'Opis stanu zdrowia/problemu',
      bookVisit: 'Umów wizytę',
      bookVisitWithPayment: 'Zapłać i umów wizytę',
      paymentRedirectInfo:
        'W następnym kroku przeniesiemy Cię do portalu Przelewy24 w celu dokonania płatności.',
      paymentAtFacilityInfo:
        'Za wizytę zapłacisz w placówce. Rezerwacja nie wymaga płatności online.',
      bookingUnavailableTitle: 'Rezerwacja online tej usługi jest niedostępna',
      bookingUnavailableBody:
        'Nie udało się ustalić sposobu płatności za tę usługę. Odśwież stronę, wybierz inną usługę lub skontaktuj się z placówką.',
      bookingUnavailableCta: 'Wybierz inną usługę',
      bookingSavedSignInUnavailable:
        'Wizyta {{visitId}} została umówiona. Nie udało się zalogować automatycznie. Zaloguj się, aby zobaczyć szczegóły wizyty.',
      bookingSavedSignInPrompt:
        'Wizyta została umówiona. Zaloguj się, aby zobaczyć szczegóły.',
      bookingAttachmentsWarning:
        'Wizyta została umówiona, ale nie udało się dodać załączników.',
      continueToPayment: 'Przejdź do płatności',
      contactTakenTitle: 'Adres email lub numer telefonu jest zajęty',
      contactTakenBody:
        'Podany adres email lub numer telefonu posiada przypisane konto w naszym systemie. Zaloguj się do aplikacji w celu umówienia wizyty.',
      slotTakenTitle: 'Ten termin jest już zajęty',
      slotTakenBody:
        'Wybrany termin został właśnie zarezerwowany przez kogoś innego. Wybierz inny dostępny termin.',
      slotTakenCta: 'Wybierz inny termin',
      termsPrefix: 'Akceptuję ',
      termsBetweenLinks: ' oraz ',
      promoCodeContent: 'Treść kodu rabatowego',
      summaryTitle: 'Twój pupil za chwilę będzie w dobrych rękach!',
      summarySubtitle:
        'Zweryfikuj podane dane i upewnij się, że podano wszystkie informacje. Dokładny opis stanu zdrowia/problemu pupila znacząco przyspieszy wizytę.',
      dataSummary: 'Podsumowanie danych',
      streetSummary: 'Ulica:',
      citySummary: 'Miejscowość:',
      petKind: 'Rodzaj:',
      breedKind: 'Gatunek/Rasa:',
      cardTitle: 'Podsumowanie',
      cardAddress: 'Adres',
      cardPhone: 'Telefon',
      cardEmail: 'Email',
      cardSpecialist: 'Specjalista',
      cardVisit: 'Wizyta',
      visitModeLabel: 'Rodzaj:',
      visitSlotLabel: 'Termin:',
      serviceLabelColon: 'Usługa:',
      serviceDescriptionLabel: 'Opis usługi:',
      backToBooking: 'Wróć',
    },
  },
  quickBooking: {
    stepperSlot: 'Termin',
    stepperGuardian: 'Opiekun',
    stepperPet: 'Pupil',
    stepperSummary: 'Podsumowanie',
    step1Title: 'Termin wizyty',
    step1Body:
      'Wybierz typ wizyty a także dogodny dla siebie termin. Jeśli termin który Cię interesuje nie jest dostępny, skontaktuj się z nami.',
    step2Title: 'Dane opiekuna',
    step2Body:
      'Na podany adres email wyślemy zaproszenie do zalogowania się w naszej platformie oraz instrukcje jak przygotować się do rozmowy z naszym specjalistą.',
    step3Title: 'Wywiad zdrowotny pupila',
    step3Body:
      'Pamiętaj aby szczegółowo opisać stan swojego pupila oraz przekazać wszelkie informacje, które mogą być przydatne podczas rozmowy z naszym specjalistą.',
    step4Body:
      'W następnym kroku przeniesiemy Cię do płatności. Opłacenie wizyty gwarantuje rezerwację terminu ze Specjalistą.',
    selectVisitTypeHeading: 'Wybierz typ wizyty',
    selectVisitTypeField: 'Typ wizyty',
    selectTimeHeading: 'Wybierz termin',
    next: 'Dalej',
    back: 'Wstecz',
    sectionAppointment: 'Termin',
    sectionGuardian: 'Opiekun',
    sectionPet: 'Pupil',
    priceLabel: 'Cena:',
    typeLabel: 'Typ:',
    dateLabel: 'Data:',
    fullNameLabel: 'Imię i nazwisko:',
    emailLabel: 'Email:',
    phoneLabel: 'Telefon:',
    petNameSummary: 'Imię:',
    specialistInfo: 'Informacje dla specjalisty',
    attachments: 'Załączniki',
    promoSection: 'Kod rabatowy',
    promoField: 'Kod rabatowy',
    payment: 'Płatność',
    prescriptionPopoverTitle: 'Potrzebujesz recepty?',
    prescriptionPopoverBody:
      'Zgodnie z obowiązującymi przepisami w Polsce, recepta weterynaryjna może zostać wystawiona wyłącznie podczas wizyty w gabinecie weterynaryjnym. Niestety, podczas wizyty online nie ma możliwości wystawienia recepty. Warto jednak pamiętać, że nie zawsze jest ona konieczna. Podczas wizyty pomożemy znaleźć najlepsze rozwiązanie dla Twojego pupila!',
    uploadFiles: 'Załącz pliki',
    maxVideoSize: 'Maksymalny rozmiar plików wideo: 50 mb',
    healthDescriptionLabel: 'Opis stanu zdrowia',
    healthDescriptionPlaceholder:
      'Opisz dolegliwości, choroby lub inne ważne kwestie o których powinien wiedzieć specjalista',
    petNameField: 'Imię',
    phoneOptionalHint:
      'Podając nam swój numer telefonu, pomożesz nam na szybszy kontakt w celu przekazania informacji lub zmian w związku z umówioną wizytą. Numer telefonu nie jest wymagany do umówienia wizyty',
    termsCheckbox: 'Akceptuję regulamin oraz politykę prywatności',
    existingUserTitle:
      'Użytkownik o podanym adresie e-mail już istnieje w naszym systemie',
    existingUserBody: 'Zaloguj się do aplikacji w celu umówienia wizyty',
    close: 'Zamknij',
    login: 'Zaloguj się',
    medicationsIntro: 'Leki:',
    medIntervalDay: 'dziennie',
    medIntervalWeek: 'tygodniowo',
    medIntervalMonth: 'miesięcznie',
    currencySuffix: 'zł',
  },
  hardcoded: {
    stworz_notatke: 'Stwórz notatkę...',
    opis_dokumentow: 'Opis dokumentów',
    dodaj_opis_ktory_pomoze_w_wyszukiwaniu_i_analizie:
      'Dodaj opis, który pomoże w wyszukiwaniu i analizie dokumentów...',
    ten_sam_opis_zostanie_dodany_do_wszystkich_przeslanych:
      'Ten sam opis zostanie dodany do wszystkich przesłanych plików',
    obslugiwane_kategorie_zwierzat: 'Obsługiwane kategorie zwierząt',
    na_ten_moment_oferujemy_spotkania_wylacznie_z_behawiorysta:
      'Na ten moment oferujemy spotkania wyłącznie z behawiorystą specjalizującym się w pracy z psami. Wkrótce dodamy możliwość umawiania wizyt dla kolejnych kategorii zwierząt.',
    np_krolik_chomik_papuga: 'Np. Królik, Chomik, Papuga...',
    jak_oceniasz_specjaliste: 'Jak oceniasz specjalistę?',
    jak_oceniasz_placowke: 'Jak oceniasz placówkę?',
    zostaw_opinie: 'Zostaw opinię',
    usuniecie_specjalizacji: 'Usunięcie specjalizacji',
    usuniecie_specjalizacji_z_placowki: 'Usunięcie specjalizacji z placówki',
    wybrane_specjalizacje_maja_przypisane_uslugi_w_ustawieniach_wizyt:
      'Wybrane specjalizacje mają przypisane usługi w ustawieniach wizyt. Usunięcie specjalizacji spowoduje usunięcie',
    uslugi: 'usługi',
    uslug: 'usług',
    wybrane_specjalizacje_maja_przypisane_uslugi_u_profesjonalistow_w:
      'Wybrane specjalizacje mają przypisane usługi u profesjonalistów w tej placówce. Usunięcie specjalizacji spowoduje usunięcie',
    profesjonalistow: 'profesjonalistów',
    nastepujace_uslugi_zostana_usuniete: 'Następujące usługi zostaną usunięte:',
    wplyw_na_profesjonalistow: 'Wpływ na profesjonalistów:',
    usluga: 'usługa',
    uslugi_beda_mozna_ponownie_wlaczyc_po_przywroceniu_specjalizacji:
      'Usługi będą można ponownie włączyć po przywróceniu specjalizacji.',
    potwierdz_usuniecie: 'Potwierdź usunięcie',
    wierszy_na_strone: 'Wierszy na stronę',
    podsumowanie_zabiegow: 'Podsumowanie zabiegów',
    liczba_zabiegow: 'Liczba zabiegów:',
    edytuj_zdjecie: 'Edytuj zdjęcie',
    dodaj_zdjecie: 'Dodaj zdjęcie',
    wlasciciel: 'WŁAŚCICIEL',
    szczegoly_wizyty: 'SZCZEGÓŁY WIZYTY',
    opis_wizyty_zgloszony_przez_wlasciciela:
      'OPIS WIZYTY ZGŁOSZONY PRZEZ WŁAŚCICIELA',
    czestotliwosc: 'Częstotliwość:',
    zywienie: 'Żywienie',
    ogolne: 'Ogólne',
    krolik: 'Królik',
    wysylanie_pliku: 'Wysyłanie pliku...',
    nie_moglismy_dodac_zalacznikow: 'Nie mogliśmy dodać załączników',
    podaj_adres_e_mail_aby_utworzyc_konto:
      'Podaj adres e-mail, aby utworzyć konto.',
    podaj_adres_e_mail_aby_oplacic_wizyte:
      'Podaj adres e-mail, aby opłacić wizytę.',
    wizyty_online_wymagaja_zalogowania_sie:
      'Wizyty online wymagają zalogowania się.',
    wybierz_placowke: 'Wybierz placówkę',
    moje_placowki: 'Moje placówki',
    placowka_jest_w_trakcie_weryfikacji: 'Placówka jest w trakcie weryfikacji',
    jestes_wlascicielem_tej_placowki: 'Jesteś właścicielem tej placówki',
    ustawienia_placowki: 'Ustawienia placówki',
    rezerwujesz_bez_czekania_na_polaczenie:
      'Rezerwujesz bez czekania na połączenie',
    widzisz_grafik_weterynarza_i_rezerwujesz_termin_jednym_kliknieciem:
      'Widzisz grafik weterynarza i rezerwujesz termin jednym kliknięciem. Koniec z wiszeniem na słuchawce. O wizycie dodatkowo Ci przypomnimy.',
    zdarza_ci_sie_przegapic_szczepienia_pamietasz_o_odrobaczaniu:
      'Zdarza Ci się przegapić szczepienia? Pamiętasz o odrobaczaniu? System sam przypomni Ci o nadchodzących terminach i ważnych datach. O urodzinach pupila również!',
    masz_pelna_kontrole_nad_zdrowiem: 'Masz pełną kontrolę nad zdrowiem',
    niezaleznie_od_tego_gdzie_leczysz_pupila_w_vetsi:
      'Niezależnie od tego, gdzie leczysz pupila, w Vetsi trzymasz całą historię w jednym miejscu. Wgraj wyniki badań i zalecenia od różnych weterynarzy, aby mieć pełny obraz zdrowia i bezpieczeństwo w nagłych sytuacjach.',
    twoj_zwierzak_stresuje_sie_innymi_psami_uprzedz_klinike:
      'Twój zwierzak stresuje się innymi psami? Uprzedź klinikę jednym kliknięciem przy rezerwacji, aby weterynarz mógł zapewnić Wam spokojne wejście.',
    dlaczego_warto_zalozyc_darmowe_konto:
      'Dlaczego warto założyć darmowe konto?',
    umow_wizyte_vetsi: 'Umów wizytę | Vetsi',
    nieprawidlowy_link_zaproszenia_brak_identyfikatora_specjalisty:
      'Nieprawidłowy link zaproszenia. Brak identyfikatora specjalisty.',
    dokumenty_zostaly_zaakceptowane: 'Dokumenty zostały zaakceptowane',
    wystapil_blad_podczas_akceptacji_dokumentow:
      'Wystąpił błąd podczas akceptacji dokumentów',
    zaktualizowalismy_nasz_regulamin_i_polityke_prywatnosci_aby_kontynuowac:
      'Zaktualizowaliśmy nasz regulamin i politykę prywatności. Aby kontynuować korzystanie z serwisu, prosimy o zapoznanie się z nowymi warunkami i ich akceptację.',
    przeczytaj_polityke_prywatnosci: 'Przeczytaj politykę prywatności',
    akceptuje: 'Akceptuję',
    konto_zostalo_zamkniete: 'Konto zostało zamknięte',
    twoje_konto_zostalo_dezaktywowane_i_zostanie_trwale_usuniete:
      'Twoje konto zostało dezaktywowane i zostanie trwale usunięte w ciągu 30 dni.',
    jesli_zmienisz_zdanie_skontaktuj_sie_z_nami_przed:
      'Jeśli zmienisz zdanie, skontaktuj się z nami przed upływem tego terminu, aby odzyskać dostęp do konta.',
    powrot_do_strony_logowania: 'Powrót do strony logowania',
    potwierdz_email_vetsi: 'Potwierdź email | Vetsi',
    zmiana_hasla_vetsi: 'Zmiana hasła | Vetsi',
    musisz_zweryfikowac_swoj_adres_e_mail_przed_kontynuowaniem:
      'Musisz zweryfikować swój adres e-mail przed kontynuowaniem.',
    konto_oczekuje_na_usuniecie: 'Konto oczekuje na usunięcie',
    twoje_konto_zostalo_oznaczone_do_usuniecia_i_zostanie:
      'Twoje konto zostało oznaczone do usunięcia i zostanie trwale usunięte w ciągu 30 dni od momentu zgłoszenia.',
    jesli_chcesz_anulowac_usuniecie_konta_skontaktuj_sie_z:
      'Jeśli chcesz anulować usunięcie konta, skontaktuj się z nami pod adresem',
    przed_uplywem_tego_terminu: 'przed upływem tego terminu.',
    polityka_prywatnosci: 'Polityka Prywatności',
    nie_udalo_sie_zaladowac_polityki_prywatnosci_sprobuj_ponownie:
      'Nie udało się załadować polityki prywatności. Spróbuj ponownie później.',
    polityka_prywatnosci_dostepna_pod_adresem:
      'Polityka prywatności dostępna pod adresem:',
    polityka_prywatnosci_nie_jest_jeszcze_dostepna:
      'Polityka prywatności nie jest jeszcze dostępna.',
    rejestracja_placowki_vetsi: 'Rejestracja Placówki | Vetsi',
    nie_udalo_sie_zaladowac_regulaminu_sprobuj_ponownie_pozniej:
      'Nie udało się załadować regulaminu. Spróbuj ponownie później.',
    regulamin_dostepny_pod_adresem: 'Regulamin dostępny pod adresem:',
    regulamin_nie_jest_jeszcze_dostepny: 'Regulamin nie jest jeszcze dostępny.',
    zaplanuj_wizyte: 'Zaplanuj wizytę',
    zaplanuj_wizyte_vetsi: 'Zaplanuj wizytę | Vetsi',
    wypelnij_formularz_vetsi: 'Wypełnij formularz | Vetsi',
    tresc_pytania_jest_wymagana: 'Treść pytania jest wymagana',
    zapytanie_zostalo_wyslane: 'Zapytanie zostało wysłane!',
    wystapil_blad_podczas_wysylania_pytania:
      'Wystąpił błąd podczas wysyłania pytania.',
    profil_jest_obecnie_weryfikowany_przez_nasz_zespol_w:
      'Profil jest obecnie weryfikowany przez nasz zespół. W ciągu 24 godzin skontaktujemy się z Tobą telefonicznie lub mailowo, aby dokończyć proces.',
    tresc_pytania: 'Treść pytania',
    wyslij: 'Wyślij',
    nie_udalo_sie_zaladowac_faktu_o_zwierzetach:
      'Nie udało się załadować faktu o zwierzętach',
    fakt_o_zwierzetach: 'Fakt o zwierzętach',
    powrot_do_strony_glownej: 'Powrót do strony głównej',
    nie_znaleziono_zawartosci: 'Nie znaleziono zawartości',
    nie_znaleziono_faktu_o_zwierzetach: 'Nie znaleziono faktu o zwierzętach',
    ladowanie_vetsi: 'Ładowanie... | Vetsi',
    produkt_nie_zostal_znaleziony: 'Produkt nie został znaleziony',
    powrot_do_listy_produktow: 'Powrót do listy produktów',
    szczegoly_produktu: 'Szczegóły produktu',
    brak_zdjecia: 'Brak zdjęcia',
    jak_dziala: 'Jak działa',
    pojemnosc: 'Pojemność',
    sklad: 'Skład',
    brak_danych_o_skladzie_produktu: 'Brak danych o składzie produktu.',
    pojemnosc_opakowania: 'Pojemność opakowania',
    brak_danych_o_pojemnosci_opakowania: 'Brak danych o pojemności opakowania.',
    biezacy_miesiac: 'Bieżący miesiąc',
    poprzedni_miesiac: 'Poprzedni miesiąc',
    statystyki_zostaly_wygenerowane_ponownie:
      'Statystyki zostały wygenerowane ponownie',
    blad_podczas_generowania_statystyk: 'Błąd podczas generowania statystyk',
    odswiez: 'Odśwież',
    nadchodzace_wizyty_vetsi: 'Nadchodzące wizyty | Vetsi',
    uzupelnianie_konta_vetsi: 'Uzupełnianie Konta | Vetsi',
    uzupelnij_swoje_konto_i_korzystaj_ze_wszystkich_mozliwosci:
      'Uzupełnij swoje konto i korzystaj ze wszystkich możliwości',
    zaproszenia_do_placowek: 'Zaproszenia do placówek',
    zapros: 'Zaproś',
    grafik_placowki: 'Grafik placówki',
    ustawienia_w_placowce_vetsi: 'Ustawienia w placówce | Vetsi',
    uzytkownicy: 'Użytkownicy',
    asystnet_vetsi_posiada_wszystkie_informacje_na_temat_historii:
      'Asystnet Vetsi posiada wszystkie informacje na temat historii leczenia, leków oraz dokumentacji medycznej tego pacjenta.',
    specjalisci_vetsi: 'Specjaliści | Vetsi',
    platnosc_potwierdzona_vetsi: 'Płatność potwierdzona | Vetsi',
    platnosc_zostala_przyjeta: 'Płatność została przyjęta',
    twoja_kampania_google_ads_zostanie_uruchomiona_wkrotce_mozesz:
      'Twoja kampania Google Ads zostanie uruchomiona wkrótce. Możesz śledzić jej postępy na stronie kampanii.',
    przejdz_do_kampanii: 'Przejdź do kampanii',
    budzet_i_harmonogram: 'Budżet i harmonogram',
    podsumowanie_i_platnosc: 'Podsumowanie i płatność',
    przekierowanie_do_platnosci: 'Przekierowanie do płatności...',
    kampania_zostala_aktywowana: 'Kampania została aktywowana!',
    blad_podczas_tworzenia_kampanii: 'Błąd podczas tworzenia kampanii',
    utworz_nowa_kampanie: 'Utwórz nową kampanię',
    skonfiguruj_kampanie_google_ads_dla_swojej_organizacji:
      'Skonfiguruj kampanię Google Ads dla swojej organizacji',
    oczekuje_na_platnosc: 'Oczekuje na płatność',
    budzet_dzienny: 'Budżet dzienny',
    budzet_calkowity: 'Budżet całkowity',
    data_rozpoczecia: 'Data rozpoczęcia',
    data_zakonczenia: 'Data zakończenia',
    slowa_kluczowe: 'Słowa kluczowe (',
    zaplac: 'Zapłać',
    wznow: 'Wznów',
    wydajnosc_kampanii: 'Wydajność kampanii',
    brak_danych_o_wydajnosci_utworz_i_aktywuj_kampanie:
      'Brak danych o wydajności. Utwórz i aktywuj kampanię.',
    wyswietlenia: 'Wyświetlenia',
    klikniecia: 'Kliknięcia',
    sr_cpc: 'Śr. CPC',
    wybierz_kampanie_z_listy_aby_zobaczyc_szczegoly:
      'Wybierz kampanię z listy, aby zobaczyć szczegóły',
    zmien_url_docelowy_reklamy: 'Zmień URL docelowy reklamy',
    nazwa_musi_miec_minimum_3_znaki: 'Nazwa musi mieć minimum 3 znaki',
    nazwa_moze_miec_maksymalnie_100_znakow:
      'Nazwa może mieć maksymalnie 100 znaków',
    opis_moze_miec_maksymalnie_500_znakow:
      'Opis może mieć maksymalnie 500 znaków',
    krotki_opis_celu_kampanii: 'Krótki opis celu kampanii...',
    slowa_kluczowe_2: 'Słowa kluczowe',
    wpisz_slowo_kluczowe_i_nacisnij_enter:
      'Wpisz słowo kluczowe i naciśnij Enter',
    dodaj_slowa_kluczowe_lub_wygeneruj_je_automatycznie:
      'Dodaj słowa kluczowe lub wygeneruj je automatycznie',
    budzet_dzienny_jest_wymagany: 'Budżet dzienny jest wymagany',
    minimalny_budzet_dzienny_to_10_zl: 'Minimalny budżet dzienny to 10 zł',
    maksymalny_budzet_dzienny_to_10_000_zl:
      'Maksymalny budżet dzienny to 10 000 zł',
    data_rozpoczecia_jest_wymagana: 'Data rozpoczęcia jest wymagana',
    data_rozpoczecia_musi_byc_w_przyszlosci:
      'Data rozpoczęcia musi być w przyszłości',
    data_zakonczenia_jest_wymagana: 'Data zakończenia jest wymagana',
    data_zakonczenia_musi_byc_po_dacie_rozpoczecia:
      'Data zakończenia musi być po dacie rozpoczęcia',
    podsumowanie_budzetu: 'Podsumowanie budżetu',
    budzet_dzienny_2: 'Budżet dzienny:',
    calkowity_budzet: 'Całkowity budżet:',
    sprawdz_szczegoly_kampanii_przed_dokonaniem_platnosci_po_oplaceniu:
      'Sprawdź szczegóły kampanii przed dokonaniem płatności. Po opłaceniu kampania zostanie automatycznie aktywowana w wybranym terminie.',
    znizka: 'Zniżka',
    zl: 'zł)',
    kwota_do_zaplaty_po_rabacie: 'Kwota do zapłaty (po rabacie)',
    szacowany_koszt_calkowity: 'Szacowany koszt całkowity',
    kwota_obejmuje_calkowity_budzet_kampanii_na_caly_okres:
      'Kwota obejmuje całkowity budżet kampanii na cały okres jej trwania.',
    zaplac_i_aktywuj: 'Zapłać i aktywuj',
    budzet: 'Budżet',
    kampania_zostala_utworzona: 'Kampania została utworzona',
    budzet_kampanii_zostal_zaktualizowany:
      'Budżet kampanii został zaktualizowany',
    blad_podczas_aktualizacji_budzetu: 'Błąd podczas aktualizacji budżetu',
    blad_podczas_generowania_slow_kluczowych:
      'Błąd podczas generowania słów kluczowych',
    url_reklamy_zostal_zaktualizowany: 'URL reklamy został zaktualizowany',
    blad_podczas_aktualizacji_url_reklamy:
      'Błąd podczas aktualizacji URL reklamy',
    blad_podczas_inicjowania_platnosci: 'Błąd podczas inicjowania płatności',
    kampania_zostala_wstrzymana: 'Kampania została wstrzymana',
    blad_podczas_wstrzymywania_kampanii: 'Błąd podczas wstrzymywania kampanii',
    kampania_zostala_wznowiona: 'Kampania została wznowiona',
    blad_podczas_wznawiania_kampanii: 'Błąd podczas wznawiania kampanii',
    kampania_zostala_anulowana: 'Kampania została anulowana',
    blad_podczas_anulowania_kampanii: 'Błąd podczas anulowania kampanii',
    kampania_zostala_usunieta: 'Kampania została usunięta',
    blad_podczas_usuwania_kampanii: 'Błąd podczas usuwania kampanii',
    aby_przeprowadzic_wizyte_wymagany_jest_dostep_do_kamery:
      'Aby przeprowadzić wizytę wymagany jest dostęp do kamery i mikrofonu',
    wystapil_problem_z_dolaczeniem_do_rozmowy:
      'Wystąpił problem z dołączeniem do rozmowy',
    uprawnienia_zostaly_przyznane_pomyslnie:
      'Uprawnienia zostały przyznane pomyślnie!',
    nie_udalo_sie_uzyskac_uprawnien_wlacz_uprawnienia_w:
      'Nie udało się uzyskać uprawnień. Włącz uprawnienia w ustawieniach przeglądarki i odśwież stronę.',
    dostep_do_kamery_i_mikrofonu: 'Dostęp do kamery i mikrofonu',
    abysmy_mogli_zapewnic_ci_najwyzsza_jakosc_obslugi_podczas:
      'Abyśmy mogli zapewnić Ci najwyższą jakość obsługi podczas e-spotkania z naszym specjalistą, prosimy o włączenie dostępu do kamery oraz mikrofonu. Te elementy są obowiązkowe, aby nasze spotkanie mogło się odbyć i przebiegać sprawnie.',
    jesli_uprawnienia_zostaly_wczesniej_zablokowane_wlacz_je_w:
      'Jeśli uprawnienia zostały wcześniej zablokowane, włącz je w ustawieniach przeglądarki i odśwież stronę.',
    ponizej_znajdziesz_linki_do_instrukcji_ktore_pomoga_ci:
      'Poniżej znajdziesz linki do instrukcji, które pomogą Ci w udzieleniu dostępu w różnych przeglądarkach:',
    zadanie_uprawnien: 'Żądanie uprawnień...',
    zezwol_na_dostep: 'Zezwól na dostęp',
    odswiez_strone: 'Odśwież stronę',
    zalacznik_pliku: 'Załącznik pliku',
    opcje_wpisz_i_nacisnij_enter: 'Opcje (wpisz i naciśnij Enter)',
    wielokrotny_wybor: 'Wielokrotny wybór',
    odpowiedz_wlasna: 'Odpowiedź własna',
    utworz_formularz: 'Utwórz formularz',
    formularz_zostal_wyslany: 'Formularz został wysłany',
    szkic_zostal_zapisany: 'Szkic został zapisany',
    wystapil_blad_podczas_zapisywania: 'Wystąpił błąd podczas zapisywania',
    formularz_nie_zostal_znaleziony: 'Formularz nie został znaleziony.',
    ten_formularz_zostal_juz_wyslany: 'Ten formularz został już wysłany.',
    wpisz_odpowiedz: 'Wpisz odpowiedź',
    usun_formularz: 'Usuń formularz',
    czy_na_pewno_chcesz_usunac_ten_formularz_ta:
      'Czy na pewno chcesz usunąć ten formularz? Ta operacja jest nieodwracalna.',
    brak_formularzy_utworz_nowy_formularz_aby_rozpoczac:
      'Brak formularzy. Utwórz nowy formularz, aby rozpocząć.',
    formularz_zostal_utworzony: 'Formularz został utworzony',
    wystapil_blad_podczas_tworzenia_formularza:
      'Wystąpił błąd podczas tworzenia formularza',
    formularz_zostal_zaktualizowany: 'Formularz został zaktualizowany',
    wystapil_blad_podczas_aktualizacji_formularza:
      'Wystąpił błąd podczas aktualizacji formularza',
    formularz_zostal_usuniety: 'Formularz został usunięty',
    wystapil_blad_podczas_usuwania_formularza:
      'Wystąpił błąd podczas usuwania formularza',
    dowiedz_sie_wiecej: 'Dowiedz się więcej',
    zaproszenie_zostalo_zaakceptowane: 'Zaproszenie zostało zaakceptowane',
    czy_na_pewno_chcesz_zaakceptowac_zaproszenie_do_placowki:
      'Czy na pewno chcesz zaakceptować zaproszenie do placówki?',
    zaproszenie_zostalo_odrzucone: 'Zaproszenie zostało odrzucone',
    odrzucic_zaproszenie: 'Odrzucić zaproszenie',
    czy_na_pewno_chcesz_odrzucic_zaproszenie_do_placowki:
      'Czy na pewno chcesz odrzucić zaproszenie do placówki?',
    wyslano: 'Wysłano',
    nie_moglismy_pobrac_zaproszen: 'Nie mogliśmy pobrać zaproszeń',
    brak_zaproszen: 'Brak zaproszeń',
    odwolujesz_wizyte: 'Odwołujesz wizytę?',
    przerywasz_wizyte: 'Przerywasz wizytę?',
    wlasciciel_pupila_oraz_specjalista_zostana_poinformowani_o_odwolaniu:
      'Właściciel pupila oraz specjalista zostaną poinformowani o odwołaniu tej wizyty. Termin u tego specjalisty ponownie będzie dostępny.',
    wlasciciel_pupila_oraz_specjalista_zostana_poinformowani_o_przerwaniu_wizyty:
      'Właściciel pupila zostanie poinformowany o przerwaniu wizyty wraz z podanym powodem.',
    nie_znaleziono_placowki: 'Nie znaleziono placówki',
    czy_na_pewno_chcesz_usunac_organizacje:
      'Czy na pewno chcesz usunąć organizację?',
    nieprawidlowy_adres_url: 'Nieprawidłowy adres URL',
    wybierz_przynajmniej_jedna_specjalizacje:
      'Wybierz przynajmniej jedną specjalizację',
    specjalizacje_sa_wymagane: 'Specjalizacje są wymagane',
    nieprawidlowy_adres_email: 'Nieprawidłowy adres email',
    organizacja_zostala_zaktualizowana: 'Organizacja została zaktualizowana',
    widocznosc_zostala_zaktualizowana: 'Widoczność została zaktualizowana',
    nie_udalo_sie_zaktualizowac_widocznosci:
      'Nie udało się zaktualizować widoczności',
    zdjecie_zostalo_juz_dodane: 'Zdjęcie zostało już dodane',
    zdjecie_zostalo_usuniete: 'Zdjęcie zostało usunięte',
    nie_udalo_sie_usunac_zdjecia: 'Nie udało się usunąć zdjęcia',
    zdjecia_zostaly_dodane: 'Zdjęcia zostały dodane',
    nie_udalo_sie_zapisac_zdjec: 'Nie udało się zapisać zdjęć',
    trwa_weryfikacja_ograniczona_funkcjonalnosc:
      'Trwa weryfikacja. Ograniczona funkcjonalność.',
    widocznosc_placowki: 'Widoczność Placówki',
    jak_kontrolowac_widocznosc_placowki: 'Jak kontrolować widoczność placówki?',
    tym_przyciskiem_mozesz_kontrolowac_widocznosc_placowki_w_wynikach:
      'Tym przyciskiem możesz kontrolować widoczność placówki w wynikach wyszukiwania. Jeśli placówka zostanie ustawiona jako niewidoczna, użytkownicy nie będą mogli jej wyszukać i umówić wizyty. Jedynie osoby posiadające bezpośredni link do wizytówki będą mogły ją znaleźć i umówić wizytę.',
    opis_placowki: 'Opis placówki...',
    zdjecia_placowki: 'Zdjęcia placówki',
    dodaj_zdjecia_placowki: 'Dodaj zdjęcia placówki',
    organizacja_zostala_usunieta: 'Organizacja została usunięta',
    probujesz_usunac_organizacje: 'Próbujesz usunąć organizację',
    czy_na_pewno_chcesz_usunac_organizacje_ta_akcja:
      'Czy na pewno chcesz usunąć organizację? Ta akcja jest nieodwracalna i spowoduje trwałe usunięcie organizacji.',
    status_zostal_zmieniony: 'Status został zmieniony',
    probujesz_deaktywowac_organizacje: 'Próbujesz deaktywować organizację',
    probujesz_aktywowac_organizacje: 'Próbujesz aktywować organizację',
    deaktywowac: 'deaktywować',
    aktywowac: 'aktywować',
    organizacje_ta_akcja_spowoduje: 'organizację? Ta akcja spowoduje',
    organizacji_w_wyszukiwarce_przez_co_bedzie:
      'organizacji w wyszukiwarce, przez co będzie',
    dla_uzytkownikow_aplikacji: 'dla użytkowników aplikacji.',
    ustawienia_w_placowce_zostaly_zaktualizowane:
      'Ustawienia w placówce zostały zaktualizowane',
    twoj_opis: 'Twój opis...',
    email_jest_nieprawidlowy: 'Email jest nieprawidłowy',
    wybierz_co_najmniej_jedna_role: 'Wybierz co najmniej jedną rolę',
    role_sa_wymagane: 'Role są wymagane',
    ten_uzytkownik_posiada_juz_zaproszenie_do_twojej_placowki:
      'Ten użytkownik posiada już zaproszenie do Twojej placówki. Wysłano przypomnienie.',
    zaproszenie_zostalo_wyslane: 'Zaproszenie zostało wysłane',
    zapros_uzytkownika: 'Zaproś użytkownika',
    na_podany_adres_email_zostanie_wyslane_zaproszenie_do:
      'Na podany adres email zostanie wysłane zaproszenie do placówki',
    imie_i_nazwisko: 'Imię i nazwisko',
    wyslij_ponownie_zaproszenie: 'Wyślij ponownie zaproszenie',
    czy_na_pewno_chcesz_wyslac_ponownie_zaproszenie_do:
      'Czy na pewno chcesz wysłać ponownie zaproszenie do placówki?',
    nie_moglismy_pobrac_uzytkownikow: 'Nie mogliśmy pobrać użytkowników',
    brak_uzytkownikow: 'Brak użytkowników',
    wystapil_blad_podczas_usuwania_profilu:
      'Wystąpił błąd podczas usuwania profilu',
    nie_mozna_usunac_profilu_z_zaplanowanymi_wizytami:
      'Nie można usunąć profilu z zaplanowanymi wizytami',
    twoj_zwierzak_zostal_usuniety: 'Twój zwierzak został usunięty',
    probujesz_usunac_swojego_zwierzaka: 'Próbujesz usunąć swojego zwierzaka',
    czy_na_pewno_chcesz_usunac_zwierzaka_z_listy:
      'Czy na pewno chcesz usunąć zwierzaka z listy? Ta akcja jest nieodwracalna i spowoduje trwałe usunięcie zwierzaka.',
    pliki_zostaly_dodane: 'Pliki zostały dodane',
    wystapil_blad_podczas_dodawania_plikow:
      'Wystąpił błąd podczas dodawania plików',
    dokument_zostal_usuniety: 'Dokument został usunięty',
    wystapil_blad_podczas_usuwania_dokumentu:
      'Wystąpił błąd podczas usuwania dokumentu',
    plik: 'Plik',
    notatka: 'Notatka',
    kopiuj: 'Kopiuj',
    skopiowano_do_schowka: 'Skopiowano do schowka',
    nie_udalo_sie_skopiowac: 'Nie udało się skopiować',
    notatka_tekstowa: 'Notatka tekstowa',
    nowa_notatka_tekstowa: 'Nowa notatka tekstowa',
    edytuj_notatke_tekstowa: 'Edytuj notatkę tekstową',
    notatka_zostala_dodana: 'Notatka została dodana',
    notatka_zostala_zaktualizowana: 'Notatka została zaktualizowana',
    notatka_tekstowa_dodana_potwierdzenie:
      'Notatka dodana do edytora. Pamiętaj, aby ją zapisać.',
    wystapil_blad_podczas_zapisywania_notatki:
      'Wystąpił błąd podczas zapisywania notatki',
    wystapil_nieoczekiwany_blad: 'Wystąpił nieoczekiwany błąd',
    nastepna_wizyta: 'Następna wizyta',
    brak_pacjentow: 'Brak pacjentów',
    nie_moglismy_pobrac_danych: 'Nie mogliśmy pobrać danych',
    zakonczone_wizyty: 'Zakończone wizyty',
    opis_uslugi: 'Opis usługi',
    automatycznie_zaakceptuj_wizyte: 'Automatycznie zaakceptuj wizytę',
    jesli_opcja_automatycznej_akceptacji_zostanie_odznaczona_opiekun_bedzie:
      'Jeśli opcja automatycznej akceptacji zostanie odznaczona, opiekun będzie musiał sam potwierdzić umówioną wizytę w ciągu 60 min. Jeśli tego nie zrobi, wizyta zostanie automatycznie anulowana a godzina tej wizyty będzie ponownie dostępna.',
    platnosc_za_wybrana_usluge_zostanie_zrealizowana_przez_opiekuna:
      'Płatność za wybraną usługę zostanie zrealizowana przez opiekuna.',
    znajdz_opiekuna: 'Znajdź opiekuna',
    wyszukuje_opiekunow_tej_placowki_po_imieniu_nazwisku_adresie:
      'Wyszukuje opiekunów tej placówki po imieniu, nazwisku, adresie email lub numerze telefonu.',
    platna_wizyta_wymaga_podania_adresu_e_mail_potrzebny:
      'Płatna wizyta wymaga podania adresu e-mail (potrzebny do płatności). Numer telefonu jest opcjonalny.',
    aby_umowic_wizyte_nalezy_podac_adres_email_i:
      'Aby umówić wizytę należy podać adres email i/lub numer telefonu na który zostaną wysłane szczegóły odnośnie umówionej wizyty.',
    utworz_konto_vetsi_dla_tego_opiekuna:
      'Utwórz konto Vetsi dla tego opiekuna',
    domyslnie_wizyta_jest_zapisywana_jako_goscinna_opiekun_nie:
      'Domyślnie wizyta jest zapisywana jako gościnna, a opiekun nie otrzymuje konta. Zaznacz, aby założyć mu konto i wysłać link do ustawienia hasła.',
    ukonczone: 'Ukończone',
    wizyty_wedlug_specjalisty: 'Wizyty według specjalisty',
    ukonczone_wizyty: 'Ukończone wizyty',
    oczekujace_na_akceptacje: 'Oczekujące na akceptację',
    stosunek_ukonczonych_do_anulowanych: 'Stosunek ukończonych do anulowanych',
    wskaznik_ukonczenia_wizyt: 'Wskaźnik ukończenia wizyt',
    srednia_ocena: 'Średnia ocena',
    powracajacy_pacjenci: 'Powracający pacjenci',
    powiazane_leki: 'Powiązane leki',
    wpisz_nazwe_leku: 'Wpisz nazwę leku...',
    brak_wynikow: 'Brak wyników',
    brak_zabiegow_w_katalogu: 'Brak zabiegów w katalogu',
    wierszy_na_strone_2: 'Wierszy na stronę:',
    katalog_zabiegow: 'Katalog zabiegów',
    sporzadzone_notatki_podczas_wizyty_zostana_wyslane_do_wlasciciela:
      'Sporządzone notatki podczas wizyty zostaną wysłane do właściciela zwierzaka. W każdej chwili po zakończeniu wizyty możesz je edytować.',
    zakoncz_i_wyslij: 'Zakończ i wyślij',
    notatki_zostaly_zaktualizowane: 'Notatki zostały zaktualizowane',
    wystapil_blad_podczas_aktualizacji_notatek:
      'Wystąpił błąd podczas aktualizacji notatek',
    notatki_wewnetrzne_zostaly_zaktualizowane:
      'Notatki wewnętrzne zostały zaktualizowane',
    brak_wypelnionych_formularzy_dla_tej_wizyty:
      'Brak wypełnionych formularzy dla tej wizyty.',
    nie_udalo_sie_otworzyc_dokumentu: 'Nie udało się otworzyć dokumentu',
    podsumowanie_wygenerowane_i_dodane_do_dokumentow_wizyty:
      'Podsumowanie wygenerowane i dodane do dokumentów wizyty',
    blad_podczas_dodawania_do_profilu: 'Błąd podczas dodawania do profilu',
    blad_podczas_generowania_podsumowania:
      'Błąd podczas generowania podsumowania',
    podsumowanie_zostalo_juz_wygenerowane_aby_wygenerowac_nowe_zaktualizuj:
      'Podsumowanie zostało już wygenerowane. Aby wygenerować nowe, zaktualizuj informacje dotyczące wizyty.',
    brak_dostepnego_podsumowania: 'Brak dostępnego podsumowania.',
    usunieto: 'Usunięto',
    brak_dokumentow_przypisanych_podczas_tej_wizyty:
      'Brak dokumentów przypisanych podczas tej wizyty',
    miesiecznie: 'Miesięcznie',
    czestotliwosc_2: 'Częstotliwość',
    dawka: 'Dawka',
    nie_udalo_sie_wygenerowac_pdf: 'Nie udało się wygenerować PDF',
    brak_zabiegow_przypisanych_podczas_tej_wizyty:
      'Brak zabiegów przypisanych podczas tej wizyty',
    usluga_dodana_pomyslnie: 'Usługa dodana pomyślnie',
    blad_podczas_dodawania_uslugi: 'Błąd podczas dodawania usługi',
    usluga_zaktualizowana_pomyslnie: 'Usługa zaktualizowana pomyślnie',
    blad_podczas_aktualizacji_uslugi: 'Błąd podczas aktualizacji usługi',
    usluga_usunieta_pomyslnie: 'Usługa usunięta pomyślnie',
    blad_podczas_usuwania_uslugi: 'Błąd podczas usuwania usługi',
    prosze_wypelnic_wszystkie_wymagane_pola:
      'Proszę wypełnić wszystkie wymagane pola',
    lista_uslug: 'Lista usług (',
    uslug_2: 'usług)',
    brak_uslug_kliknij_dodaj_aby_stworzyc_pierwsza_usluge:
      'Brak usług. Kliknij "Dodaj" aby stworzyć pierwszą usługę.',
    edytuj_usluge: 'Edytuj usługę',
    dodaj_usluge: 'Dodaj usługę',
    wybierz_specjalizacje_skonfigurowana_w_organizacji:
      'Wybierz specjalizację skonfigurowaną w organizacji',
    brak_dostepnych_specjalizacji_dla_tej_kategorii:
      'Brak dostępnych specjalizacji dla tej kategorii',
    nazwa_uslugi: 'Nazwa usługi',
    np_badanie_ogolne_szczepienie_konsultacja:
      'np. Badanie ogólne, Szczepienie, Konsultacja',
    dodatkowe_informacje_o_usludze: 'Dodatkowe informacje o usłudze...',
    zmiany_zostana_zapisane_i_zaktualizowane_w_liscie_uslug:
      'Zmiany zostaną zapisane i zaktualizowane w liście usług.',
    usluga_zostanie_utworzona_i_automatycznie_dodana_do_listy:
      'Usługa zostanie utworzona i automatycznie dodana do listy dostępnych usług w Twojej organizacji.',
    usuniecie_uslugi_z_placowki: 'Usunięcie usługi z placówki',
    ustawienia_wizyt_zostaly_zaktualizowane:
      'Ustawienia wizyt zostały zaktualizowane',
    blad_podczas_zapisywania_ustawien: 'Błąd podczas zapisywania ustawień',
    twoje_ustawienia_zostaly_zaktualizowane:
      'Twoje ustawienia zostały zaktualizowane',
    wybierz_typy_wizyt_i_skonfiguruj_kategorie_dla_kazdego:
      'Wybierz typy wizyt i skonfiguruj kategorie dla każdego typu',
    wybierz_typy_wizyt_i_kategorie_ktore_obslugujesz:
      'Wybierz typy wizyt i kategorie, które obsługujesz',
    niedostepne_w_placowce: '(Niedostępne w placówce)',
    brak_dostepnych_kategorii_dla_tego_typu_wizyty:
      'Brak dostępnych kategorii dla tego typu wizyty',
    brak_uslug_dla_kategorii: 'Brak usług dla kategorii "',
    administrator_placowki_nie_dodal_jeszcze_uslug_dla_tej:
      'Administrator placówki nie dodał jeszcze usług dla tej kategorii. Skontaktuj się z administratorem, aby dodał odpowiednie usługi.',
    brak_dostepnych_uslug: 'Brak dostępnych usług',
    administrator_placowki_nie_dodal_jeszcze_uslug_pasujacych_do:
      'Administrator placówki nie dodał jeszcze usług pasujących do Twoich specjalizacji. Skontaktuj się z administratorem, aby dodał odpowiednie usługi lub sprawdź swoje specjalizacje w zakładce "Szczegóły".',
    uslugi_dla_kategorii: 'Usługi dla kategorii:',
    wybierz_uslugi_ktore_oferujesz_w_tej_kategorii:
      'Wybierz usługi, które oferujesz w tej kategorii',
    pozostaw_puste_aby_uzyc_domyslnego_czasu:
      'Pozostaw puste aby użyć domyślnego czasu',
    formularze_zostaly_zaktualizowane: 'Formularze zostały zaktualizowane',
    blad_podczas_aktualizacji_formularzy:
      'Błąd podczas aktualizacji formularzy',
    brak_formularzy_utworz_je_w_zakladce_formularze:
      'Brak formularzy. Utwórz je w zakładce Formularze.',
    nip_musi_zawierac_10_cyfr: 'NIP musi zawierać 10 cyfr',
    organizacja_zostala_dodana: 'Organizacja została dodana',
    dodaj_organizacje: 'Dodaj organizację',
    specjalisci: '#Specjaliści',
    nie_moglismy_pobrac_organizacji: 'Nie mogliśmy pobrać organizacji',
    zaznacz_biezaca_strone: 'Zaznacz bieżącą stronę',
    ustawienia_zabiegow: 'Ustawienia zabiegów',
    brak_zabiegow: 'Brak zabiegów',
    skladniki: 'Składniki',
    wystapil_blad_podczas_sprawdzania_kompatybilnosci:
      'Wystąpił błąd podczas sprawdzania kompatybilności.',
    wystapil_blad_podczas_sprawdzania_kompatybilnosci_sprobuj_ponownie:
      'Wystąpił błąd podczas sprawdzania kompatybilności. Spróbuj ponownie.',
    sprawdz_czy_produkt_jest_odpowiedni_dla_twojego_pupila:
      'Sprawdź czy produkt jest odpowiedni dla Twojego pupila',
    nie_masz_jeszcze_zadnych_pupili_dodaj_profil_pupila:
      'Nie masz jeszcze żadnych pupili. Dodaj profil pupila, aby sprawdzić dopasowanie produktu.',
    wazne_uwagi: 'Ważne uwagi:',
    pokaz_wiecej: 'Pokaż więcej',
    produkty_naszych_zaufanych_partnerow_dla_twojego_pupila:
      'Produkty naszych zaufanych partnerów dla Twojego pupila',
    trafnosc: 'Trafność',
    cena_od_najnizszej: 'Cena: od najniższej',
    cena_od_najwyzszej: 'Cena: od najwyższej',
    produktow: 'produktów',
    sprobuj_zmienic_kryteria_wyszukiwania:
      'Spróbuj zmienić kryteria wyszukiwania',
    wystapil_blad_podczas_kopiowania_kodu:
      'Wystąpił błąd podczas kopiowania kodu',
    kupon_wazny_do: 'Kupon ważny do:',
    brak_kuponow: 'Brak kuponów',
    aktualnie_nie_mamy_dla_ciebie_kuponow_pracujemy_nad:
      'Aktualnie nie mamy dla Ciebie kuponów, pracujemy nad tym :)',
    ochrona_pupila_w_zasiegu: 'Ochrona pupila w zasięgu',
    lapy: 'łapy',
    twoj_czworonozny_przyjaciel_zasluguje_na_najlepsza_opieke_spraw:
      'Twój czworonożny przyjaciel zasługuje na najlepszą opiekę. Spraw, by każdego dnia był otoczony komfortem oraz poczuciem bezpieczeństwa dzięki Petcover.',
    poznaj_oferte: 'Poznaj ofertę',
    ktore: 'które',
    wymien: 'wymień',
    jakie_sa_mozliwe_diagnozy_dla_tych_objawow:
      'Jakie są możliwe diagnozy dla tych objawów?',
    czy_sa_jakies_interakcje_z_obecnymi_lekami:
      'Czy są jakieś interakcje z obecnymi lekami?',
    jakie_sa_zalecenia_dotyczace_leczenia:
      'Jakie są zalecenia dotyczące leczenia?',
    czy_sa_jakies_ostrzezenia_lub_przeciwwskazania:
      'Czy są jakieś ostrzeżenia lub przeciwwskazania?',
    jakie_sa_typowe_powiklania_w_tym_przypadku:
      'Jakie są typowe powikłania w tym przypadku?',
    jakie_sa_wskazania_do_konsultacji_specjalistycznej:
      'Jakie są wskazania do konsultacji specjalistycznej?',
    jakie_parametry_nalezy_monitorowac: 'Jakie parametry należy monitorować?',
    czy_sa_alternatywne_metody_leczenia: 'Czy są alternatywne metody leczenia?',
    nie_udalo_sie_wyslac_pytania_sprobuj_ponownie:
      'Nie udało się wysłać pytania. Spróbuj ponownie.',
    generujemy_podsumowanie_kliniczne_wkrotce_otrzymasz_szczegolowa_analize:
      'Generujemy podsumowanie kliniczne. Wkrótce otrzymasz szczegółową analizę!',
    diagnoza_roznicowa: 'Diagnoza różnicowa:',
    ostrzezenia: 'Ostrzeżenia:',
    blad_podczas_odwolywania_wizyty: 'Błąd podczas odwoływania wizyty',
    umow_ponownie: 'Umów ponownie',
    przejdz_do_profilu: 'Przejdź do profilu',
    uzupelnij_dodatkowe_dane_profilu_zwierzaka_aby_usprawnic_przebieg:
      'Uzupełnij dodatkowe dane profilu zwierzaka, aby usprawnić przebieg wizyty.',
    uzupelnij_profil_zwierzaka: 'Uzupełnij profil zwierzaka',
    plik_zostal_usuniety: 'Plik został usunięty',
    wystapil_blad_podczas_usuwania_pliku:
      'Wystąpił błąd podczas usuwania pliku',
    nie_moglismy_pobrac_plikow_dla_wskazanego_profilu:
      'Nie mogliśmy pobrać plików dla wskazanego profilu',
    dodawaj_rozne_typy_dokumentacji_medycznej_swojego_pupila_takie:
      'Dodawaj różne typy dokumentacji medycznej swojego pupila, takie jak wyniki badań krwi, zdjęcia RTG, karty szczepień, wyniki USG czy dokumentację wizyt weterynaryjnych. Pomogą one w analizie ogólnego stanu zdrowia Twojego zwierzaka.',
    usun_plik: 'Usuń plik',
    brak_plikow: 'Brak plików',
    najblizsza_wizyta: 'Najbliższa wizyta:',
    usun_lekarstwo: 'Usuń lekarstwo',
    czy_na_pewno_chcesz_usunac_ten_lekarstwo:
      'Czy na pewno chcesz usunąć to lekarstwo?',
    miesiace: 'miesiące',
    dawka_musi_byc_wieksza_od_0: 'Dawka musi być większa od 0',
    nieprawidlowa_czestotliwosc: 'Nieprawidłowa częstotliwość',
    czestotliwosc_jest_wymagana: 'Częstotliwość jest wymagana',
    podglad_lekarstwa: 'Podgląd lekarstwa',
    szczegoly_leku: 'Szczegóły leku',
    postac_farmaceutyczna: 'Postać farmaceutyczna:',
    przypomnienie_podglad: 'Przypomnienie (podgląd)',
    dzien_tygodnia: 'Dzień tygodnia',
    tydzien_miesiaca: 'Tydzień miesiąca',
    rodzaj_powiadomien: 'Rodzaj powiadomień',
    wybierz_co_najmniej_jeden_kanal_powiadomien:
      'Wybierz co najmniej jeden kanał powiadomień',
    mozesz_edytowac_tylko_przypomnienia_dodane_w_ramach_twojej:
      'Możesz edytować tylko przypomnienia dodane w ramach Twojej organizacji.',
    opis_nie_moze_przekraczac_200_znakow:
      'Opis nie może przekraczać 200 znaków',
    dane_twojego_zwierzaka_zostaly_zaktualizowane:
      'Dane Twojego zwierzaka zostały zaktualizowane',
    twoj_zwierzak_zostal_dodany: 'Twój zwierzak został dodany',
    nie_udalo_sie_przeslac_avatara: 'Nie udało się przesłać avatara',
    nieprawidlowa_rasa: 'Nieprawidłowa rasa',
    tylko_specjalisci_moga_przegladac_i_zarzadzac_produktami:
      'Tylko specjaliści mogą przeglądać i zarządzać produktami.',
    przypomnienie_zostalo_dodane: 'Przypomnienie zostało dodane',
    wystapil_blad_podczas_dodawania_przypomnienia:
      'Wystąpił błąd podczas dodawania przypomnienia',
    przypomnienie_zostalo_zaktualizowane:
      'Przypomnienie zostało zaktualizowane',
    wystapil_blad_podczas_aktualizacji_przypomnienia:
      'Wystąpił błąd podczas aktualizacji przypomnienia',
    przypomnienie_zostalo_usuniete: 'Przypomnienie zostało usunięte',
    wystapil_blad_podczas_usuwania_przypomnienia:
      'Wystąpił błąd podczas usuwania przypomnienia',
    usun_przypomnienie: 'Usuń przypomnienie',
    czy_na_pewno_chcesz_usunac_to_przypomnienie_tej:
      'Czy na pewno chcesz usunąć to przypomnienie? Tej operacji nie można cofnąć.',
    opis_moze_miec_maksymalnie_250_znakow:
      'Opis może mieć maksymalnie 250 znaków',
    podaj_prawidlowa_date_i_godzine: 'Podaj prawidłową datę i godzinę',
    data_i_godzina_sa_wymagane: 'Data i godzina są wymagane',
    data_nie_moze_byc_w_przeszlosci: 'Data nie może być w przeszłości',
    nieprawidlowy_typ_powtarzania: 'Nieprawidłowy typ powtarzania',
    wartosc_interwalu_jest_wymagana: 'Wartość interwału jest wymagana',
    podglad_przypomnienia: 'Podgląd przypomnienia',
    dzien_tygodnia_opcjonalnie: 'Dzień tygodnia (opcjonalnie)',
    tydzien_miesiaca_opcjonalnie: 'Tydzień miesiąca (opcjonalnie)',
    niedziele: 'niedzielę',
    srode: 'środę',
    sobote: 'sobotę',
    godzine: 'godzinę',
    dzien: 'dzień',
    tydzien: 'tydzień',
    miesiac: 'miesiąc',
    miesiecy: 'miesięcy',
    brak_przypomnien: 'Brak przypomnień',
    wystapil_blad_podczas_ladowania_rekomendacji:
      'Wystąpił błąd podczas ładowania rekomendacji',
    uzupelnij_profil: 'Uzupełnij profil',
    aby_otrzymywac_spersonalizowane_rekomendacje_dotyczace_zdrowia_i_opieki:
      'Aby otrzymywać spersonalizowane rekomendacje dotyczące zdrowia i opieki nad Twoim pupilem, uzupełnij brakujące informacje w profilu.',
    analizujemy_twoj_profil: ', analizujemy Twój profil',
    nasze_algorytmy_pracuja_nad_stworzeniem_spersonalizowanych_sugestii_opieki:
      'Nasze algorytmy pracują nad stworzeniem spersonalizowanych sugestii opieki. Wkrótce pojawią się tutaj rekomendacje dopasowane do potrzeb Twojego zwierzaka!',
    sredni: 'Średni',
    umow_konsultacje_dietetyczna: 'Umów konsultację dietetyczną',
    usun_zabieg: 'Usuń zabieg',
    czy_na_pewno_chcesz_usunac_ten_zabieg_powiazane:
      'Czy na pewno chcesz usunąć ten zabieg? Powiązane przypomnienie również zostanie usunięte. Tej operacji nie można cofnąć.',
    podglad_zabiegu: 'Podgląd zabiegu',
    mozesz_edytowac_tylko_zabiegi_dodane_w_ramach_twojej:
      'Możesz edytować tylko zabiegi dodane w ramach Twojej organizacji.',
    profil_zostal_utworzony: 'Profil został utworzony',
    czy_chcesz_abym_przekierowal_cie_do_formularza_umowienia:
      'Czy chcesz, abym przekierował Cię do formularza umówienia pierwszej wizyty?',
    pomin: 'Pomiń',
    usun_szablon: 'Usuń szablon',
    czy_na_pewno_chcesz_usunac_ten_szablon:
      'Czy na pewno chcesz usunąć ten szablon?',
    nieprawidlowy_typ_szablonu: 'Nieprawidłowy typ szablonu',
    tresc_jest_wymagana: 'Treść jest wymagana',
    tresc_szablonu: 'Treść szablonu',
    udostepnij_dla_innych_specjalistow_w_twojej_placowce:
      'Udostępnij dla innych specjalistów w Twojej placówce',
    udostepniony: 'Udostępniony',
    brak_szablonow: 'Brak szablonów',
    ogolny: 'Ogólny',
    ocena_wstepna: 'Ocena wstępna',
    nagly_przypadek: 'Nagły przypadek',
    szablon_zostal_utworzony: 'Szablon został utworzony',
    wystapil_blad_podczas_tworzenia_szablonu:
      'Wystąpił błąd podczas tworzenia szablonu',
    szablon_zostal_zaktualizowany: 'Szablon został zaktualizowany',
    wystapil_blad_podczas_aktualizacji_szablonu:
      'Wystąpił błąd podczas aktualizacji szablonu',
    szablon_zostal_usuniety: 'Szablon został usunięty',
    wystapil_blad_podczas_usuwania_szablonu:
      'Wystąpił błąd podczas usuwania szablonu',
    nazwa_placowki_profilu_jest_wymagana:
      'Nazwa placówki/profilu jest wymagana',
    blad_podczas_przesylania_logo: 'Błąd podczas przesyłania logo',
    logo_placowki: 'Logo placówki',
    informacje_o_placowce: 'Informacje o placówce',
    nazwa_placowki_profilu: 'Nazwa placówki/profilu',
    logo_placowki_jest_wymagane_to_kluczowy_element_twojej:
      'Logo placówki jest wymagane. To kluczowy element Twojej marki, który buduje profesjonalny wizerunek i zwiększa zaufanie klientów podczas rezerwacji wizyt. Będzie ono widoczne na Twoim profilu obok nazwy.',
    potwierdz_dane_twojej_placowki: 'Potwierdź dane twojej placówki',
    upewnij_sie_ze_podane_informacje_sa_poprawne_zostana:
      'Upewnij się, że podane informacje są poprawne. Zostaną one zweryfikowane przez nasz zespół w ciągu 24h. Skontaktujemy się z Tobą telefonicznie lub mailowo, aby dokończyć proces. Do momentu zakończenia weryfikacji, wizytówka będzie nieaktywna i niewidoczna dla klientów.',
    stare_haslo_jest_wymagane: 'Stare hasło jest wymagane',
    haslo_musi_miec_minimum_6_znakow: 'Hasło musi mieć minimum 6 znaków',
    haslo_zostalo_zmienione: 'Hasło zostało zmienione',
    stare_haslo: 'Stare hasło',
    fakty_zwiazane_ze_zdrowiem_chorobami_leczeniem_lub_opieka:
      'Fakty związane ze zdrowiem, chorobami, leczeniem lub opieką medyczną nad zwierzętami',
    styl_zycia: 'Styl życia',
    fakty_dotyczace_codziennej_opieki_karmienia_pielegnacji_lub_zycia:
      'Fakty dotyczące codziennej opieki, karmienia, pielęgnacji lub życia ze zwierzętami',
    fakty_o_zachowaniu_zwierzat_treningu_lub_komunikacji:
      'Fakty o zachowaniu zwierząt, treningu lub komunikacji',
    musisz_wybrac_przynajmniej_jeden_typ_faktow:
      'Musisz wybrać przynajmniej jeden typ faktów',
    preferencje_faktow_zostaly_zaktualizowane:
      'Preferencje faktów zostały zaktualizowane',
    nie_udalo_sie_zaktualizowac_preferencji_faktow:
      'Nie udało się zaktualizować preferencji faktów',
    preferencje_tresci_o_zwierzetach: 'Preferencje treści o zwierzętach',
    wybierz_typy_tresci_o_zwierzetach_ktore_chcesz_otrzymywac:
      'Wybierz typy treści o zwierzętach, które chcesz otrzymywać. Możesz wybrać więcej niż jeden typ.',
    ten_email_jest_juz_zajety: 'Ten email jest już zajęty',
    zdjecie_jest_wymagane: 'Zdjęcie jest wymagane',
    zdjecie_profilowe: 'Zdjęcie profilowe',
    informacje_ogolne: 'Informacje ogólne',
    mozesz_dodac_adres_email_aby_otrzymywac_powiadomienia:
      'Możesz dodać adres email, aby otrzymywać powiadomienia.',
    konto_zostalo_zarejestrowane_przy_uzyciu_adresu_email_zmiana:
      'Konto zostało zarejestrowane przy użyciu adresu email. Zmiana nie jest możliwa.',
    podany_numer_telefonu_nie_bedzie_widoczny_na_klientow:
      'Podany numer telefonu nie będzie widoczny na klientów umawiających wizyty. Służy jedynie do logowania w przypadku wyboru tej formy autoryzacji i powiadomień systemowych.',
    w_przypadku_posiadania_numeru_pwz_nalezy_go_wprowadzic:
      'W przypadku posiadania numeru PWZ, należy go wprowadzić. Przyspiesza to weryfikację profilu.',
    konto_zostalo_zarejestrowane_przy_uzyciu_numeru_telefonu_zmiana:
      'Konto zostało zarejestrowane przy użyciu numeru telefonu. Zmiana nie jest możliwa.',
    zdjecie_profilowe_jest_wymagane_wybor_odpowiedniej_fotografii_jest:
      'Zdjęcie profilowe jest wymagane. Wybór odpowiedniej fotografii jest istotny dla budowania zaufania u nowych klientów. Zdjęcie będzie wyświetlane na karcie specjalisty w Twoim profilu online.',
    szczegoly_konta: 'Szczegóły konta',
    zmien_haslo: 'Zmień hasło',
    preferencje_tresci: 'Preferencje treści',
    powyzszy_opis_bedzie_widoczny_dla_wlascicieli_zwierzat_w:
      'Powyższy opis będzie widoczny dla właścicieli zwierząt w profilu specjalisty',
    placowka: 'Placówka',
    profil_zostal_zaktualizowany: 'Profil został zaktualizowany',
    nie_znaleziono_organizacji_uzytkownika:
      'Nie znaleziono organizacji użytkownika',
    nie_pamietasz_hasla: 'Nie pamiętasz hasła?',
    twoje_zwierze_zasluguje_na: 'Twoje zwierzę zasługuje na',
    opieke: 'opiekę!',
    weryfikacja_sie_powiodla: 'Weryfikacja się powiodła!',
    stworz_nowe_haslo_aby_w_pelni_korzystac_z:
      'Stwórz nowe hasło aby w pełni korzystać z platformy Vetsi.',
    haslo_musi_miec_przynajmniej_6_znakow:
      'Hasło musi mieć przynajmniej 6 znaków',
    cos_poszlo_nie_tak: 'Coś poszło nie tak :(',
    twoje_haslo_zostalo_zmienione: 'Twoje hasło zostało zmienione!',
    nowe_haslo: 'Nowe hasło',
    zresetuj_haslo: 'Zresetuj hasło',
    podaj_adres_email_ktory_jest_przypisany_do_twojego:
      'Podaj adres email, który jest przypisany do Twojego konta aby otrzymać link do resetowania hasła.',
    sprawdz_swoja_skrzynke_odbiorcza: 'Sprawdź swoją skrzynkę odbiorczą',
    wyslalismy_link_weryfikacyjny_na_twoj_adres_email:
      'Wysłaliśmy link weryfikacyjny na Twój adres email.',
    nieprawidlowy_kod_weryfikacyjny: 'Nieprawidłowy kod weryfikacyjny',
    zaloguj_sie_przez_google: 'Zaloguj się przez Google',
    zaloguj_sie_numerem_telefonu: 'Zaloguj się numerem telefonu',
    nie_otrzymales_kodu: 'Nie otrzymałeś kodu?',
    wyslij_kod: 'Wyślij kod',
    wroc_do_innych_metod_logowania: 'Wróć do innych metod logowania',
    wystapil_blad_podczas_zamykania_konta:
      'Wystąpił błąd podczas zamykania konta',
    nie_bedziesz_mogl_korzystac_z_serwisu_vetsi:
      'Nie będziesz mógł korzystać z serwisu Vetsi',
    stracisz_dostep_do_wszystkich_swoich_danych:
      'Stracisz dostęp do wszystkich swoich danych',
    twoje_konto_zostanie_dezaktywowane_i_usuniete_po_30:
      'Twoje konto zostanie dezaktywowane i usunięte po 30 dniach',
    jesli_chcesz_kontynuowac_korzystanie_z_serwisu_musisz_zaakceptowac:
      'Jeśli chcesz kontynuować korzystanie z serwisu, musisz zaakceptować regulamin.',
    wcisniecie_przycisku_ponizej_spowoduje_trwale_zamkniecie_konta:
      'Wciśnięcie przycisku poniżej spowoduje trwałe zamknięcie konta.',
    rejestracja_juz_prawie_gotowa: 'Rejestracja już prawie gotowa.',
    sprawdz_swoja_skrzynke_odbiorcza_potwierdz_podany_adres_e:
      'Sprawdź swoją skrzynkę odbiorczą, potwierdź podany adres e-mail i aktywuj konto, klikając w link w wiadomości.',
    do_czego_wykorzystujemy_date_urodzenia:
      'Do czego wykorzystujemy datę urodzenia?',
    data_urodzenia_pozwala_nam_lepiej_dopasowac_nasze_uslugi:
      'Data urodzenia pozwala nam lepiej dopasować nasze usługi i rekomendacje do Twoich potrzeb. Pomaga nam również zapewnić odpowiednią ochronę danych i zgodność z przepisami. Dodatkowo przygotowujemy specjalne prezenty urodzinowe! Data urodzenia nie jest wymagana do rejestracji.',
    przynajmniej_jeden_dzien_roboczy_jest_wymagany:
      'Przynajmniej jeden dzień roboczy jest wymagany',
    organizacja_zostala_skonfigurowana_pomyslnie:
      'Organizacja została skonfigurowana pomyślnie',
    wystapil_blad_podczas_konfiguracji_organizacji:
      'Wystąpił błąd podczas konfiguracji organizacji',
    skonfiguruj_swoja: 'Skonfiguruj swoją',
    organizacje: 'organizację',
    pomin_na_razie: 'Pomiń na razie',
    zakoncz_konfiguracje: 'Zakończ konfigurację',
    ustaw_godziny_pracy_dla_kazdego_dnia_tygodnia:
      'Ustaw godziny pracy dla każdego dnia tygodnia',
    wybierz_jakie_rodzaje_wizyt_chcesz_oferowac:
      'Wybierz jakie rodzaje wizyt chcesz oferować',
    podajac_nam_swoj_numer_telefonu_pomozesz_nam_na:
      'Podając nam swój numer telefonu, pomożesz nam na szybszy kontakt w celu przekazania informacji lub zmian w związku z umówioną wizytą. Numer telefonu nie jest wymagany do rejestracji.',
    weterynaria_zaczyna_sie_tutaj: 'weterynaria zaczyna się tutaj!',
    zaloguj_sie_do_vetsi_clinic: 'Zaloguj się do Vetsi Clinic',
    dolacz_do: 'Dołącz do',
    zwieksz: 'Zwiększ',
    widocznosc: 'widoczność',
    klientow: 'klientów',
    zyskaj_wlasny_profil_online_i_rezerwacje_24_7:
      'Zyskaj własny profil online i rezerwacje 24/7. Ogranicz liczbę telefonów i buduj widoczność, która skutecznie przyciąga nowych opiekunów zwierząt.',
    adres_e_mail_musi_miec_poprawna_forme:
      'Adres e-mail musi mieć poprawną formę',
    podane_haslo_sie_nie_zgadza: 'Podane hasło się nie zgadza',
    prywatnosc_danych: 'Prywatność danych',
    twoj_adres_e_mail_nie_bedzie_widoczny_dla:
      'Twój adres e-mail nie będzie widoczny dla użytkowników. Służy tylko do komunikacji z zespołem Vetsi oraz do logowania się do aplikacji.',
    i_oswiadczam_iz_zapoznalem_am_sie_z_ich:
      'i oświadczam, iż zapoznałem/am się z ich treścią*',
    wyrazam_zgode_na_przetwarzanie_przez_vetsi_sp_z:
      'Wyrażam zgodę na przetwarzanie przez Vetsi Sp. z o.o. moich danych osobowych w postaci adresu poczty elektronicznej oraz numeru telefonu w celu przesyłania mi informacji handlowych i marketingowych dotyczących produktów i usług oferowanych przez Vetsi Sp. z o.o. za pomocą środków komunikacji elektronicznej, świadczeniu usług drogą elektroniczną.',
    utworz_konto: 'Utwórz konto',
    paws_orry_cos_poszlo_nie_tak: 'Paws-orry, coś poszło nie tak.',
    nie_moglismy_zweryfikowac_twojego_adresu_e_mail_sprobuj:
      'Nie mogliśmy zweryfikować Twojego adresu e-mail. Spróbuj ponownie klikając w link weryfikacyjny w wiadomości e-mail.',
    twoj_adres_zostal_zweryfikowany_teraz_gdy_jestes_czescia:
      'Twój adres został zweryfikowany. Teraz, gdy jesteś częścią Vetsi, możesz cieszyć się pełnym dostępem do naszej platformy.',
    zaloz_konto_w_vetsi: 'Załóź konto w Vetsi',
    psiakosc_adres_e_mail_juz_istnieje_zaloguj_sie:
      'Psiakość! Adres e-mail już istnieje. Zaloguj się lub użyj opcji przypomnienia hasła.',
    email_musi_byc_prawidlowy: 'Email musi być prawidłowy.',
    psiakosc_nieprawidlowy_adres_e_mail_lub_haslo:
      'Psiakość! Nieprawidłowy adres e-mail lub hasło.',
    haslo_musi_miec_co_najmniej_6_znakow:
      'Hasło musi mieć co najmniej 6 znaków.',
    cos_poszlo_nie_tak_sprobuj_ponownie_pozniej:
      'Coś poszło nie tak :( Spróbuj ponownie później.',
    wyslane: 'Wysłane',
    wygasle: 'Wygasłe',
    medycyna_wewnetrzna: 'Medycyna wewnętrzna',
    rozrod_zwierzat: 'Rozród zwierząt',
    zywienie_zwierzat: 'Żywienie zwierząt',
    zdrowie_publiczne_i_bezpieczenstwo_zywnosci:
      'Zdrowie publiczne i bezpieczeństwo żywności',
    doradztwo_zywieniowe: 'Doradztwo żywieniowe',
    zywienie_terapeutyczne: 'Żywienie terapeutyczne',
    plan_zywienia: 'Plan żywienia',
    zywienie_szczeniat_i_kociat: 'Żywienie szczeniąt i kociąt',
    zywienie_sportowe_pracujace: 'Żywienie sportowe/pracujące',
    zywienie_w_ciazy_i_laktacji: 'Żywienie w ciąży i laktacji',
    zywienie_barf_i_diety_domowe: 'Żywienie BARF i diety domowe',
    zarzadzanie_agresja: 'Zarządzanie agresją',
    lek_separacyjny: 'Lęk separacyjny',
    fobie_i_leki: 'Fobie i lęki',
    trening_posluszenstwa: 'Trening posłuszeństwa',
    problemy_z_czystoscia: 'Problemy z czystością',
    nadpobudliwosc_i_reaktywnosc: 'Nadpobudliwość i reaktywność',
    laczenie_zwierzat_w_domu: 'Łączenie zwierząt w domu',
    testy_predyspozycji_szczeniat: 'Testy predyspozycji szczeniąt',
    przygotowanie_na_pojawienie_sie_dziecka:
      'Przygotowanie na pojawienie się dziecka',
    obrona_zasobow: 'Obrona zasobów',
    wsparcie_dla_psow_dorastajacych_okres_adolescencji:
      'Wsparcie dla psów dorastających (okres adolescencji)',
    problemy_zwiazane_z_bolem_zdrowiem: 'Problemy związane z bólem / zdrowiem',
    oczekiwanie_na_platnosc: 'Oczekiwanie na płatność',
    platnosc_potwierdzona: 'Płatność potwierdzona',
    platnosc_nieudana: 'Płatność nieudana',
    platnosc_zwrocona: 'Płatność zwrócona',
    odwolana: 'Odwołana',
    yearsFew: '{{count}} lata',
    yearsMany: '{{count}} lat',
    yearsOne: '{{count}} rok',
    monthsFew: '{{count}} miesiące',
    monthsMany: '{{count}} miesięcy',
    monthsOne: '{{count}} miesiąc',
    weeksFew: '{{count}} tygodnie',
    weeksMany: '{{count}} tygodni',
    weeksOne: '{{count}} tydzień',
    daysMany: '{{count}} dni',
    daysOne: '{{count}} dzień',
    daysZero: '{{count}} dni',
    smsVerificationCodeInfo:
      'Otrzymasz kod weryfikacyjny SMS na podany numer telefonu.',
    resendInSeconds: 'Wyślij ponownie ({{seconds}}s)',
    treatmentSummaryFilename: 'Podsumowanie zabiegów',
    compatibilityCheckedFor: 'Sprawdzono kompatybilność dla {{name}}',
    moreCount: '+{{count}} więcej',
    targetLocations: 'Lokalizacje docelowe',
    everyInterval: 'Co {{count}} {{unit}}',
    onWeekday: ' w {{day}}',
    weekOfMonthSuffix: '({{week}} tydzień)',
    zapisz_zmiany: 'Zapisz zmiany',
    profesjonalisty: 'profesjonalisty',
    serviceRemovalWarningMessage:
      'Wybrana usługa jest skonfigurowana u {{count}} {{professionals}} w tej placówce. Usunięcie usługi spowoduje jej usunięcie z ich konfiguracji.',
    priceBullet: ' • {{price}} zł',
    priceComma: ', {{price}} zł',
    currencyPln: 'zł',
    czas_trwania_minuty: 'Czas trwania (minuty)',
    defaultDurationMinutes: 'Domyślnie: {{duration}} min',
    przywroc_poprzednia_wersje: 'Przywróć poprzednią wersję',
    notatki_dodane_do_wizyty_potwierdzenie:
      'Notatki zostały przygotowane i czekają na zatwierdzenie lub edycję.',
    czy_dodac_podsumowanie_wizyty: 'Czy dodać podsumowanie wizyty?',
    wlasciciel_zostanie_poinformowany_o_dodaniu_dokumentu:
      'W przypadku wyboru "Generuj i wyślij" opiekun zostanie poinformowany o dodaniu tego dokumentu.',
    generuj_i_wyslij: 'Generuj i wyślij',
    generuj: 'Generuj',
    podsumowanie_wygenerowane_i_pobrane: 'Podsumowanie wygenerowane i pobrane.',
    dodaj_lek: 'Dodaj lek',
    dziennie: 'Dziennie',
    tygodniowo: 'Tygodniowo',
    dodatkowe_notatki: 'Dodatkowe notatki',
    brak_przypisanych_lekow: 'Brak przypisanych leków',
    usun_lek: 'Usuń lek',
    wyszukaj_lek_lub_wpisz_nazwe: 'Wyszukaj lek lub wpisz nazwę...',
  },
  medication: {
    form: {
      stepStatus: 'Status',
      stepSummary: 'Podsumowanie',
      summaryName: 'Nazwa',
      summaryPreparation: 'Typ preparatu',
      summaryYes: 'Tak',
      summaryNoReminder: 'Bez przypomnienia',
      summaryReminderWhen: 'Termin',
      summaryReminderRepeat: 'Powtarzanie',
      summaryReminderChannels: 'Powiadomienia',
      detailsTitle: 'Szczegóły lekarstwa',
      changeStatus: 'Zmień status',
      changeStatusTitle: 'Zmień status lekarstwa',
      statusOnlyNotice:
        'Wizyta została zakończona ponad 30 dni temu. Możesz już tylko zmienić status leku - przebieg wizyty pozostanie bez zmian.',
      stepMedicine: 'Lek',
      stepDosage: 'Dawkowanie',
      stepCourse: 'Przebieg',
      stepReminder: 'Przypomnienie',
      stepStock: 'Magazyn',
      sectionDosage: 'Dawkowanie',
      sectionClinical: 'Wskazanie i przebieg',
      sectionStatus: 'Status leczenia',
      otherOption: 'Inne - wpisz ręcznie',
      noMedicineFound: 'Brak leku na liście - wpisz nazwę ręcznie',
      nameRequired: 'Nazwa jest wymagana',
      notNegative: 'Wartość nie może być ujemna',
      customRequired: 'Uzupełnij pole opisowe',
      quantityPositive: 'Wartość musi być większa od 0',
      dosagePending: 'Dawka do ustalenia',
      dosagePendingHint:
        'Lek zapisze się bez dawki, którą będzie można uzupełnić w dowolnym momencie.',
      strengthValue: 'Gramatura',
      strengthRequired: 'Gramatura jest wymagana',
      strengthUnit: 'Jednostka gramatury',
      strengthUnitRequired: 'Jednostka jest wymagana',
      strengthUnitCustom: 'Jednostka - wpisz ręcznie',
      medicationForm: 'Postać',
      medicationFormCustom: 'Postać - wpisz ręcznie',
      formRequired: 'Postać jest wymagana',
      quantityValue: 'Ilość na podanie',
      quantityRequired: 'Ilość jest wymagana',
      quantityHint: 'Jedna dawka, np. 0,5 tabletki albo 1,5 ml',
      quantityHintUnit: 'Ile {{unit}} na jedno podanie',
      frequencyType: 'Częstotliwość',
      frequencyRequired: 'Częstotliwość jest wymagana',
      frequencyValue: 'Ile razy / co ile',
      frequencyValueRequired: 'Podaj liczbę',
      frequencyCustom: 'Częstotliwość - wpisz ręcznie',
      durationType: 'Okres leczenia',
      durationRequired: 'Okres leczenia jest wymagany',
      durationValue: 'Długość',
      durationValueRequired: 'Podaj długość',
      durationCustom: 'Okres - wpisz ręcznie',
      dosageSchedule: 'Dawkowanie zmienne w czasie',
      dosageScheduleHint: 'Np. 7 dni 2× dziennie, potem ½ tabletki 2× dziennie',
      indication: 'Wskazanie',
      indicationHint: 'Na jakiej podstawie podano lek',
      startedAt: 'Przyjmowany od',
      startedAtHint: 'Data rozpoczęcia, jeśli inna niż dziś',
      adverseReaction: 'Wystąpiła reakcja niepożądana',
      adverseReactionNote: 'Opis reakcji',
      adverseReactionNoteRequired: 'Opisz reakcję niepożądaną',
      status: 'Status',
      stopReason: 'Powód odstawienia',
      stopReasonRequired: 'Powód odstawienia jest wymagany',
      stopReasonNote: 'Powód - wpisz ręcznie',
      endedAt: 'Odstawiony dnia',
      endedAtHint: 'Data odstawienia, jeśli inna niż dziś',
      reminderTimeHint: 'Godzinę możesz wpisać z klawiatury',
      invalidForm: 'Popraw zaznaczone pola - lek nie został zapisany',
      formTablet: 'Tabletka',
      formCapsule: 'Kapsułka',
      formSachet: 'Saszetka',
      formSuspension: 'Zawiesina',
      formSolution: 'Roztwór',
      formDrops: 'Krople',
      formInjection: 'Iniekcja',
      formOintment: 'Maść',
      formSpotOn: 'Krople na skórę (spot-on)',
      formSpray: 'Spray',
      formPowder: 'Proszek',
      formPaste: 'Pasta',
      unitIu: 'j.m.',
      unitNone: 'bez jednostki',
      frequencyTimesPerDay: 'Razy dziennie',
      frequencyEveryNHours: 'Co ile godzin',
      frequencyEveryNDays: 'Co ile dni',
      frequencyTimesPerWeek: 'Razy w tygodniu',
      frequencyTimesPerMonth: 'Razy w miesiącu',
      frequencyAsNeeded: 'Doraźnie',
      durationUntilFurtherNotice: 'Do odwołania',
      durationDays: 'Dni',
      durationWeeks: 'Tygodni',
      durationUntilFollowUp: 'Do wizyty kontrolnej',
      durationSingleDose: 'Jednorazowo',
      autofillHistory:
        'Podpowiedziano na podstawie podania z {{date}} ({{species}})',
      autofillOtherSpecies: 'inny gatunek',
      autofillDrugData: 'Podpowiedziano z danych leku.',
      autofillClear: 'Wyczyść podpowiedź',
      medicineLockedHint: 'Aby zmienić lek, usuń linię i dodaj nową.',
    },
    history: {
      created: 'Dodano',
      edited: 'Zaktualizowano',
      dosageChanged: 'Zmieniono dawkowanie',
      paused: 'Wstrzymano',
      resumed: 'Wznowiono',
      stopped: 'Odstawiono',
      started: 'Rozpoczęto',
      system: 'System',
      empty: 'Brak zmian w historii',
      tabDetails: 'Szczegóły',
      tabHistory: 'Historia zmian',
    },
    status: {
      scheduled: 'Zaplanowany',
      active: 'Przyjmowany',
      paused: 'Wstrzymany',
      stopped: 'Odstawiony',
    },
    stopReason: {
      courseCompleted: 'Zakończona kuracja',
      ineffective: 'Brak skuteczności',
      adverseReaction: 'Reakcja niepożądana',
      ownerDecision: 'Decyzja opiekuna',
      replaced: 'Zamieniony na inny',
    },
    table: {
      added: 'Data',
      strength: 'Gramatura',
      dosing: 'Dawkowanie',
      duration: 'Okres',
      status: 'Status',
      sourceVisit: 'Wizyta',
      dosagePending: 'Dawka do ustalenia',
      addedBy: 'Dodano przez',
    },
  },
  common: {
    closed: 'Zamknięte',
    dayOff: 'Dzień wolny',
    close: 'Zamknij',
    cancel: 'Anuluj',
    save: 'Zapisz',
    delete: 'Usuń',
    add: 'Dodaj',
    remove: 'Usuń',
    owner: 'Właściciel',
    live: 'W trakcie',
    goToHome: 'Przejdź do strony głównej',
  },
  guestVisitPage: {
    title: 'Twoja wizyta',
    patientCardHeader: 'Pacjent',
    ownerCardHeader: 'Opiekun',
    summary: {
      tabSummary: 'Podsumowanie wizyty',
      tabDetails: 'Szczegóły wizyty',
      courseTitle: 'Przebieg wizyty',
      noteTitle: 'Notatka z wizyty',
      treatmentsTitle: 'Zabiegi',
      medicationsTitle: 'Leki',
      remindersTitle: 'Przypomnienia',
      documentsTitle: 'Dokumenty',
      transcriptionTitle: 'Transkrypcja',
      transcriptSummaryTitle: 'Streszczenie rozmowy',
      transcriptSummaryGenerating: 'Generowanie streszczenia…',
      empty: 'Brak danych do wyświetlenia.',
      reminderEdit: 'Edytuj',
      reminderDelete: 'Usuń',
      reminderSave: 'Zapisz',
      reminderRequired: 'Pole wymagane',
      reminderEditTitle: 'Edytuj przypomnienie',
      reminderDeleteTitle: 'Usunąć przypomnienie?',
      reminderDeleteConfirm:
        'Po usunięciu nie będziemy mogli wysłać Ci tego przypomnienia.',
      reminderDescriptionLabel: 'Opis przypomnienia',
      reminderScheduledLabel: 'Data i godzina',
      reminderChannelsHint:
        'Wybierz, jak chcesz otrzymać przypomnienie. Możesz odznaczyć oba kanały, ale wtedy nie otrzymasz powiadomienia.',
      ratingEditTitle: 'Oceń wizytę',
      ratingReadOnlyTitle: 'Opinia o wizycie',
    },
    ownerEmailLabel: 'Email:',
    ownerPhoneLabel: 'Telefon:',
    verify: {
      title: 'Potwierdź dostęp do swojej wizyty',
      chooseChannel: 'Wybierz, jak potwierdzimy Twoją tożsamość:',
      sendEmail: 'Wyślij mi link na e-mail',
      sendSms: 'Wyślij mi link SMS',
      noChannel: 'Brak kontaktu do weryfikacji tej wizyty.',
      sentEmail:
        'Wysłaliśmy link na {{maskedEmail}}. Otwórz go z tego urządzenia.',
      sentSms:
        'Wysłaliśmy link na {{maskedPhone}}. Otwórz go z tego urządzenia.',
      lockedOut: 'Zbyt wiele prób. Spróbuj ponownie za {{retryAfter}} sek.',
      linkConsumed: 'Ten link już został użyty lub wygasł.',
      linkExpiredTitle: 'Link wygasł.',
      linkExpiredBody:
        'Link do zarządzania wizytą wygasł. Skontaktuj się z placówką, aby uzyskać nowy link.',
      linkFailedTitle: 'Nie mogliśmy zweryfikować linku.',
      linkFailedBody:
        'Link do wizyty jest nieprawidłowy lub uszkodzony. Sprawdź, czy otworzyłeś go poprawnie z wiadomości e-mail lub SMS.',
      verifying: 'Trwa weryfikacja linku…',
      manageTitle: 'Zarządzaj wizytą',
      sendingCode: 'Wysyłamy jednorazowy kod…',
      recoveryIntro:
        'Wyślemy jednorazowy kod na potwierdzony adres e-mail lub numer telefonu.',
      recoveryStart: 'Wyślij kod weryfikacyjny',
      recoveryFailed: 'Nie udało się rozpocząć odzyskiwania dostępu.',
      codeSent: 'Wysłaliśmy kod weryfikacyjny na {{destination}}.',
      emailRecoverySent:
        'Wysłaliśmy wiadomość weryfikacyjną na {{destination}}. Wpisz otrzymany kod lub otwórz link z wiadomości.',
      codeLabel: 'Kod weryfikacyjny',
      codeRequired: 'Wpisz kod weryfikacyjny.',
      codeInvalid: 'Kod musi składać się z 6 cyfr.',
      codeSubmit: 'Potwierdź kod',
      codeFailed: 'Kod jest nieprawidłowy lub wygasł. Spróbuj ponownie.',
      goToHome: 'Wróć do strony głównej',
    },
    liveVisit: {
      title: 'Wizyta online',
      joinError:
        'Nie udało się dołączyć do wizyty. Specjalista mógł jeszcze nie rozpocząć spotkania.',
      requestNewLink: 'Wyślij nowy link',
      useSmsInstead: 'Użyj SMS zamiast tego',
      useEmailInstead: 'Użyj e-mail zamiast tego',
      verifying: 'Weryfikacja linku do wizyty',
      sendingCode: 'Wysyłamy kod…',
      sendingLink: 'Wysyłamy link…',
    },
    errors: {
      generic: 'Coś poszło nie tak. Spróbuj ponownie.',
      network: 'Brak połączenia z serwerem. Sprawdź internet.',
    },
    reschedule: {
      noSlots:
        'Brak dostępnych terminów w najbliższym czasie. Skontaktuj się z placówką.',
      submit: 'Potwierdź zmianę',
    },
    reject: {
      title: 'Odrzucenie wizyty',
      body: 'Czy na pewno chcesz odrzucić tę wizytę? Tej akcji nie można cofnąć.',
      reasonLabel: 'Powód odrzucenia (opcjonalnie)',
      confirm: 'Odrzuć',
      back: 'Anuluj',
    },
    ownerEditModal: {
      title: 'Edytuj dane opiekuna',
      firstName: 'Imię',
      lastName: 'Nazwisko',
      email: 'Email',
      phoneNumber: 'Telefon',
      save: 'Zapisz',
      cancel: 'Anuluj',
    },
  },
  dictation: {
    start: 'Dyktuj notatkę',
    stop: 'Zatrzymaj dyktowanie',
    connecting: 'Łączenie…',
    permissionDenied:
      'Brak dostępu do mikrofonu. Sprawdź uprawnienia przeglądarki.',
    startFailed: 'Nie udało się rozpocząć dyktowania.',
    connectionLost: 'Utracono połączenie z usługą dyktowania.',
    micBusy: 'Najpierw zatrzymaj transkrypcję wizyty.',
  },
  warehouse: {
    common: {
      title: 'Magazyn',
      save: 'Zapisz',
      cancel: 'Anuluj',
      close: 'Zamknij',
      edit: 'Edytuj',
      remove: 'Usuń',
      actions: 'Akcje',
      all: 'Wszystkie',
      none: 'Brak',
      filterChip: '{{label}}: {{value}}',
      searchChip: 'Szukaj: {{value}}',
      packageShort: 'op.',
      unitShort: 'jedn.',
      genericError: 'Coś poszło nie tak. Spróbuj ponownie.',
      notFound: 'Nie znaleziono.',
      disabled:
        'Magazyn jest wyłączony. Nie można zatwierdzać ani anulować dokumentów, korygować stanów ani wskazywać partii. Historia, katalog i szkice pozostają dostępne.',
      notEnabled: 'Magazyn nie jest włączony w tej placówce.',
      stockWarning: 'Brak na stanie: {{name}} (brakuje {{quantity}} jedn.)',
      unconfirmedSave: 'Poprzedni zapis nie został potwierdzony. Ponów zapis',
      tabs: {
        products: 'Produkty',
        documents: 'Dokumenty',
        demand: 'Zapotrzebowania',
        sales: 'Sprzedaż',
        suppliers: 'Dostawcy',
      },
      measures: {
        PACKAGE: 'Opakowania (op.)',
        UNIT: 'Jednostki',
      },
      kinds: {
        DRUG: 'Lek',
        NON_DRUG: 'Produkt',
      },
      vatRates: {
        '23': '23%',
        '8': '8%',
        '5': '5%',
        '0': '0%',
        ZW: 'zw.',
      },
    },
    products: {
      title: 'Produkty',
      add: 'Dodaj produkt',
      empty: 'Brak produktów w magazynie',
      columns: {
        name: 'Nazwa',
        kind: 'Rodzaj',
        stock: 'Stan',
        minimum: 'Minimum',
        flags: 'Oznaczenia',
      },
      filters: {
        search: 'Szukaj po nazwie lub kodzie EAN',
        kind: 'Rodzaj',
        belowMinimum: 'Do zamówienia',
        negative: 'Stan ujemny',
        expiring: 'Kończy się ważność',
        archived: 'Archiwalne',
      },
      badges: {
        rx: 'Rx',
        rxHint:
          'Lek na receptę. Nie można go sprzedać, wydaje się go jako lek w wizycie.',
        controlled: 'Kontrolowany {{category}}',
        controlledHint:
          'Lek kontrolowany kategorii {{category}}. Książkę kontroli leków kontrolowanych nadal prowadzisz w wersji papierowej.',
        negative: 'Stan ujemny',
        negativeHint:
          'Stan spadł poniżej zera, bo wydano więcej, niż przyjęto. Przyjmij brakujący towar (PZ) albo skoryguj stan, jeśli spis się nie zgadza.',
        belowMinimum: 'Poniżej minimum',
        belowMinimumHint:
          'Stan jest niższy niż ustalone minimum, więc czas zamówić ten produkt. Znajdziesz go w filtrze „Do zamówienia”.',
        expiring: 'Kończy się ważność',
        expiringHint:
          'Partia na stanie jest przeterminowana albo straci ważność w ciągu 60 dni. Sprawdź partie: przeterminowane spisz korektą, resztę zużyj w pierwszej kolejności.',
        archived: 'Archiwalny',
        archivedHint:
          'Produkt zarchiwizowany. Nie przyjmie nowych ruchów magazynowych, a jego historia zostaje zachowana.',
        unassigned: 'Bez partii: {{count}}',
        unassignedHint:
          'Część wydań zapisano bez partii, bo w chwili wydania nie było jej na stanie. Wskaż partię przy tych wydaniach, aby karta ewidencji i lista odbiorców partii były kompletne.',
      },
      form: {
        createTitle: 'Nowy produkt',
        editTitle: 'Edytuj produkt',
        kind: 'Rodzaj produktu',
        registrySearch: 'Wyszukaj lek w rejestrze',
        registryNoResults: 'Nie znaleziono leku w rejestrze',
        packagingOptions: 'Opakowania w rejestrze: {{options}}',
        controlledHint:
          'W rejestrze ten lek ma kategorię Rpw. Sprawdź, czy jest lekiem kontrolowanym.',
        paperBookHint:
          'Książkę kontroli leków kontrolowanych nadal prowadzisz w wersji papierowej.',
        name: 'Nazwa',
        isRx: 'Lek na receptę (Rx)',
        prescription: 'Recepta',
        prescriptionNone: 'Bez recepty',
        prescriptionRx: 'Na receptę (Rx)',
        controlledCategory: 'Kategoria leku kontrolowanego',
        unit: 'Jednostka',
        unitLocked:
          'Jednostki nie można zmienić, bo produkt ma już ruchy lub pozycje dokumentów. Dla innej postaci dodaj nowy produkt.',
        unitCustom: 'Nazwa jednostki',
        unitsPerPackage: 'Jednostek w opakowaniu',
        dispenseMode: 'Wydawanie opiekunowi',
        dispenseModeHint:
          'Tak formularz leku policzy ilość wydawaną opiekunowi na kurację.',
        dispenseModes: {
          PACKAGES: 'w całych opakowaniach',
          UNITS: 'na sztuki',
        },
        packagePriceGross: 'Cena brutto za opakowanie',
        unitPriceGross: 'Cena brutto za jednostkę',
        unitPriceHint: 'Puste pole = cena opakowania ÷ liczba jednostek',
        packagePriceNet: 'Cena netto za opakowanie',
        unitPriceNet: 'Cena netto za jednostkę',
        info: {
          kind: 'Lek ma dodatkowe dane: recepta, kategoria kontrolowana, partie i daty ważności. Produkt to pozostały towar, np. karma lub materiały opatrunkowe.',
          gtin: 'Kod kreskowy z opakowania (EAN). Ułatwia wyszukanie produktu.',
          prescription: 'Leku na receptę nie można sprzedać przez Sprzedaż. Wydaje się go jako lek w wizycie.',
          controlledCategory: 'Kategoria z ustawy o przeciwdziałaniu narkomanii, np. II-P. Lek kontrolowany zawsze jest na receptę, a książkę kontroli nadal prowadzisz na papierze.',
          form: 'Postać farmaceutyczna z ulotki, np. tabletki, zawiesina doustna, roztwór do wstrzykiwań.',
          strength: 'Ilość substancji czynnej, np. 50 mg albo 1,5 mg/ml.',
          marketingAuthorisationNumber: 'Numer pozwolenia na dopuszczenie do obrotu z ulotki albo z rejestru leków.',
          marketingAuthorisationHolder: 'Firma, która ma pozwolenie na dopuszczenie leku do obrotu. Wymagana dla leku na receptę.',
          withdrawalPeriod: 'Okres karencji: czas od podania leku do uboju zwierzęcia albo pozyskania mleka, jaj lub miodu. Ważny przy zwierzętach gospodarskich.',
          unit: 'Najmniejsza porcja, w której wydajesz produkt, np. tabletka, ml, sztuka. W tej jednostce liczony jest stan.',
          unitCustom: 'Nazwa jednostki, której nie ma na liście.',
          unitsPerPackage: 'Ile jednostek jest w jednym opakowaniu, np. 10 tabletek. Na tej podstawie opakowania są przeliczane na jednostki.',
          minStock: 'Gdy stan spadnie poniżej tej ilości, produkt dostanie oznaczenie „Poniżej minimum” i trafi do filtra „Do zamówienia”.',
          vatRate: 'Stawka VAT przy sprzedaży, wspólna dla ceny za opakowanie i za jednostkę. Według niej netto i brutto przeliczają się nawzajem.',
          packagePriceGross: 'Cena sprzedaży brutto całego opakowania, podpowiadana przy sprzedaży i w wizycie.',
          unitPriceGross: 'Cena sprzedaży brutto jednej jednostki, gdy sprzedajesz na sztuki.',
          packagePriceNet: 'Cena sprzedaży netto całego opakowania. Wpisz netto albo brutto, druga cena przeliczy się ze stawki VAT.',
          unitPriceNet: 'Cena sprzedaży netto jednej jednostki. Wpisz netto albo brutto, druga cena przeliczy się ze stawki VAT.',
        },
        vatRate: 'Stawka VAT',
        minStock: 'Stan minimalny',
        minStockMeasure: 'Stan minimalny w',
        marketingAuthorisationNumber: 'Numer pozwolenia',
        marketingAuthorisationHolder: 'Podmiot odpowiedzialny',
        withdrawalPeriod: 'Okres karencji',
        pharmaceuticalForm: 'Postać',
        strength: 'Moc',
        gtin: 'Kod EAN / GTIN',
        drugSection: 'Dane leku',
        steps: {
          product: 'Produkt',
          stock: 'Stan',
          prices: 'Ceny',
          summary: 'Podsumowanie',
        },
        next: 'Dalej',
        back: 'Wstecz',
        summaryYes: 'Tak',
        summaryNo: 'Nie',
        created: 'Dodano produkt.',
        updated: 'Zapisano produkt.',
      },
      validation: {
        nameRequired: 'Podaj nazwę produktu.',
        unitCustomRequired: 'Podaj nazwę jednostki.',
        unitsPerPackage: 'Podaj liczbę całkowitą od 1 do 100 000.',
        price: 'Podaj kwotę, np. 12,50.',
        quantity: 'Podaj ilość większą od zera (maks. 3 miejsca po przecinku).',
        gtin: 'Kod EAN ma od 8 do 14 cyfr.',
        rxFactsRequired:
          'Lek na receptę wymaga numeru pozwolenia i podmiotu odpowiedzialnego.',
        nameTooLong: 'Nazwa produktu może mieć najwyżej 200 znaków.',
        unitCustomTooLong: 'Nazwa jednostki może mieć najwyżej 50 znaków.',
        marketingAuthorisationNumberTooLong:
          'Numer pozwolenia może mieć najwyżej 100 znaków.',
        marketingAuthorisationHolderTooLong:
          'Podmiot odpowiedzialny może mieć najwyżej 300 znaków.',
        withdrawalPeriodTooLong:
          'Okres karencji może mieć najwyżej 500 znaków.',
        formTooLong: 'Postać może mieć najwyżej 200 znaków.',
        strengthTooLong: 'Moc może mieć najwyżej 200 znaków.',
      },
      unassigned: {
        title: 'Wydania bez partii',
        hint: 'Lek wydano, gdy jego partii nie było na stanie. Wskaż rzeczywistą partię, aby karta ewidencji i lista odbiorców partii były kompletne.',
        empty: 'Wszystkie wydania mają przypisaną partię.',
        date: 'Data wydania',
        quantity: 'Ilość',
        source: 'Źródło',
        assign: 'Wskaż partię',
      },
      assignBatch: {
        title: 'Wskaż partię',
        issue: 'Wydanie z {{date}}: {{quantity}}',
        batch: 'Partia',
        partial: 'Przypisz tylko część wydania',
        info: {
          partial:
            'Zaznacz, aby do tej partii przypisać tylko część wydanej ilości. Pozostała ilość zostanie bez partii do przypisania później.',
        },
        quantity: 'Ilość do przypisania',
        save: 'Przypisz partię',
        done: 'Przypisano partię {{batch}}.',
        noBatches:
          'Ten produkt nie ma jeszcze partii. Najpierw przyjmij towar (PZ).',
        batchRequired: 'Wybierz partię.',
        expiredHint: 'przeterminowana',
      },
      archive: {
        action: 'Archiwizuj',
        title: 'Zarchiwizować produkt?',
        body: 'Zarchiwizowany produkt nie przyjmie nowych ruchów magazynowych, a jego historia zostanie zachowana.',
        done: 'Produkt zarchiwizowany.',
      },
      detail: {
        back: 'Wróć do produktów',
        stock: 'Stan magazynowy',
        lastCost: 'Ostatnia cena zakupu netto / jedn.',
        adjust: 'Korekta stanu',
        packagePrice: 'Cena brutto za opakowanie',
        unitPrice: 'Cena brutto za jednostkę',
        batches: 'Partie',
        batchesHint:
          'Wszystkie partie tego leku przyjęte do magazynu, od najkrótszej daty ważności. Przy każdej widać jej stan i komu ją wydano.',
        movements: 'Historia ruchów',
        movementsHint:
          'Każde przyjęcie, wydanie, sprzedaż i korekta tego produktu, od najnowszych. Anulowane i cofnięte ruchy są wyszarzone.',
      },
      batches: {
        number: 'Numer serii',
        expiry: 'Data ważności',
        stock: 'Stan',
        received: 'Pierwsze przyjęcie',
        expired: 'przeterminowana',
        expiredHint:
          'Partia jest przeterminowana i nie zostanie wydana ani sprzedana. Można ją tylko spisać korektą z powodem „Przeterminowanie”.',
        expiringSoon: 'kończy się ważność',
        expiringSoonHint:
          'Partia straci ważność w ciągu 60 dni. System wydaje ją przed partiami z dłuższą ważnością, więc warto zużyć ją w pierwszej kolejności.',
        empty: 'Brak partii',
      },
      movements: {
        date: 'Data',
        type: 'Rodzaj',
        status: 'Status',
        quantity: 'Ilość',
        batch: 'Partia',
        document: 'Dokument',
        recordedBy: 'Zapisał(a)',
        unitCost: 'Cena zakupu netto / jedn.',
        reversal: 'cofnięcie',
        reversalHint:
          'Cofnięcie anulowanego wpisu. Razem z wpisem „anulowany” nie zmienia stanu.',
        reversed: 'anulowany',
        reversedHint:
          'Wpis anulowany później cofnięciem. Zostaje w historii, ale nie liczy się do stanu.',
        unknownBatch: 'nieznana partia',
        empty: 'Brak ruchów',
        types: {
          OPENING: 'Stan początkowy',
          RECEIPT: 'Przyjęcie',
          USAGE: 'Zużycie',
          SALE: 'Sprzedaż',
          ADJUSTMENT: 'Korekta',
        },
      },
    },
    documents: {
      title: 'Dokumenty',
      empty: 'Brak dokumentów',
      newReceipt: 'Nowe przyjęcie (PZ)',
      newOpening: 'Stan początkowy (BO)',
      draft: 'draft',
      columns: {
        number: 'Numer',
        type: 'Rodzaj',
        date: 'Data',
        supplier: 'Dostawca',
        status: 'Status',
        totalNet: 'Wartość netto',
        totalGross: 'Wartość brutto',
      },
      filters: {
        type: 'Rodzaj',
        status: 'Status',
      },
      types: {
        PZ: 'Przyjęcie (PZ)',
        BO: 'Stan początkowy (BO)',
        WZ: 'Sprzedaż (WZ)',
        KOR: 'Korekta (KOR)',
      },
      statuses: {
        DRAFT: 'Draft',
        APPROVED: 'Zatwierdzony',
        CANCELLED: 'Anulowany',
      },
      statusHints: {
        DRAFT:
          'Draft: dokument nie ma jeszcze numeru i nie zmienia stanów magazynowych. Możesz go edytować, zatwierdzić albo odrzucić.',
        APPROVED:
          'Dokument zatwierdzony: ma numer, zmienił stany magazynowe i nie można go już edytować. Pomyłkę w przyjęciu, stanie początkowym lub sprzedaży cofniesz, anulując dokument.',
        CANCELLED:
          'Dokument anulowany: nie wpływa na stany magazynowe, a jeśli był zatwierdzony, jego ruchy cofnięto. Zostaje w historii do wglądu.',
      },
      approvalUnavailable:
        'Zatwierdzanie jest niedostępne, dopóki magazyn jest wyłączony. Możesz zapisać szkic.',
      receipt: {
        createPzTitle: 'Nowe przyjęcie (PZ)',
        createBoTitle: 'Stan początkowy (BO)',
        editTitle: 'Edytuj szkic',
        supplier: 'Dostawca',
        newSupplier: 'Dodaj dostawcę „{{name}}”',
        invoiceNumber: 'Numer faktury',
        documentDate: 'Data dokumentu',
        note: 'Uwagi',
        lines: 'Pozycje',
        saveDraft: 'Zapisz szkic',
        approve: 'Zatwierdź',
        draftSaved: 'Zapisano szkic.',
        approved: 'Zatwierdzono dokument {{number}}.',
        noLines: 'Dodaj co najmniej jedną pozycję.',
        supplierRequired: 'Wybierz dostawcę.',
        dateRequired: 'Podaj datę.',
        invoiceTooLong: 'Numer faktury może mieć najwyżej 100 znaków.',
        noteTooLong: 'Uwagi mogą mieć najwyżej 1000 znaków.',
        editSupplier: 'Uzupełnij adres',
        info: {
          supplier:
            'Dostawca musi mieć zapisany adres, aby można było zatwierdzić to przyjęcie (PZ). Możesz dodać nowego dostawcę, wpisując jego nazwę.',
        },
      },
      approveDialog: {
        title: 'Zatwierdzić dokument?',
        body: 'Po zatwierdzeniu dokument dostanie numer, zwiększy stany magazynowe i nie będzie można go edytować. Pomyłkę cofniesz, anulując dokument.',
        confirm: 'Zatwierdź',
      },
      lines: {
        title: 'Pozycja dokumentu',
        addProduct: 'Dodaj produkt do dokumentu',
        newProduct: 'Nowy produkt „{{name}}”',
        product: 'Produkt',
        quantity: 'Ilość',
        measure: 'Miara',
        costNetPerPackage: 'Cena zakupu netto za opakowanie',
        costNetPerUnit: 'Cena zakupu netto za jednostkę',
        vatRate: 'VAT',
        batchNumber: 'Numer serii',
        expiryDate: 'Data ważności',
        lineNet: 'Wartość netto',
        lineGross: 'Wartość brutto',
        remove: 'Usuń pozycję',
        empty: 'Brak pozycji',
        costTooHigh: 'Cena może wynosić najwyżej 10 000 000,00 zł.',
        info: {
          costNet:
            'Cena zakupu netto od dostawcy. Z niej liczona jest wartość netto i brutto pozycji.',
          vatRate:
            'Stawka VAT zakupu tej pozycji. Z niej liczona jest wartość brutto na dokumencie.',
          batchNumber:
            'Numer serii (LOT) z opakowania lub faktury. Umożliwia śledzenie partii przy wydawaniu i w karcie ewidencji.',
          expiryDate:
            'Data ważności partii. Partie o krótszej ważności są wydawane w pierwszej kolejności.',
        },
      },
      attachment: {
        title: 'Załącznik (skan faktury)',
        drop: 'Upuść lub wybierz plik PDF, JPG lub PNG (maks. 15 MB)',
        current: 'Załącznik: {{name}}',
        pending: 'Do wysłania: {{name}}',
        open: 'Otwórz załącznik',
        rejected: 'Dozwolone są pliki PDF, JPG i PNG do 15 MB.',
        tooLarge: 'Plik jest za duży (maks. 15 MB).',
      },
      detail: {
        back: 'Wróć do dokumentów',
        title: 'Dokument',
        totalNet: 'Razem netto',
        totalGross: 'Razem brutto',
        reason: 'Powód korekty',
        note: 'Uwagi',
        createdAt: 'Utworzono',
        approvedAt: 'Zatwierdzono',
        cancelledAt: 'Anulowano',
        cancelReason: 'Powód anulowania',
        supplierAddress: 'Adres dostawcy',
        editDraft: 'Edytuj szkic',
        cancelDocument: 'Anuluj dokument',
        discardDraft: 'Odrzuć szkic',
        approvalUnconfirmed:
          'Zatwierdzenie nie zostało potwierdzone. Otwórz „Edytuj szkic” i zatwierdź ponownie.',
      },
      cancelDialog: {
        title: 'Anulować dokument?',
        body: 'Anulowanie cofnie wszystkie ruchy magazynowe tego dokumentu. Numer dokumentu zostanie zachowany.',
        draftBody:
          'Draft zostanie odrzucony. Stany magazynowe się nie zmienią.',
        reason: 'Powód anulowania',
        reasonRequired: 'Podaj powód (co najmniej 3 znaki).',
        reasonTooLong: 'Powód może mieć najwyżej 500 znaków.',
        confirm: 'Anuluj dokument',
        done: 'Dokument anulowany.',
      },
    },
    suppliers: {
      title: 'Dostawcy',
      add: 'Dodaj dostawcę',
      createTitle: 'Nowy dostawca',
      editTitle: 'Edytuj dostawcę',
      empty: 'Brak dostawców',
      search: 'Szukaj po nazwie lub NIP',
      columns: {
        name: 'Nazwa',
        nip: 'NIP',
        address: 'Adres',
      },
      form: {
        name: 'Nazwa dostawcy',
        nip: 'NIP (opcjonalnie)',
        info: {
          nip: 'Numer NIP dostawcy. Jeśli go podasz, musi być poprawny: 10 cyfr ze zgodną cyfrą kontrolną.',
        },
        nameRequired: 'Podaj nazwę dostawcy.',
        nipInvalid: 'Numer NIP jest nieprawidłowy.',
        street: 'Ulica i numer',
        postalCode: 'Kod pocztowy',
        city: 'Miejscowość',
        addressHint:
          'Adres jest potrzebny, aby zatwierdzić przyjęcie (PZ) od tego dostawcy.',
        addressIncomplete:
          'Uzupełnij ulicę, kod pocztowy i miejscowość albo zostaw wszystkie pola puste.',
        nameTooLong: 'Nazwa dostawcy może mieć najwyżej 200 znaków.',
        streetTooLong: 'Ulica i numer mogą mieć najwyżej 200 znaków.',
        postalCodeTooLong: 'Kod pocztowy może mieć najwyżej 20 znaków.',
        cityTooLong: 'Miejscowość może mieć najwyżej 100 znaków.',
      },
      created: 'Dodano dostawcę.',
      updated: 'Zapisano dostawcę.',
      nipTaken: 'Dostawca z tym numerem NIP już istnieje.',
    },
    adjustments: {
      title: 'Korekta stanu',
      direction: 'Rodzaj korekty',
      directions: {
        INCREASE: 'Zwiększenie stanu',
        DECREASE: 'Zmniejszenie stanu',
      },
      quantity: 'Ilość',
      measure: 'Miara',
      reason: 'Powód',
      batch: 'Partia',
      batchAuto: 'Automatycznie (najkrótsza ważność)',
      newBatch: 'Nowa partia',
      batchNumber: 'Numer serii',
      expiryDate: 'Data ważności',
      info: {
        batchNumber: 'Numer serii (LOT) nowej partii, którą tworzysz tą korektą.',
        expiryDate:
          'Data ważności nowej partii. Partie o krótszej ważności są wydawane w pierwszej kolejności.',
      },
      note: 'Uwagi',
      save: 'Zapisz korektę',
      done: 'Zapisano korektę {{number}}.',
      expiredHint: 'Przy przeterminowaniu wybierz przeterminowaną partię.',
      batchRequired: 'Dla leku podaj numer serii i datę ważności.',
      batchNumberTooLong: 'Numer serii może mieć najwyżej 100 znaków.',
      noteTooLong: 'Uwagi mogą mieć najwyżej 1000 znaków.',
      expiredBatchRequired:
        'Przy przeterminowaniu wskaż konkretną, istniejącą partię. Nie wybieraj automatycznej ani nowej.',
    },
    sales: {
      newSale: 'Nowa sprzedaż',
      formTitle: 'Nowa sprzedaż',
      formTitleVisit: 'Sprzedaż w wizycie',
      visitMenuItem: 'Sprzedaż',
      buyerName: 'Nabywca (opcjonalnie)',
      note: 'Uwagi (opcjonalnie)',
      productPicker: 'Dodaj produkt',
      productPickerPlaceholder: 'Wyszukaj produkt po nazwie',
      noProducts: 'Brak pasujących produktów',
      rxBadge: 'Rx',
      rxHint: 'Wydaj jako Lekarstwo w wizycie',
      product: 'Produkt',
      quantity: 'Ilość',
      measure: 'Miara',
      measurePackage: 'op.',
      measureUnit: 'jedn.',
      unitPriceGross: 'Cena brutto',
      info: {
        unitPriceGross:
          'Cena brutto podpowiadana z karty produktu. Możesz ją zmienić tylko dla tej sprzedaży.',
      },
      lineGross: 'Wartość brutto',
      vat: 'VAT',
      onHand: 'Na stanie: {{stock}}',
      removeLine: 'Usuń pozycję',
      noLines: 'Dodaj co najmniej jeden produkt.',
      maxLines: 'Sprzedaż może mieć najwyżej 100 pozycji.',
      invalidQuantity:
        'Podaj ilość większą od zera (maks. 3 miejsca po przecinku).',
      invalidPrice:
        'Podaj cenę w złotych, np. 49,99 (najwyżej 10 000 000,00 zł).',
      buyerNameMax: 'Nabywca może mieć maksymalnie 120 znaków.',
      noteMax: 'Uwagi mogą mieć maksymalnie 500 znaków.',
      totalNet: 'Razem netto',
      totalVat: 'Razem VAT',
      totalGross: 'Razem brutto',
      submit: 'Zapisz sprzedaż',
      retrySubmit: 'Ponów zapis',
      retryPending:
        'Nie wiemy, czy sprzedaż została zapisana. Ponów zapis: te same pozycje nie zostaną sprzedane dwa razy.',
      created: 'Sprzedaż zapisana.',
      createdWithShortage: 'Sprzedaż zapisana. Stan ujemny: {{products}}.',
      createError: 'Nie udało się zapisać sprzedaży.',
      buyer: 'Nabywca',
      noBuyer: 'Nie podano',
      counterpartyRetail: 'Sprzedaż detaliczna',
      visit: 'Wizyta',
      openVisit: 'Otwórz wizytę',
      noVisit: 'Sprzedaż bez wizyty',
      cancel: 'Anuluj sprzedaż',
      list: {
        search: 'Szukaj po nazwie produktu',
        status: 'Status',
        statusApproved: 'Zatwierdzone',
        statusCancelled: 'Anulowane',
        statusAll: 'Wszystkie',
        from: 'Od',
        to: 'Do',
        empty: 'Brak sprzedanych produktów',
        approved: 'Zatwierdzona',
        approvedHint:
          'Sprzedaż zapisana: sprzedane produkty zeszły ze stanu. Jeśli to pomyłka, anuluj sprzedaż, a towar wróci na stan.',
        cancelled: 'Anulowana',
        cancelledHint:
          'Sprzedaż anulowana: sprzedane produkty wróciły na stan. Zostaje w historii do wglądu.',
        columns: {
          date: 'Data',
          product: 'Produkt',
          quantity: 'Ilość',
          unitPriceGross: 'Cena brutto',
          lineNet: 'Wartość netto',
          lineGross: 'Wartość brutto',
          document: 'Dokument',
          status: 'Status',
          saleTotal: 'Razem',
        },
      },
    },
    reasons: {
      DAMAGED: 'Uszkodzenie',
      EXPIRED: 'Przeterminowanie',
      STOCK_COUNT: 'Spis z natury',
      INTERNAL_USE: 'Zużycie wewnętrzne',
      OTHER: 'Inny powód',
    },
    units: {
      TABLET: {
        one: 'tabletka',
        few: 'tabletki',
        many: 'tabletek',
        fraction: 'tabletki',
        name: 'Tabletka',
      },
      CAPSULE: {
        one: 'kapsułka',
        few: 'kapsułki',
        many: 'kapsułek',
        fraction: 'kapsułki',
        name: 'Kapsułka',
      },
      BLISTER: {
        one: 'blister',
        few: 'blistry',
        many: 'blistrów',
        fraction: 'blistra',
        name: 'Blister',
      },
      ML: {
        one: 'ml',
        few: 'ml',
        many: 'ml',
        fraction: 'ml',
        name: 'Mililitr (ml)',
      },
      G: { one: 'g', few: 'g', many: 'g', fraction: 'g', name: 'Gram (g)' },
      PIECE: {
        one: 'szt.',
        few: 'szt.',
        many: 'szt.',
        fraction: 'szt.',
        name: 'Sztuka (szt.)',
      },
      SACHET: {
        one: 'saszetka',
        few: 'saszetki',
        many: 'saszetek',
        fraction: 'saszetki',
        name: 'Saszetka',
      },
      AMPOULE: {
        one: 'ampułka',
        few: 'ampułki',
        many: 'ampułek',
        fraction: 'ampułki',
        name: 'Ampułka',
      },
      VIAL: {
        one: 'fiolka',
        few: 'fiolki',
        many: 'fiolek',
        fraction: 'fiolki',
        name: 'Fiolka',
      },
      PIPETTE: {
        one: 'pipeta',
        few: 'pipety',
        many: 'pipet',
        fraction: 'pipety',
        name: 'Pipeta',
      },
      DOSE: {
        one: 'dawka',
        few: 'dawki',
        many: 'dawek',
        fraction: 'dawki',
        name: 'Dawka',
      },
      OTHER: {
        one: 'jedn.',
        few: 'jedn.',
        many: 'jedn.',
        fraction: 'jedn.',
        name: 'Inna (własna nazwa)',
      },
    },
    errors: {
      PRODUCT_ARCHIVED:
        'Produkt jest zarchiwizowany i nie może mieć nowych ruchów magazynowych.',
      PRODUCT_KIND_MISMATCH:
        'Ta operacja nie jest dostępna dla tego rodzaju produktu.',
      RX_NOT_SELLABLE:
        'Leku na receptę nie można sprzedać. Wydaj go jako lekarstwo w wizycie.',
      BATCH_EXPIRED: 'Wybrana partia jest przeterminowana.',
      BATCH_REQUIRED: 'Dla leku podaj numer serii i datę ważności.',
      BATCH_PRODUCT_MISMATCH: 'Wybrana partia nie należy do tego produktu.',
      DOCUMENT_NOT_DRAFT:
        'Dokument jest już zatwierdzony lub anulowany i nie można go zmienić.',
      DOCUMENT_ALREADY_CANCELLED: 'Dokument jest już anulowany.',
      DOCUMENT_TYPE_NOT_CANCELLABLE:
        'Tego dokumentu nie można anulować. Popraw stan nową korektą.',
      NIP_INVALID: 'Numer NIP jest nieprawidłowy.',
      INVALID_QUANTITY:
        'Ilość musi być większa od zera i mieć najwyżej trzy miejsca po przecinku.',
      EMPTY_DOCUMENT: 'Dokument musi mieć co najmniej jedną pozycję.',
      WAREHOUSE_DISABLED:
        'Magazyn nie jest włączony w tej placówce. Historia pozostaje dostępna do odczytu.',
      UNIT_LOCKED: 'Jednostki nie można zmienić. Odśwież produkt.',
      OPERATION_KEY_REUSED:
        'Ten klucz operacji użyto już dla innych danych. Odśwież formularz i spróbuj ponownie.',
      MOVEMENT_NOT_ASSIGNABLE:
        'Tego wydania nie można przypisać do partii, bo ma już partię albo zostało skorygowane.',
      DUPLICATE_LINE_ID:
        'Pozycje mają powtórzone identyfikatory. Odśwież formularz i spróbuj ponownie.',
      MA_HOLDER_REQUIRED:
        'Lek na receptę wymaga numeru pozwolenia i podmiotu odpowiedzialnego.',
      PRESCRIPTION_FACTS_REQUIRED:
        'Przy wydaniu leku na receptę opiekunowi zaznacz, czy wystawiono receptę.',
      RECIPIENT_REQUIRED: 'Podaj imię i nazwisko opiekuna, któremu wydano lek.',
      SUPPLIER_ADDRESS_REQUIRED:
        'Aby zatwierdzić przyjęcie, uzupełnij adres dostawcy.',
      MEDICATION_HAS_TREATMENT_STOCK:
        'Ten lek pochodzi z zabiegu i pobrał stan z magazynu. Usuń go lub zmień w zabiegu.',
      DEMAND_REQUEST_TRANSITION_INVALID:
        'Nie można tak zmienić statusu tego zapotrzebowania.',
      DEMAND_REQUEST_LINK_INVALID:
        'Z produktem z katalogu można połączyć tylko otwarte albo zamówione zapotrzebowanie spoza magazynu.',
      DEMAND_REQUEST_UNLINK_INVALID:
        'Tego zapotrzebowania nie można odpiąć od produktu.',
      RECIPIENT_ADDRESS_REQUIRED: 'Podaj adres odbiorcy leku na receptę.',
      VISIT_NOT_SELLABLE:
        'Sprzedaż można dodać tylko do wizyty w trakcie lub zakończonej.',
    },
    clinical: {
      sectionTitle: 'Z magazynu',
      takeFromStock: 'Pobierz z magazynu',
      product: 'Lek z magazynu',
      material: 'Materiał z magazynu',
      productRequired: 'Wybierz produkt z magazynu',
      onHand: 'Na stanie: {{quantity}}',
      quantity: 'Ilość',
      quantityRequired: 'Podaj ilość',
      quantityPositive: 'Ilość musi być większa od zera',
      measure: 'Liczone w',
      measurePackage: 'opakowaniach (op.)',
      measureUnit: 'jednostkach (jedn.)',
      measureShortPackage: 'op.',
      measureShortUnit: 'jedn.',
      handover: 'Sposób wydania',
      handoverAdministered: 'Podany w placówce',
      handoverHandedOver: 'Wydany opiekunowi',
      handoverRequired:
        'Wskaż, czy lek podano w placówce, czy wydano opiekunowi',
      prescription: 'Recepta',
      prescriptionIssued: 'Wystawiono receptę (realizacja w placówce)',
      prescriptionNotIssued: 'Bez recepty',
      prescriptionRequired: 'Wskaż, czy wystawiono receptę',
      recipient: 'Odbiorca (opiekun)',
      recipientHelp:
        'Zostaw puste, aby zapisać właściciela pacjenta lub opiekuna podanego przy wizycie gościa.',
      recipientTooLong: 'Imię i nazwisko może mieć najwyżej 120 znaków',
      recipientAddress: 'Adres odbiorcy',
      recipientAddressHelp:
        'Wymagany przy wydaniu leku na receptę. Puste pole zapisze adres z profilu właściciela pacjenta; dla gościa lub innej osoby wpisz adres.',
      recipientAddressRequired: 'Podaj adres odbiorcy leku na receptę.',
      recipientAddressTooLong: 'Adres może mieć najwyżej 300 znaków',
      disabledReadOnly: 'Magazyn jest wyłączony, więc wydanie jest tylko do odczytu',
      batch: 'Partia',
      batchAuto: 'Automatycznie (najkrótsza ważność)',
      batchAutoPreview:
        'Zostanie pobrana partia {{batch}}, ważna do {{expiry}}',
      batchNoneAvailable: 'Brak ważnej partii na stanie',
      batchOption:
        'Partia {{batch}}, ważna do {{expiry}}, na stanie {{quantity}}',
      batchOptionExpired:
        'Partia {{batch}}, ważna do {{expiry}} (przeterminowana)',
      batchOptionEmpty:
        'Partia {{batch}}, ważna do {{expiry}} (brak na stanie)',
      batchOptionMissing: 'Wybrana wcześniej partia (niedostępna)',
      batchPinUnusable:
        'Ta partia jest przeterminowana lub pusta, więc zmiana wydania może zostać odrzucona. Wybierz „Automatycznie”, aby pobrać partię o najkrótszej ważności.',
      shortage:
        'Na stanie jest {{available}}, a pobierasz {{requested}}. Zapis pozostawi stan ujemny.',
      requestDemand: 'Zgłoś zapotrzebowanie',
      rowStock: 'Z magazynu: {{quantity}} {{measure}}, {{handover}}',
      rowStockAdministered: 'podany w placówce',
      rowStockHandedOver: 'wydany opiekunowi',
      materials: 'Materiały',
      materialsEmpty: 'Brak materiałów',
      materialAdd: 'Dodaj materiał',
      materialRemove: 'Usuń materiał',
      visitWriteNeedsClinic:
        'Zabiegi wizyty zapisuje placówka. Wybierz placówkę i spróbuj ponownie.',
      blockHeader: 'Z magazynu: {{product}} · Stan: {{stock}}',
      optOut: 'Nie pobieraj z magazynu',
      optedOut: 'Lek nie zostanie pobrany z magazynu.',
      optedOutSaved: 'Wydanie zostanie cofnięte przy zapisie.',
      optBackIn: 'Pobierz jednak',
      summaryStock: '{{quantity}} {{measure}}, {{handover}}, partia {{batch}}',
      summaryStockPrescription:
        '{{quantity}} {{measure}}, {{handover}}, partia {{batch}}, recepta: {{prescription}}',
      summaryPrescriptionIssued: 'wystawiona',
      summaryPrescriptionNotIssued: 'niewystawiona',
      summaryPrescriptionMissing: 'do uzupełnienia w kroku Magazyn',
      summaryHandoverMissing: 'sposób wydania: do uzupełnienia w kroku Magazyn',
      summaryStockNoQuantity: '{{handover}}, partia {{batch}}',
      summaryBatchAuto: 'automatycznie',
      summaryBatchPinned: 'wybrana ręcznie',
      summaryReversal: 'Wydanie z magazynu zostanie cofnięte.',
      assumptions: 'Założenia: sprawdź przed zapisem',
      issueDose: 'Jedno podanie: {{dose}}',
      issueDoseRounded: 'Jedno podanie: {{dose}} → {{total}}',
      issueDosePackages:
        'Jedno podanie: {{dose}} → {{packages}} ({{packageContent}})',
      issueCourse:
        'Kuracja {{dose}} {{frequency}} przez {{duration}} = {{total}}',
      issueCoursePackages:
        'Kuracja {{dose}} {{frequency}} przez {{duration}} = {{total}} → {{packages}} ({{packageContent}})',
      issueFrequency: {
        TIMES_PER_DAY: '× {{n}} dziennie',
        EVERY_N_HOURS: 'co {{n}} godz.',
        EVERY_N_DAYS: 'co {{days}}',
        TIMES_PER_WEEK: '× {{n}} w tygodniu',
        TIMES_PER_MONTH: '× {{n}} w miesiącu',
      },
      issueDays: { one: 'dzień', few: 'dni', many: 'dni', fraction: 'dnia' },
      issueWeeks: {
        one: 'tydzień',
        few: 'tygodnie',
        many: 'tygodni',
        fraction: 'tygodnia',
      },
      issueNotComputable:
        'Nie da się policzyć ilości z dawkowania. Wpisz, ile pobrać.',
    },
    medicineSearch: {
      groupWarehouse: 'W magazynie',
      groupRegistry: 'Rejestr leków',
      stock: 'Stan: {{quantity}}',
      expiry: 'ważn. do {{date}}',
      belowMinimum: 'poniżej minimum',
      controlled: 'kontrolowany',
      human: 'Ludzki',
      humanHint:
        'Lek zarejestrowany dla ludzi. U zwierzęcia stosuje się go tylko wtedy, gdy brak odpowiedniego leku weterynaryjnego (kaskada).',
      veterinary: 'Weterynaryjny',
      veterinaryHint: 'Lek weterynaryjny, zarejestrowany do stosowania u zwierząt.',
    },
    medicineStock: {
      title: 'W naszym magazynie',
      stock: 'Stan: {{quantity}}',
      minimum: 'Minimum: {{quantity}}',
      batch: 'Partia {{batch}} · ważna do {{expiry}} · {{quantity}}',
      nextOut: 'wyjdzie jako następna',
      nextOutHint:
        'Tę partię system wyda jako pierwszą, bo ma najkrótszą ważność spośród nieprzeterminowanych partii na stanie. Jeśli podajesz inną, wskaż ją ręcznie.',
      expired: 'przeterminowana',
      expiredHint:
        'Partia jest przeterminowana i nie zostanie wydana. Można ją tylko spisać korektą w magazynie.',
      noBatches: 'Brak partii na stanie.',
      loadError: 'Nie udało się wczytać stanu magazynu.',
      notInWarehouse: 'Nie znaleźliśmy tego leku w magazynie placówki.',
      requestDemand: 'Zgłoś zapotrzebowanie',
    },
    demand: {
      actions: {
        request: 'Zgłoś zapotrzebowanie',
        markOrdered: 'Zamówione',
        markOrderedHint: 'Oznacz jako zamówione',
        close: 'Zamknij',
        closeHint: 'Zamknij bez przyjęcia towaru. Stan magazynu się nie zmieni.',
        receiveHint: 'Przyjmij towar dokumentem PZ',
        unlinkHint: 'Odepnij produkt z katalogu',
      },
      filter: {
        label: 'Status',
        ALL: 'Wszystkie',
        OPEN: 'Otwarte',
        ORDERED: 'Zamówione',
        CLOSED: 'Zamknięte',
      },
      status: {
        OPEN: 'Otwarte',
        ORDERED: 'Zamówione',
        CLOSED: 'Zamknięte',
      },
      statusHints: {
        OPEN: 'Zgłoszone i czeka na zamówienie. Administrator lub właściciel placówki oznaczy je jako zamówione albo zamknie.',
        ORDERED:
          'Produkt zamówiono i czeka na dostawę. Przyjęcie go dokumentem PZ zamknie zapotrzebowanie automatycznie.',
        CLOSED:
          'Zapotrzebowanie zamknięte: towar przyjęto dokumentem PZ albo zamknięto je ręcznie. Nic więcej nie trzeba robić.',
      },
      table: {
        product: 'Produkt',
        quantity: 'Ilość',
        note: 'Uwagi',
        requestedBy: 'Zgłoszenie',
        status: 'Status',
        actions: 'Akcje',
        source: 'Rodzaj',
        fromCatalogue: 'Z magazynu',
        fromCatalogueHint:
          'Produkt z katalogu magazynu. Zapotrzebowanie zamknie się samo po przyjęciu go dokumentem PZ.',
        outsideCatalogue: 'Spoza magazynu',
        outsideCatalogueHint:
          'Produktu nie ma w katalogu magazynu, zgłoszono go samą nazwą. Samo się nie zamknie. Gdy jest zamówione, przyjmij je dokumentem PZ z tej listy: wybierzesz albo dodasz produkt w katalogu, a zatwierdzenie PZ je zamknie. Możesz je też zamknąć ręcznie.',
        closedByDocument: 'Zamknięte przyjęciem {{number}}',
        requestedAs: 'Zgłoszono jako: {{name}}',
        changedBy: 'Zmiana: {{name}}',
        empty: 'Brak zapotrzebowań',
      },
      form: {
        title: 'Zgłoś zapotrzebowanie',
        addProduct: 'Dodaj produkt',
        info: {
          addProduct:
            'Wybierz produkt z magazynu albo wpisz nazwę produktu spoza magazynu. Zapotrzebowanie na produkt z magazynu zamknie się samo po przyjęciu go dokumentem PZ; produkt spoza magazynu trzeba zamknąć ręcznie.',
        },
        addOutsideProduct: 'Dodaj „{{name}}” jako produkt spoza magazynu',
        removeLine: 'Usuń pozycję',
        quantityShort: 'Ilość',
        measure: 'Liczone w',
        note: 'Uwagi (opcjonalnie)',
        noLines: 'Dodaj co najmniej jeden produkt.',
        maxLines: 'Zgłoszenie może mieć najwyżej 50 pozycji.',
        submit: 'Zgłoś',
        retrySubmit: 'Ponów zapis',
        unconfirmedSave:
          'Nie wiemy, czy zapotrzebowanie zostało zapisane. Ponów zapis: nie zostanie zgłoszone dwa razy.',
      },
      validation: {
        nameRequired: 'Podaj nazwę produktu',
        nameTooLong: 'Nazwa może mieć maksymalnie 120 znaków',
        quantityInvalid:
          'Podaj liczbę większą od zera (maks. 3 miejsca po przecinku)',
        noteTooLong: 'Uwagi mogą mieć maksymalnie 500 znaków',
      },
      snackbar: {
        createdBatch: 'Zgłoszono zapotrzebowanie: {{count}} poz.',
        statusChanged: 'Zmieniono status zapotrzebowania',
        unlinked: 'Odpięto produkt od zapotrzebowania',
      },
      unlink: {
        title: 'Odpiąć produkt?',
        body: 'Zapotrzebowanie wróci do pozycji spoza magazynu „{{name}}”.',
        confirm: 'Odepnij',
      },
      link: {
        title: 'Wybierz produkt',
        product: 'Produkt z katalogu',
        helper: 'Wybierz produkt z katalogu albo dodaj nowy.',
      },
    },
    recordCard: {
      button: 'Karta ewidencji (PDF)',
      dialogTitle: 'Karta ewidencji',
      from: 'Od dnia',
      to: 'Do dnia',
      thisYear: 'Bieżący rok',
      previousYear: 'Poprzedni rok',
      period: 'Okres',
      customRange: 'Własny zakres',
      download: 'Pobierz PDF',
      cancel: 'Anuluj',
      rangeInvalid: 'Data początkowa nie może być późniejsza niż data końcowa.',
      generateError: 'Nie udało się wygenerować karty ewidencji.',
      generating: 'Generuję kartę ewidencji…',
      rxNote:
        'Lek na receptę (Rx): karta ewidencji jest obowiązkowa. Drukuj ją i przechowuj wydruki przez 5 lat.',
      nonRxNote:
        'Lek bez oznaczenia Rx: karta ewidencji nie jest dla niego obowiązkowa, ale możesz ją wydrukować.',
      controlledNote:
        'Lek kontrolowany ({{category}}): książkę kontroli nadal prowadzisz w wersji papierowej.',
      pdf: {
        title:
          'Dokumentacja obrotu detalicznego produktami leczniczymi weterynaryjnymi',
        cardNumber: 'Nr karty/rok',
        period: 'Okres',
        clinic: 'Nazwa i adres zakładu leczniczego dla zwierząt',
        productName: 'Nazwa produktu leczniczego weterynaryjnego',
        maHolder: 'Nazwa podmiotu odpowiedzialnego',
        maNumber: 'Numer pozwolenia na dopuszczenie do obrotu',
        form: 'Postać farmaceutyczna',
        strength: 'Moc',
        packType: 'Rodzaj opakowania',
        packContent: '{{count}} {{unit}} w opakowaniu',
        withdrawal: 'Okres karencji',
        availability: 'Kategoria dostępności',
        rx: 'Rp: wydawany na receptę',
        otc: 'OTC: wydawany bez recepty',
        notProvided: 'nie podano',
        columns: {
          lp: 'Lp.',
          date: 'Data',
          operation: 'Operacja',
          party: 'Dostawca / odbiorca (adres)',
          document: 'Nr dokumentu',
          batch: 'Nr serii',
          expiry: 'Ważność',
          incoming: 'Przyjęto',
          outgoing: 'Zużyto / wydano',
          balance: 'Stan po',
          clinicalRef: 'Poz. w dokumentacji lek.-wet.',
          prescriber: 'Lekarz',
          prescription: 'Recepta',
        },
        types: {
          OPENING: 'Stan początkowy',
          RECEIPT: 'Przyjęcie',
          USAGE: 'Zużycie',
          SALE: 'Sprzedaż',
          ADJUSTMENT: 'Korekta stanu',
        },
        handover: {
          ADMINISTERED: 'podany w placówce',
          HANDED_OVER: 'wydany opiekunowi',
        },
        prescription: {
          issued: 'Rp wystawiona',
          notIssued: 'recepty nie wystawiono',
          realisedAtFacility: 'zrealizowana w lecznicy',
        },
        correction: 'storno poz. {{lp}}',
        correctionOutside: 'storno wpisu z {{date}}',
        reversedOn: 'stornowano {{date}}',
        assignment: 'przypisanie partii do poz. {{lp}}',
        assignmentOutside: 'przypisanie partii do wpisu z {{date}}',
        assignedOn: 'partię wskazano {{date}}',
        repost: 'korekta wydania z {{date}}',
        assignmentRepost: 'przypisanie partii do wydania z {{date}}',
        recordedBy: 'wpisał(a): {{name}}, {{date}}',
        unknownBatch: 'seria nieznana',
        rowMaNumber: 'pozw. nr {{number}}',
        visitRef: '{{patient}}, wizyta {{date}}, nr {{id}}',
        patientRef: '{{patient}}, wpis nr {{id}}',
        invoice: 'FV {{number}}',
        packs: '{{count}} op. po {{size}} {{unit}}',
        quantity: '{{packages}} op. + {{units}} {{unit}}',
        packagesOnly: '{{packages}} op.',
        unitsOnly: '{{units}} {{unit}}',
        units: {
          TABLET: 'tabl.',
          CAPSULE: 'kaps.',
          BLISTER: 'blist.',
          ML: 'ml',
          G: 'g',
          PIECE: 'szt.',
          SACHET: 'sasz.',
          AMPOULE: 'amp.',
          VIAL: 'fiol.',
          PIPETTE: 'pip.',
          DOSE: 'dawk.',
          OTHER: 'jedn.',
        },
        opening: 'Stan na początek okresu',
        closing: 'Stan na koniec okresu',
        withoutBatch: 'Wydania bez partii w okresie: {{count}}',
        batchBalances: 'Stany według serii',
        batchColumn: 'Seria',
        expiryColumn: 'Ważność',
        openingColumn: 'Stan początkowy',
        closingColumn: 'Stan końcowy',
        noRows: 'Brak ruchów w wybranym okresie.',
        generated: 'Wygenerowano w systemie Vetsi Clinic {{date}}',
        legalFooter:
          'Dokumentacja prowadzona w formie elektronicznej. Wydruk przechowuj przez 5 lat (§ 2 ust. 3 rozporządzenia MRiRW z 17.10.2008 r.).',
        signature: 'Data i podpis lekarza weterynarii',
        page: 'Strona {{page}} z {{total}}',
        fileName: 'Karta ewidencji',
      },
      recipients: {
        button: 'Kto dostał tę partię',
        title: 'Kto dostał partię {{batch}}',
        subtitle: '{{product}} · ważność {{expiry}}',
        empty: 'Z tej partii nic jeszcze nie wydano.',
        loadError: 'Nie udało się pobrać listy odbiorców.',
        close: 'Zamknij',
        sale: 'sprzedaż',
        assignedLater: 'partię wskazano {{date}}',
        columns: {
          date: 'Data',
          patient: 'Pacjent',
          visit: 'Wizyta',
          quantity: 'Ilość',
          handover: 'Sposób wydania',
          recipient: 'Odbiorca',
          prescriber: 'Lekarz',
          document: 'Dokument',
        },
      },
    },
  },
  webinar: {
    common: {
      loading: 'Ładowanie…',
      loadError: 'Nie udało się pobrać danych webinaru.',
      actionError: 'Nie udało się wykonać działania. Spróbuj ponownie.',
      retry: 'Spróbuj ponownie',
      refresh: 'Odśwież',
      done: 'Gotowe.',
    },
    adminRedirect: {
      unavailableTitle: 'Panel webinarów jest niedostępny',
      unavailableDescription:
        'Webinarami zarządza się w panelu administratora, ale jego adres nie jest skonfigurowany w tym środowisku.',
    },
    status: {
      DRAFT: 'Szkic',
      PUBLISHED: 'Opublikowany',
      REHEARSAL: 'Trwa próba',
      PREPARATION: 'Przygotowanie ekipy',
      OPEN: 'Pokój otwarty',
      ENDED: 'Zakończony',
      CANCELLED: 'Odwołany',
    },
    list: {
      title: 'Webinary',
      create: 'Nowy webinar',
      upcomingLabel: 'Nadchodzące webinary',
      pastLabel: 'Minione webinary',
      past: 'Minione ({{count}})',
      seats: '{{count}} z {{capacity}}',
      places: 'Miejsca: {{capacity}}',
      noPresenters: 'Brak prowadzących',
      presenterCount: 'Prowadzący: {{count}}',
      noUpcoming: 'Brak nadchodzących webinarów.',
      empty: 'Nie utworzono jeszcze żadnego webinaru.',
    },
    form: {
      createTitle: 'Nowy webinar',
      editTitle: 'Edytuj webinar',
      title: 'Tytuł',
      slug: 'Adres w linku',
      slugHint:
        'Małe litery, cyfry i myślniki. Po publikacji adresu nie można zmienić.',
      slugPreview: 'Strona zapisów: {{address}}',
      changeSlug: 'Zmień',
      changeSlugLabel: 'Zmień adres strony zapisów',
      description: 'Opis',
      startsAt: 'Data i godzina rozpoczęcia',
      durationMinutes: 'Czas trwania',
      minutes: 'min',
      capacity: 'Liczba miejsc',
      capacityHint: 'Prowadzący nie zajmują miejsc.',
      publishedNotice:
        'Zmiana tytułu, opisu, terminu lub czasu trwania wyśle zapisanym uczestnikom wiadomość.',
      create: 'Utwórz szkic',
      save: 'Zapisz zmiany',
      created: 'Utworzono szkic webinaru.',
      saved: 'Zapisano zmiany.',
      validation: {
        titleRequired: 'Podaj tytuł',
        slugRequired: 'Podaj adres strony zapisów',
        slugFormat: 'Użyj małych liter, cyfr i pojedynczych myślników',
        startsAtRequired: 'Podaj termin',
        startsAtFuture: 'Termin musi być w przyszłości',
        durationRange: 'Podaj od 1 do 1440 minut',
        capacityMin: 'Podaj co najmniej 1 miejsce',
        tooLong: 'Tekst jest za długi',
      },
    },
    detail: {
      back: 'Webinary',
      duration: '{{minutes}} min',
      sections: 'Sekcje webinaru',
      presenterLink: 'Wejście dla prowadzących',
      registrationLink: 'Strona zapisów',
      registrationAfterPublish: 'Dostępna po publikacji',
      registrationClosed: 'Niedostępna',
      copyLink: 'Kopiuj link: {{title}}',
      openLink: 'Otwórz: {{title}}',
      copied: 'Skopiowano link.',
      noDescription: 'Brak opisu.',
      notFound: 'Nie znaleziono webinaru.',
      rehearsalNote:
        'Trwa próba. Prowadzący mogą wejść do pokoju, a uczestnicy czekają na otwarcie.',
      liveNote: 'Webinar trwa. Zapisy są zamknięte.',
      provisioningNote:
        'Otwarcie pokoju nie zostało potwierdzone. Ponów otwarcie, aby uzgodnić jego stan. Do tego czasu nie wyłączaj serwera.',
      endingNote:
        'Zamknięcie pokoju nie zostało potwierdzone. Zakończ go ponownie. Do tego czasu nie wyłączaj serwera.',
    },
    actions: {
      edit: 'Edytuj',
      publish: 'Publikuj',
      rehearsal: 'Rozpocznij próbę',
      open: 'Otwórz dla uczestników',
      endRehearsal: 'Zakończ próbę',
      end: 'Zakończ webinar',
      cancel: 'Odwołaj webinar',
      delete: 'Usuń szkic',
      more: 'Więcej działań',
      confirm: {
        publish: {
          title: 'Opublikować webinar?',
          body: 'Webinar pojawi się na stronie Vetsi Clinic i otworzą się zapisy.',
        },
        rehearsal: {
          title: 'Rozpocząć próbę?',
          body: 'Pokój otworzy się tylko dla prowadzących. Uczestnicy poczekają na otwarcie webinaru. Jednocześnie może trwać tylko jeden webinar lub próba.',
        },
        open: {
          title: 'Otworzyć webinar dla uczestników?',
          body: 'Zapisy zostaną zamknięte, a zapisani uczestnicy wejdą do pokoju. Jednocześnie może trwać tylko jeden webinar lub próba.',
        },
        endRehearsal: {
          title: 'Zakończyć próbę?',
          body: 'Pokój zostanie zamknięty. Webinar pozostanie opublikowany.',
        },
        end: {
          title: 'Zakończyć webinar?',
          body: 'Wszyscy zostaną rozłączeni, a pokój zamknięty. Nagranie, jeśli było włączone, pojawi się na liście nagrań.',
        },
        cancel: {
          title: 'Odwołać webinar?',
          body: 'Zapisani uczestnicy dostaną wiadomość o odwołaniu. Tej operacji nie można cofnąć.',
        },
        delete: {
          title: 'Usunąć szkic?',
          body: 'Szkic zostanie trwale usunięty.',
        },
      },
    },
    presenters: {
      title: 'Prowadzący',
      email: 'E-mail konta Vetsi',
      add: 'Dodaj',
      remove: 'Usuń prowadzącego {{name}}',
      empty:
        'Dodaj co najmniej jednego prowadzącego. Bez tego nie opublikujesz webinaru.',
      notFound:
        'Nie znaleziono aktywnego konta z tym adresem. Prowadzący musi najpierw założyć konto Vetsi.',
      duplicate: 'To konto jest już prowadzącym.',
      invalidEmail: 'Podaj poprawny adres e-mail',
      locked:
        'Prowadzących można zmieniać przed otwarciem webinaru i poza trwającą próbą.',
      unknown: 'Konto Vetsi',
      saved: 'Zapisano prowadzących.',
    },
    registrations: {
      title: 'Zapisani',
      tableLabel: 'Zapisani uczestnicy',
      search: 'Szukaj zapisanych',
      searchPlaceholder: 'Szukaj po nazwisku, e-mailu lub placówce',
      noResults: 'Brak wyników.',
      columns: {
        name: 'Imię i nazwisko',
        email: 'E-mail',
        profession: 'Zawód',
        clinic: 'Placówka',
        mode: 'Udział',
        marketing: 'Zgoda marketingowa',
        createdAt: 'Zapisano',
        status: 'Stan',
        emails: 'E-maile',
        actions: 'Działania',
      },
      mode: {
        live: 'Na żywo',
        recording: 'Tylko nagranie',
      },
      requested: 'Wybrano: {{mode}}',
      marketing: {
        yes: 'Tak',
        no: 'Nie',
        pending: 'Niepotwierdzona',
        inactive: 'Nieaktywna',
      },
      status: {
        PENDING_SIGNUP: 'Czeka na potwierdzenie',
        CONFIRMED_SIGNUP: 'Potwierdzony',
        REVOKED_LINK: 'Unieważniony',
      },
      pendingUntil: 'Link ważny do {{date}}',
      pendingExpired: 'Link wygasł',
      confirmedAt: 'Potwierdzono {{date}}',
      email: {
        verification: 'Link potwierdzający',
        confirmation: 'Potwierdzenie zapisu',
        status: {
          NOT_QUEUED: 'Nie zlecono',
          QUEUED: 'W kolejce',
          SENDING: 'Wysyłanie',
          ACCEPTED: 'Przyjęta przez SMTP',
          UNCERTAIN: 'Wynik niepewny',
          FAILED: 'Nie wysłano',
          SUPPRESSED: 'Wstrzymana',
        },
        hint: {
          NOT_QUEUED: 'Ta wiadomość nie została zlecona.',
          QUEUED: 'Wiadomość czeka w kolejce wysyłki.',
          SENDING: 'Trwa wysyłka wiadomości.',
          ACCEPTED:
            'Serwer pocztowy przyjął wiadomość. To nie oznacza dostarczenia do skrzynki ani potwierdzenia adresu.',
          UNCERTAIN: 'Nie wiadomo, czy serwer pocztowy przyjął wiadomość.',
          FAILED: 'Wysyłka się nie udała.',
          SUPPRESSED:
            'Wiadomość nie została wysłana, bo przestała być aktualna.',
        },
        attempts: 'Próby: {{count}}. Ostatnia: {{date}}.',
      },
      resendVerification: 'Wyślij ponownie link potwierdzający do {{name}}',
      resendConfirmation: 'Wyślij ponownie potwierdzenie zapisu do {{name}}',
      resendAvailableAt: 'Ponowna wysyłka będzie możliwa {{date}}',
      resendUnavailable: 'Ponowna wysyłka jest teraz niedostępna',
      resendDone: 'Wiadomość dodano do kolejki wysyłki.',
      revoke: 'Unieważnij link uczestnika {{name}}',
      revokeRecording: 'Unieważnij zapis po nagranie uczestnika {{name}}',
      revokePending: 'Unieważnij zgłoszenie uczestnika {{name}}',
      revokeAction: 'Unieważnij',
      revokeConfirm: {
        title: 'Unieważnić link?',
        titleRecording: 'Unieważnić zapis?',
        titlePending: 'Unieważnić zgłoszenie?',
        body: 'Osobisty link uczestnika {{name}} przestanie działać. Jeśli uczestnik jest w pokoju, zostanie z niego usunięty, a jego miejsce się zwolni.',
        bodyRecording: 'Zapis uczestnika {{name}} tylko po nagranie zostanie unieważniony. Ten zapis nie zajmował miejsca na żywo.',
        bodyPending: 'Zgłoszenie uczestnika {{name}} czeka na potwierdzenie adresu e-mail i nie zajmuje miejsca. Po unieważnieniu link potwierdzający przestanie działać.',
      },
      revokedDone: 'Link został unieważniony.',
      empty: 'Nikt jeszcze się nie zapisał.',
    },
    recordings: {
      title: 'Nagrania',
      privacy: 'Nagrania są prywatne. Pobiera je i usuwa tylko administrator.',
      tableLabel: 'Lista nagrań',
      columns: {
        uploadedAt: 'Zapisano',
        size: 'Rozmiar',
        status: 'Stan',
        actions: 'Działania',
      },
      status: {
        PENDING: 'Zapisywanie',
        AVAILABLE: 'Gotowe',
        DELETING: 'Usuwanie',
        DELETED: 'Usunięte',
        FAILED: 'Nie zapisano',
      },
      failedNotice:
        'Dla nagrań ze stanem „Nie zapisano” serwer nie utworzył pliku, więc nie ma czego pobrać.',
      download: 'Pobierz nagranie',
      downloadStarted: 'Rozpoczęto pobieranie nagrania.',
      delete: 'Usuń nagranie',
      deleteConfirm: {
        title: 'Usunąć nagranie?',
        body: 'Plik zostanie trwale usunięty z prywatnego magazynu.',
      },
      deleted: 'Nagranie zostało usunięte.',
      empty: 'Brak nagrań tego webinaru.',
    },
    readiness: {
      safe: 'Serwer webinarów można wyłączyć.',
      unsafe: 'Nie wyłączaj serwera webinarów.',
      details: 'Szczegóły',
      loadError: 'Nie udało się sprawdzić stanu serwera webinarów.',
      activeSession: 'Otwarta sesja tego webinaru',
      pendingRecordings: 'Nagrania w trakcie zapisu lub usuwania',
      unresolvedNotifications: 'Wiadomości e-mail do sprawdzenia',
      yes: 'Tak',
      no: 'Nie',
    },
    presenterEntry: {
      title: 'Prowadzone webinary',
      description: 'Tu wejdziesz do pokoju webinaru jako prowadzący.',
      empty:
        'Nie masz przypisanych webinarów. Jeśli organizator dodał Cię jako prowadzącego, sprawdź, czy logujesz się na właściwe konto.',
      join: 'Wejdź do pokoju',
      waiting:
        'Pokój nie jest jeszcze otwarty. Organizator może wcześniej uruchomić próbę. Pokój na żywo dla ekipy może otworzyć najwcześniej {{crewDate}}, 30 minut przed rozpoczęciem webinaru, a uczestników wpuszcza od {{date}}, 15 minut przed rozpoczęciem.',
      blocked: 'Nie udało się bezpiecznie połączyć z pokojem webinaru.',
      rehearsalHint:
        'Przed webinarem organizator może uruchomić próbę albo, od 30 minut przed rozpoczęciem, otworzyć pokój na żywo dla ekipy. Wchodzisz do nich tutaj, tak jak na webinar. Zapisani uczestnicy nie mają dostępu do próby, a do pokoju na żywo wchodzą dopiero, gdy organizator ich wpuści.',
    },
  },
} as const;

export default translations;
